/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AppRouteImport } from "./routes/_app";
import { Route as ForgotPasswordRouteImport } from "./routes/forgot-password";
import { Route as HandheldRouteImport } from "./routes/handheld";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as AppAbbreviationsRouteImport } from "./routes/_app/abbreviations";
import { Route as AppDashboardRouteImport } from "./routes/_app/dashboard";
import { Route as AppHomeRouteImport } from "./routes/_app/home";
import { Route as AppQcDashboardRouteImport } from "./routes/_app/qc-dashboard";
import { Route as AppIndexRouteImport } from "./routes/app/index";
import { Route as InviteTokenRouteImport } from "./routes/invite.$token";
import { Route as KioskPackingRouteImport } from "./routes/kiosk/packing";
import { Route as AppAccountPasswordRouteImport } from "./routes/_app/account/password";
import { Route as AppAccountProfileRouteImport } from "./routes/_app/account/profile";
import { Route as AppAdminAuditLogRouteImport } from "./routes/_app/admin/audit-log";
import { Route as AppAdminIntegrationsRouteImport } from "./routes/_app/admin/integrations";
import { Route as AppAdminRolesRouteImport } from "./routes/_app/admin/roles";
import { Route as AppAdminUsersRouteImport } from "./routes/_app/admin/users";
import { Route as AppArrivalsIndexRouteImport } from "./routes/_app/arrivals/index";
import { Route as AppDevTokensRouteImport } from "./routes/_app/dev.tokens";
import { Route as AppDispatchBarcodeLookupRouteImport } from "./routes/_app/dispatch/barcode-lookup";
import { Route as AppDryerIndexRouteImport } from "./routes/_app/dryer/index";
import { Route as AppFeedbackIndexRouteImport } from "./routes/_app/feedback/index";
import { Route as AppFeedbackIdRouteImport } from "./routes/_app/feedback/$id";
import { Route as AppFeedbackNewRouteImport } from "./routes/_app/feedback/new";
import { Route as AppGateIndexRouteImport } from "./routes/_app/gate/index";
import { Route as AppInventoryIndexRouteImport } from "./routes/_app/inventory/index";
import { Route as AppInventoryOpeningRouteImport } from "./routes/_app/inventory/opening";
import { Route as AppInventoryReconciliationRouteImport } from "./routes/_app/inventory/reconciliation";
import { Route as AppInventoryReportsRouteImport } from "./routes/_app/inventory/reports";
import { Route as AppInventoryReservationsRouteImport } from "./routes/_app/inventory/reservations";
import { Route as AppMastersKeyRouteImport } from "./routes/_app/masters/$key";
import { Route as AppMastersApiFeedRouteImport } from "./routes/_app/masters/api-feed";
import { Route as AppMastersGotFarmersRouteImport } from "./routes/_app/masters/got-farmers";
import { Route as AppMastersGotLocationsRouteImport } from "./routes/_app/masters/got-locations";
import { Route as AppMastersGotPpnStandardsRouteImport } from "./routes/_app/masters/got-ppn-standards";
import { Route as AppMastersLocationsRouteImport } from "./routes/_app/masters/locations";
import { Route as AppMastersMailSettingsRouteImport } from "./routes/_app/masters/mail-settings";
import { Route as AppMastersProductionPersonnelRouteImport } from "./routes/_app/masters/production-personnel";
import { Route as AppMastersStorageRestrictionsRouteImport } from "./routes/_app/masters/storage-restrictions";
import { Route as AppOrdersIndexRouteImport } from "./routes/_app/orders/index";
import { Route as AppOrdersIdRouteImport } from "./routes/_app/orders/$id";
import { Route as AppOrdersHoldsRouteImport } from "./routes/_app/orders/holds";
import { Route as AppOrdersImportRouteImport } from "./routes/_app/orders/import";
import { Route as AppOrdersNewRouteImport } from "./routes/_app/orders/new";
import { Route as AppOrdersStatusRouteImport } from "./routes/_app/orders/status";
import { Route as AppQualityIndexRouteImport } from "./routes/_app/quality/index";
import { Route as AppReportsIndexRouteImport } from "./routes/_app/reports/index";
import { Route as AppReportsHighMoistureRouteImport } from "./routes/_app/reports/high-moisture";
import { Route as AppReportsVarietyDecodingRouteImport } from "./routes/_app/reports/variety-decoding";
import { Route as AppStoresIndexRouteImport } from "./routes/_app/stores/index";
import { Route as AppStoresCaptiveRouteImport } from "./routes/_app/stores/captive";
import { Route as AppStoresDiscardRouteImport } from "./routes/_app/stores/discard";
import { Route as AppStoresOpeningRouteImport } from "./routes/_app/stores/opening";
import { Route as AppStoresReorderRouteImport } from "./routes/_app/stores/reorder";
import { Route as AppStoresUtilityRouteImport } from "./routes/_app/stores/utility";
import { Route as AppWarehouseIndexRouteImport } from "./routes/_app/warehouse/index";
import { Route as AppWarehouseSlocRouteImport } from "./routes/_app/warehouse/sloc";
import { Route as AppAdminUsersUserIdRouteImport } from "./routes/_app/admin/users_.$userId";
import { Route as AppArrivalsFormIndexRouteImport } from "./routes/_app/arrivals/$form/index";
import { Route as AppArrivalsFormIdRouteImport } from "./routes/_app/arrivals/$form/$id";
import { Route as AppArrivalsFormNewRouteImport } from "./routes/_app/arrivals/$form/new";
import { Route as AppArrivalsPpAppearanceIndexRouteImport } from "./routes/_app/arrivals/pp-appearance/index";
import { Route as AppArrivalsPpAppearanceSampleIdRouteImport } from "./routes/_app/arrivals/pp-appearance/$sampleId";
import { Route as AppArrivalsTradingIndexRouteImport } from "./routes/_app/arrivals/trading/index";
import { Route as AppArrivalsTradingIdRouteImport } from "./routes/_app/arrivals/trading/$id";
import { Route as AppArrivalsTradingNewRouteImport } from "./routes/_app/arrivals/trading/new";
import { Route as AppDispatchStockTransferIndexRouteImport } from "./routes/_app/dispatch/stock-transfer/index";
import { Route as AppDispatchStockTransferIdRouteImport } from "./routes/_app/dispatch/stock-transfer/$id";
import { Route as AppDispatchStockTransferNewRouteImport } from "./routes/_app/dispatch/stock-transfer/new";
import { Route as AppDryerStageIdRouteImport } from "./routes/_app/dryer/$stage.$id";
import { Route as AppGatePassInIdRouteImport } from "./routes/_app/gate/pass-in/$id";
import { Route as AppGatePassInNewRouteImport } from "./routes/_app/gate/pass-in/new";
import { Route as AppInventoryLotsIndexRouteImport } from "./routes/_app/inventory/lots/index";
import { Route as AppInventoryLotsLotIdRouteImport } from "./routes/_app/inventory/lots/$lotId";
import { Route as AppMastersVendorsIdRouteImport } from "./routes/_app/masters/vendors.$id";
import { Route as AppMastersVendorsNewRouteImport } from "./routes/_app/masters/vendors.new";
import { Route as AppPackagingFcPackingSlipIndexRouteImport } from "./routes/_app/packaging/fc-packing-slip/index";
import { Route as AppPackagingFcPackingSlipIdRouteImport } from "./routes/_app/packaging/fc-packing-slip/$id";
import { Route as AppPackagingFcPackingSlipNewRouteImport } from "./routes/_app/packaging/fc-packing-slip/new";
import { Route as AppPackagingIvtIndexRouteImport } from "./routes/_app/packaging/ivt/index";
import { Route as AppPackagingIvtIdRouteImport } from "./routes/_app/packaging/ivt/$id";
import { Route as AppPackagingIvtNewRouteImport } from "./routes/_app/packaging/ivt/new";
import { Route as AppPackagingOflIndexRouteImport } from "./routes/_app/packaging/ofl/index";
import { Route as AppPackagingOflIdRouteImport } from "./routes/_app/packaging/ofl/$id";
import { Route as AppPackagingOflNewRouteImport } from "./routes/_app/packaging/ofl/new";
import { Route as AppPackagingP2cIndexRouteImport } from "./routes/_app/packaging/p2c/index";
import { Route as AppPackagingP2cIdRouteImport } from "./routes/_app/packaging/p2c/$id";
import { Route as AppPackagingP2cNewRouteImport } from "./routes/_app/packaging/p2c/new";
import { Route as AppPackagingPackReprintIndexRouteImport } from "./routes/_app/packaging/pack-reprint/index";
import { Route as AppPackagingPackReprintIdRouteImport } from "./routes/_app/packaging/pack-reprint/$id";
import { Route as AppPackagingPackReprintNewRouteImport } from "./routes/_app/packaging/pack-reprint/new";
import { Route as AppPackagingPackingSlipIndexRouteImport } from "./routes/_app/packaging/packing-slip/index";
import { Route as AppPackagingPackingSlipIdRouteImport } from "./routes/_app/packaging/packing-slip/$id";
import { Route as AppPackagingPackingSlipNewRouteImport } from "./routes/_app/packaging/packing-slip/new";
import { Route as AppPackagingPnpFcSlipIndexRouteImport } from "./routes/_app/packaging/pnp-fc-slip/index";
import { Route as AppPackagingPnpFcSlipIdRouteImport } from "./routes/_app/packaging/pnp-fc-slip/$id";
import { Route as AppPackagingPnpSlipIndexRouteImport } from "./routes/_app/packaging/pnp-slip/index";
import { Route as AppPackagingReprintSlipIndexRouteImport } from "./routes/_app/packaging/reprint-slip/index";
import { Route as AppPackagingReprintSlipIdRouteImport } from "./routes/_app/packaging/reprint-slip/$id";
import { Route as AppPackagingReprintSlipNewRouteImport } from "./routes/_app/packaging/reprint-slip/new";
import { Route as AppPackagingRootStockCountIndexRouteImport } from "./routes/_app/packaging/root-stock-count/index";
import { Route as AppPackagingSathiIndexRouteImport } from "./routes/_app/packaging/sathi/index";
import { Route as AppPackagingStoreIndentsIndexRouteImport } from "./routes/_app/packaging/store-indents/index";
import { Route as AppPackagingStoreIndentsIdRouteImport } from "./routes/_app/packaging/store-indents/$id";
import { Route as AppPackagingStoreIndentsNewRouteImport } from "./routes/_app/packaging/store-indents/new";
import { Route as AppPackagingUnpackagingIndexRouteImport } from "./routes/_app/packaging/unpackaging/index";
import { Route as AppPackagingWbPackingSlipIndexRouteImport } from "./routes/_app/packaging/wb-packing-slip/index";
import { Route as AppPackagingWbPackingSlipIdRouteImport } from "./routes/_app/packaging/wb-packing-slip/$id";
import { Route as AppPackagingWbPackingSlipNewRouteImport } from "./routes/_app/packaging/wb-packing-slip/new";
import { Route as AppProcessingBlendingIndexRouteImport } from "./routes/_app/processing/blending/index";
import { Route as AppProcessingBlendingIdRouteImport } from "./routes/_app/processing/blending/$id";
import { Route as AppProcessingBlendingNewRouteImport } from "./routes/_app/processing/blending/new";
import { Route as AppProcessingColorSortIndexRouteImport } from "./routes/_app/processing/color-sort/index";
import { Route as AppProcessingColorSortIdRouteImport } from "./routes/_app/processing/color-sort/$id";
import { Route as AppProcessingColorSortNewRouteImport } from "./routes/_app/processing/color-sort/new";
import { Route as AppProcessingDryingIndexRouteImport } from "./routes/_app/processing/drying/index";
import { Route as AppProcessingDryingIdRouteImport } from "./routes/_app/processing/drying/$id";
import { Route as AppProcessingDryingNewRouteImport } from "./routes/_app/processing/drying/new";
import { Route as AppProcessingPackingSlipIndexRouteImport } from "./routes/_app/processing/packing-slip/index";
import { Route as AppProcessingPackingSlipIdRouteImport } from "./routes/_app/processing/packing-slip/$id";
import { Route as AppProcessingPackingSlipNewRouteImport } from "./routes/_app/processing/packing-slip/new";
import { Route as AppProcessingPnpFcSlipIndexRouteImport } from "./routes/_app/processing/pnp-fc-slip/index";
import { Route as AppProcessingPnpFcSlipIdRouteImport } from "./routes/_app/processing/pnp-fc-slip/$id";
import { Route as AppProcessingPnpFcSlipNewRouteImport } from "./routes/_app/processing/pnp-fc-slip/new";
import { Route as AppProcessingPrimingIndexRouteImport } from "./routes/_app/processing/priming/index";
import { Route as AppProcessingPrimingIdRouteImport } from "./routes/_app/processing/priming/$id";
import { Route as AppProcessingPrimingNewRouteImport } from "./routes/_app/processing/priming/new";
import { Route as AppProcessingReportsIndexRouteImport } from "./routes/_app/processing/reports/index";
import { Route as AppProcessingReportsKeyRouteImport } from "./routes/_app/processing/reports/$key";
import { Route as AppProcessingSlipIndexRouteImport } from "./routes/_app/processing/slip/index";
import { Route as AppProcessingSlipIdRouteImport } from "./routes/_app/processing/slip/$id";
import { Route as AppProcessingSlipNewRouteImport } from "./routes/_app/processing/slip/new";
import { Route as AppProcessingThermalIndexRouteImport } from "./routes/_app/processing/thermal/index";
import { Route as AppProcessingThermalIdRouteImport } from "./routes/_app/processing/thermal/$id";
import { Route as AppProcessingThermalNewRouteImport } from "./routes/_app/processing/thermal/new";
import { Route as AppProcessingTreatmentIndexRouteImport } from "./routes/_app/processing/treatment/index";
import { Route as AppProcessingTreatmentIdRouteImport } from "./routes/_app/processing/treatment/$id";
import { Route as AppProcessingTreatmentNewRouteImport } from "./routes/_app/processing/treatment/new";
import { Route as AppQualityAllocationIndexRouteImport } from "./routes/_app/quality/allocation/index";
import { Route as AppQualityAllocationSrfIdRouteImport } from "./routes/_app/quality/allocation/$srfId";
import { Route as AppQualityAllocationMonitorRouteImport } from "./routes/_app/quality/allocation/monitor";
import { Route as AppQualityAllocationSamplesRouteImport } from "./routes/_app/quality/allocation/samples";
import { Route as AppQualityBarcodeSearchIndexRouteImport } from "./routes/_app/quality/barcode-search/index";
import { Route as AppQualityBatchFinderIndexRouteImport } from "./routes/_app/quality/batch-finder/index";
import { Route as AppQualityBlendingIndexRouteImport } from "./routes/_app/quality/blending/index";
import { Route as AppQualityBlendingIdRouteImport } from "./routes/_app/quality/blending/$id";
import { Route as AppQualityDamagedSamplesIndexRouteImport } from "./routes/_app/quality/damaged-samples/index";
import { Route as AppQualityDensityIndexRouteImport } from "./routes/_app/quality/density/index";
import { Route as AppQualityDovCalculatorIndexRouteImport } from "./routes/_app/quality/dov-calculator/index";
import { Route as AppQualityGerminationIndexRouteImport } from "./routes/_app/quality/germination/index";
import { Route as AppQualityGerminationSampleIdRouteImport } from "./routes/_app/quality/germination/$sampleId";
import { Route as AppQualityGotBiographyRouteImport } from "./routes/_app/quality/got/biography";
import { Route as AppQualityGotDispatchRouteImport } from "./routes/_app/quality/got/dispatch";
import { Route as AppQualityGotLowPpnRouteImport } from "./routes/_app/quality/got/low-ppn";
import { Route as AppQualityGotPrintSampleRouteImport } from "./routes/_app/quality/got/print-sample";
import { Route as AppQualityGuardSamplesIndexRouteImport } from "./routes/_app/quality/guard-samples/index";
import { Route as AppQualityGuardSamplesMoveRouteImport } from "./routes/_app/quality/guard-samples/move";
import { Route as AppQualityMoistureIndexRouteImport } from "./routes/_app/quality/moisture/index";
import { Route as AppQualityMoistureSampleIdRouteImport } from "./routes/_app/quality/moisture/$sampleId";
import { Route as AppQualityPendingIndexRouteImport } from "./routes/_app/quality/pending/index";
import { Route as AppQualityPendingSampleIdRouteImport } from "./routes/_app/quality/pending/$sampleId";
import { Route as AppQualityPpIndexRouteImport } from "./routes/_app/quality/pp/index";
import { Route as AppQualityPpSampleIdRouteImport } from "./routes/_app/quality/pp/$sampleId";
import { Route as AppQualityQcAgeingIndexRouteImport } from "./routes/_app/quality/qc-ageing/index";
import { Route as AppQualityRequestsIndexRouteImport } from "./routes/_app/quality/requests/index";
import { Route as AppQualityRequestsRequestIdRouteImport } from "./routes/_app/quality/requests/$requestId";
import { Route as AppQualityRequestsNewRouteImport } from "./routes/_app/quality/requests/new";
import { Route as AppQualityRtSrfIndexRouteImport } from "./routes/_app/quality/rt-srf/index";
import { Route as AppQualityStandardsIndexRouteImport } from "./routes/_app/quality/standards/index";
import { Route as AppReportsArrivalIndexRouteImport } from "./routes/_app/reports/arrival/index";
import { Route as AppReportsArrivalSlugRouteImport } from "./routes/_app/reports/arrival/$slug";
import { Route as AppReportsCswIndexRouteImport } from "./routes/_app/reports/csw/index";
import { Route as AppReportsCswKeyRouteImport } from "./routes/_app/reports/csw/$key";
import { Route as AppReportsDispatchPeriodicalRouteImport } from "./routes/_app/reports/dispatch/periodical";
import { Route as AppReportsOrdersDispatchKeyRouteImport } from "./routes/_app/reports/orders-dispatch/$key";
import { Route as AppReportsPackagingIndexRouteImport } from "./routes/_app/reports/packaging/index";
import { Route as AppReportsPackagingSlugRouteImport } from "./routes/_app/reports/packaging/$slug";
import { Route as AppReportsQcSlugRouteImport } from "./routes/_app/reports/qc/$slug";
import { Route as AppReportsRswIndexRouteImport } from "./routes/_app/reports/rsw/index";
import { Route as AppReportsRswKeyRouteImport } from "./routes/_app/reports/rsw/$key";
import { Route as AppReportsStockIndexRouteImport } from "./routes/_app/reports/stock/index";
import { Route as AppReportsStockSlugRouteImport } from "./routes/_app/reports/stock/$slug";
import { Route as AppReportsWarehouseIndexRouteImport } from "./routes/_app/reports/warehouse/index";
import { Route as AppReportsWarehouseSlugRouteImport } from "./routes/_app/reports/warehouse/$slug";
import { Route as AppRndPrimingIndexRouteImport } from "./routes/_app/rnd/priming/index";
import { Route as AppStoresArrivalsIndexRouteImport } from "./routes/_app/stores/arrivals/index";
import { Route as AppStoresArrivalsIdRouteImport } from "./routes/_app/stores/arrivals/$id";
import { Route as AppStoresArrivalsNewRouteImport } from "./routes/_app/stores/arrivals/new";
import { Route as AppStoresCorrectionsIndexRouteImport } from "./routes/_app/stores/corrections/index";
import { Route as AppStoresCorrectionsNewRouteImport } from "./routes/_app/stores/corrections/new";
import { Route as AppStoresCountsIndexRouteImport } from "./routes/_app/stores/counts/index";
import { Route as AppStoresDocsIdRouteImport } from "./routes/_app/stores/docs/$id";
import { Route as AppStoresIndentsIndexRouteImport } from "./routes/_app/stores/indents/index";
import { Route as AppStoresIndentsIdRouteImport } from "./routes/_app/stores/indents/$id";
import { Route as AppStoresIndentsNewRouteImport } from "./routes/_app/stores/indents/new";
import { Route as AppStoresIssuesIndexRouteImport } from "./routes/_app/stores/issues/index";
import { Route as AppStoresIssuesNewRouteImport } from "./routes/_app/stores/issues/new";
import { Route as AppStoresReportsIndexRouteImport } from "./routes/_app/stores/reports/index";
import { Route as AppStoresReportsKeyRouteImport } from "./routes/_app/stores/reports/$key";
import { Route as AppStoresReportsBinCardRouteImport } from "./routes/_app/stores/reports/bin-card";
import { Route as AppStoresSlocIndexRouteImport } from "./routes/_app/stores/sloc/index";
import { Route as AppStoresSlocNewRouteImport } from "./routes/_app/stores/sloc/new";
import { Route as AppThermalPendingIndexRouteImport } from "./routes/_app/thermal/pending/index";
import { Route as AppWarehouseStageLotBiographyRouteImport } from "./routes/_app/warehouse/$stage/lot-biography";
import { Route as AppWarehouseLotBiographyIndexRouteImport } from "./routes/_app/warehouse/lot-biography/index";
import { Route as AppWarehouseLotBiographyLotIdRouteImport } from "./routes/_app/warehouse/lot-biography/$lotId";
import { Route as AppArrivalsFormIdDetailsRouteImport } from "./routes/_app/arrivals/$form/$id_.details";
import { Route as AppArrivalsTradingIdDetailsRouteImport } from "./routes/_app/arrivals/trading/$id_.details";
import { Route as AppDispatchSalesKindIndexRouteImport } from "./routes/_app/dispatch/sales/$kind/index";
import { Route as AppDispatchSalesKindIdRouteImport } from "./routes/_app/dispatch/sales/$kind/$id";
import { Route as AppDispatchSalesKindNewRouteImport } from "./routes/_app/dispatch/sales/$kind/new";
import { Route as AppProcessingBlendingIdDetailsRouteImport } from "./routes/_app/processing/blending/$id_.details";
import { Route as AppQualityGotFinalGradeIndexRouteImport } from "./routes/_app/quality/got/final-grade/index";
import { Route as AppQualityGotFinalGradeIdRouteImport } from "./routes/_app/quality/got/final-grade/$id";
import { Route as AppQualityGotHandoverIndexRouteImport } from "./routes/_app/quality/got/handover/index";
import { Route as AppQualityGotHandoverReceiveRouteImport } from "./routes/_app/quality/got/handover/receive";
import { Route as AppQualityGotHandoverReportRouteImport } from "./routes/_app/quality/got/handover/report";
import { Route as AppQualityGotReportsIndexRouteImport } from "./routes/_app/quality/got/reports/index";
import { Route as AppQualityGotReportsKeyRouteImport } from "./routes/_app/quality/got/reports/$key";
import { Route as AppQualityGotResultUpdateIndexRouteImport } from "./routes/_app/quality/got/result-update/index";
import { Route as AppQualityGotReviewIndexRouteImport } from "./routes/_app/quality/got/review/index";
import { Route as AppQualityGotReviewSampleIdRouteImport } from "./routes/_app/quality/got/review/$sampleId";
import { Route as AppQualityReleasesKindIndexRouteImport } from "./routes/_app/quality/releases/$kind/index";
import { Route as AppQualityReleasesKindReleaseIdRouteImport } from "./routes/_app/quality/releases/$kind/$releaseId";
import { Route as AppQualityReleasesKindNewRouteImport } from "./routes/_app/quality/releases/$kind/new";
import { Route as AppWarehouseStageBatchIndexRouteImport } from "./routes/_app/warehouse/$stage/batch/index";
import { Route as AppWarehouseStageBatchNewRouteImport } from "./routes/_app/warehouse/$stage/batch/new";
import { Route as AppWarehouseStageReleaseIndexRouteImport } from "./routes/_app/warehouse/$stage/release/index";
import { Route as AppWarehouseStageReleaseNewRouteImport } from "./routes/_app/warehouse/$stage/release/new";
import { Route as AppWarehouseStageReportsIndexRouteImport } from "./routes/_app/warehouse/$stage/reports/index";
import { Route as AppWarehouseStageReportsKeyRouteImport } from "./routes/_app/warehouse/$stage/reports/$key";
import { Route as AppWarehouseStageSeedStatusIndexRouteImport } from "./routes/_app/warehouse/$stage/seed-status/index";
import { Route as AppWarehouseStageSeedStatusUpdateRouteImport } from "./routes/_app/warehouse/$stage/seed-status/update";
import { Route as AppWarehouseStageSlocIndexRouteImport } from "./routes/_app/warehouse/$stage/sloc/index";
import { Route as AppWarehouseStageSlocNewRouteImport } from "./routes/_app/warehouse/$stage/sloc/new";
import { Route as AppQualityGotPrintKindDispatchIdRouteImport } from "./routes/_app/quality/got/print/$kind/$dispatchId";
import { Route as AppQualityGotResultUpdateSampleIdIndexRouteImport } from "./routes/_app/quality/got/result-update/$sampleId/index";
import { Route as AppQualityGotResultUpdateSampleIdViewRouteImport } from "./routes/_app/quality/got/result-update/$sampleId/view";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any);
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => rootRouteImport,
} as any);
const HandheldRoute = HandheldRouteImport.update({
  id: "/handheld",
  path: "/handheld",
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const AppAbbreviationsRoute = AppAbbreviationsRouteImport.update({
  id: "/abbreviations",
  path: "/abbreviations",
  getParentRoute: () => AppRoute,
} as any);
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AppRoute,
} as any);
const AppHomeRoute = AppHomeRouteImport.update({
  id: "/home",
  path: "/home",
  getParentRoute: () => AppRoute,
} as any);
const AppQcDashboardRoute = AppQcDashboardRouteImport.update({
  id: "/qc-dashboard",
  path: "/qc-dashboard",
  getParentRoute: () => AppRoute,
} as any);
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/app/",
  path: "/app/",
  getParentRoute: () => rootRouteImport,
} as any);
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: "/invite/$token",
  path: "/invite/$token",
  getParentRoute: () => rootRouteImport,
} as any);
const KioskPackingRoute = KioskPackingRouteImport.update({
  id: "/kiosk/packing",
  path: "/kiosk/packing",
  getParentRoute: () => rootRouteImport,
} as any);
const AppAccountPasswordRoute = AppAccountPasswordRouteImport.update({
  id: "/account/password",
  path: "/account/password",
  getParentRoute: () => AppRoute,
} as any);
const AppAccountProfileRoute = AppAccountProfileRouteImport.update({
  id: "/account/profile",
  path: "/account/profile",
  getParentRoute: () => AppRoute,
} as any);
const AppAdminAuditLogRoute = AppAdminAuditLogRouteImport.update({
  id: "/admin/audit-log",
  path: "/admin/audit-log",
  getParentRoute: () => AppRoute,
} as any);
const AppAdminIntegrationsRoute = AppAdminIntegrationsRouteImport.update({
  id: "/admin/integrations",
  path: "/admin/integrations",
  getParentRoute: () => AppRoute,
} as any);
const AppAdminRolesRoute = AppAdminRolesRouteImport.update({
  id: "/admin/roles",
  path: "/admin/roles",
  getParentRoute: () => AppRoute,
} as any);
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: "/admin/users",
  path: "/admin/users",
  getParentRoute: () => AppRoute,
} as any);
const AppArrivalsIndexRoute = AppArrivalsIndexRouteImport.update({
  id: "/arrivals/",
  path: "/arrivals/",
  getParentRoute: () => AppRoute,
} as any);
const AppDevTokensRoute = AppDevTokensRouteImport.update({
  id: "/dev/tokens",
  path: "/dev/tokens",
  getParentRoute: () => AppRoute,
} as any);
const AppDispatchBarcodeLookupRoute =
  AppDispatchBarcodeLookupRouteImport.update({
    id: "/dispatch/barcode-lookup",
    path: "/dispatch/barcode-lookup",
    getParentRoute: () => AppRoute,
  } as any);
const AppDryerIndexRoute = AppDryerIndexRouteImport.update({
  id: "/dryer/",
  path: "/dryer/",
  getParentRoute: () => AppRoute,
} as any);
const AppFeedbackIndexRoute = AppFeedbackIndexRouteImport.update({
  id: "/feedback/",
  path: "/feedback/",
  getParentRoute: () => AppRoute,
} as any);
const AppFeedbackIdRoute = AppFeedbackIdRouteImport.update({
  id: "/feedback/$id",
  path: "/feedback/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppFeedbackNewRoute = AppFeedbackNewRouteImport.update({
  id: "/feedback/new",
  path: "/feedback/new",
  getParentRoute: () => AppRoute,
} as any);
const AppGateIndexRoute = AppGateIndexRouteImport.update({
  id: "/gate/",
  path: "/gate/",
  getParentRoute: () => AppRoute,
} as any);
const AppInventoryIndexRoute = AppInventoryIndexRouteImport.update({
  id: "/inventory/",
  path: "/inventory/",
  getParentRoute: () => AppRoute,
} as any);
const AppInventoryOpeningRoute = AppInventoryOpeningRouteImport.update({
  id: "/inventory/opening",
  path: "/inventory/opening",
  getParentRoute: () => AppRoute,
} as any);
const AppInventoryReconciliationRoute =
  AppInventoryReconciliationRouteImport.update({
    id: "/inventory/reconciliation",
    path: "/inventory/reconciliation",
    getParentRoute: () => AppRoute,
  } as any);
const AppInventoryReportsRoute = AppInventoryReportsRouteImport.update({
  id: "/inventory/reports",
  path: "/inventory/reports",
  getParentRoute: () => AppRoute,
} as any);
const AppInventoryReservationsRoute =
  AppInventoryReservationsRouteImport.update({
    id: "/inventory/reservations",
    path: "/inventory/reservations",
    getParentRoute: () => AppRoute,
  } as any);
const AppMastersKeyRoute = AppMastersKeyRouteImport.update({
  id: "/masters/$key",
  path: "/masters/$key",
  getParentRoute: () => AppRoute,
} as any);
const AppMastersApiFeedRoute = AppMastersApiFeedRouteImport.update({
  id: "/masters/api-feed",
  path: "/masters/api-feed",
  getParentRoute: () => AppRoute,
} as any);
const AppMastersGotFarmersRoute = AppMastersGotFarmersRouteImport.update({
  id: "/masters/got-farmers",
  path: "/masters/got-farmers",
  getParentRoute: () => AppRoute,
} as any);
const AppMastersGotLocationsRoute = AppMastersGotLocationsRouteImport.update({
  id: "/masters/got-locations",
  path: "/masters/got-locations",
  getParentRoute: () => AppRoute,
} as any);
const AppMastersGotPpnStandardsRoute =
  AppMastersGotPpnStandardsRouteImport.update({
    id: "/masters/got-ppn-standards",
    path: "/masters/got-ppn-standards",
    getParentRoute: () => AppRoute,
  } as any);
const AppMastersLocationsRoute = AppMastersLocationsRouteImport.update({
  id: "/masters/locations",
  path: "/masters/locations",
  getParentRoute: () => AppRoute,
} as any);
const AppMastersMailSettingsRoute = AppMastersMailSettingsRouteImport.update({
  id: "/masters/mail-settings",
  path: "/masters/mail-settings",
  getParentRoute: () => AppRoute,
} as any);
const AppMastersProductionPersonnelRoute =
  AppMastersProductionPersonnelRouteImport.update({
    id: "/masters/production-personnel",
    path: "/masters/production-personnel",
    getParentRoute: () => AppRoute,
  } as any);
const AppMastersStorageRestrictionsRoute =
  AppMastersStorageRestrictionsRouteImport.update({
    id: "/masters/storage-restrictions",
    path: "/masters/storage-restrictions",
    getParentRoute: () => AppRoute,
  } as any);
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: "/orders/",
  path: "/orders/",
  getParentRoute: () => AppRoute,
} as any);
const AppOrdersIdRoute = AppOrdersIdRouteImport.update({
  id: "/orders/$id",
  path: "/orders/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppOrdersHoldsRoute = AppOrdersHoldsRouteImport.update({
  id: "/orders/holds",
  path: "/orders/holds",
  getParentRoute: () => AppRoute,
} as any);
const AppOrdersImportRoute = AppOrdersImportRouteImport.update({
  id: "/orders/import",
  path: "/orders/import",
  getParentRoute: () => AppRoute,
} as any);
const AppOrdersNewRoute = AppOrdersNewRouteImport.update({
  id: "/orders/new",
  path: "/orders/new",
  getParentRoute: () => AppRoute,
} as any);
const AppOrdersStatusRoute = AppOrdersStatusRouteImport.update({
  id: "/orders/status",
  path: "/orders/status",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityIndexRoute = AppQualityIndexRouteImport.update({
  id: "/quality/",
  path: "/quality/",
  getParentRoute: () => AppRoute,
} as any);
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: "/reports/",
  path: "/reports/",
  getParentRoute: () => AppRoute,
} as any);
const AppReportsHighMoistureRoute = AppReportsHighMoistureRouteImport.update({
  id: "/reports/high-moisture",
  path: "/reports/high-moisture",
  getParentRoute: () => AppRoute,
} as any);
const AppReportsVarietyDecodingRoute =
  AppReportsVarietyDecodingRouteImport.update({
    id: "/reports/variety-decoding",
    path: "/reports/variety-decoding",
    getParentRoute: () => AppRoute,
  } as any);
const AppStoresIndexRoute = AppStoresIndexRouteImport.update({
  id: "/stores/",
  path: "/stores/",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresCaptiveRoute = AppStoresCaptiveRouteImport.update({
  id: "/stores/captive",
  path: "/stores/captive",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresDiscardRoute = AppStoresDiscardRouteImport.update({
  id: "/stores/discard",
  path: "/stores/discard",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresOpeningRoute = AppStoresOpeningRouteImport.update({
  id: "/stores/opening",
  path: "/stores/opening",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresReorderRoute = AppStoresReorderRouteImport.update({
  id: "/stores/reorder",
  path: "/stores/reorder",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresUtilityRoute = AppStoresUtilityRouteImport.update({
  id: "/stores/utility",
  path: "/stores/utility",
  getParentRoute: () => AppRoute,
} as any);
const AppWarehouseIndexRoute = AppWarehouseIndexRouteImport.update({
  id: "/warehouse/",
  path: "/warehouse/",
  getParentRoute: () => AppRoute,
} as any);
const AppWarehouseSlocRoute = AppWarehouseSlocRouteImport.update({
  id: "/warehouse/sloc",
  path: "/warehouse/sloc",
  getParentRoute: () => AppRoute,
} as any);
const AppAdminUsersUserIdRoute = AppAdminUsersUserIdRouteImport.update({
  id: "/admin/users_/$userId",
  path: "/admin/users/$userId",
  getParentRoute: () => AppRoute,
} as any);
const AppArrivalsFormIndexRoute = AppArrivalsFormIndexRouteImport.update({
  id: "/arrivals/$form/",
  path: "/arrivals/$form/",
  getParentRoute: () => AppRoute,
} as any);
const AppArrivalsFormIdRoute = AppArrivalsFormIdRouteImport.update({
  id: "/arrivals/$form/$id",
  path: "/arrivals/$form/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppArrivalsFormNewRoute = AppArrivalsFormNewRouteImport.update({
  id: "/arrivals/$form/new",
  path: "/arrivals/$form/new",
  getParentRoute: () => AppRoute,
} as any);
const AppArrivalsPpAppearanceIndexRoute =
  AppArrivalsPpAppearanceIndexRouteImport.update({
    id: "/arrivals/pp-appearance/",
    path: "/arrivals/pp-appearance/",
    getParentRoute: () => AppRoute,
  } as any);
const AppArrivalsPpAppearanceSampleIdRoute =
  AppArrivalsPpAppearanceSampleIdRouteImport.update({
    id: "/arrivals/pp-appearance/$sampleId",
    path: "/arrivals/pp-appearance/$sampleId",
    getParentRoute: () => AppRoute,
  } as any);
const AppArrivalsTradingIndexRoute = AppArrivalsTradingIndexRouteImport.update({
  id: "/arrivals/trading/",
  path: "/arrivals/trading/",
  getParentRoute: () => AppRoute,
} as any);
const AppArrivalsTradingIdRoute = AppArrivalsTradingIdRouteImport.update({
  id: "/arrivals/trading/$id",
  path: "/arrivals/trading/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppArrivalsTradingNewRoute = AppArrivalsTradingNewRouteImport.update({
  id: "/arrivals/trading/new",
  path: "/arrivals/trading/new",
  getParentRoute: () => AppRoute,
} as any);
const AppDispatchStockTransferIndexRoute =
  AppDispatchStockTransferIndexRouteImport.update({
    id: "/dispatch/stock-transfer/",
    path: "/dispatch/stock-transfer/",
    getParentRoute: () => AppRoute,
  } as any);
const AppDispatchStockTransferIdRoute =
  AppDispatchStockTransferIdRouteImport.update({
    id: "/dispatch/stock-transfer/$id",
    path: "/dispatch/stock-transfer/$id",
    getParentRoute: () => AppRoute,
  } as any);
const AppDispatchStockTransferNewRoute =
  AppDispatchStockTransferNewRouteImport.update({
    id: "/dispatch/stock-transfer/new",
    path: "/dispatch/stock-transfer/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppDryerStageIdRoute = AppDryerStageIdRouteImport.update({
  id: "/dryer/$stage/$id",
  path: "/dryer/$stage/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppGatePassInIdRoute = AppGatePassInIdRouteImport.update({
  id: "/gate/pass-in/$id",
  path: "/gate/pass-in/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppGatePassInNewRoute = AppGatePassInNewRouteImport.update({
  id: "/gate/pass-in/new",
  path: "/gate/pass-in/new",
  getParentRoute: () => AppRoute,
} as any);
const AppInventoryLotsIndexRoute = AppInventoryLotsIndexRouteImport.update({
  id: "/inventory/lots/",
  path: "/inventory/lots/",
  getParentRoute: () => AppRoute,
} as any);
const AppInventoryLotsLotIdRoute = AppInventoryLotsLotIdRouteImport.update({
  id: "/inventory/lots/$lotId",
  path: "/inventory/lots/$lotId",
  getParentRoute: () => AppRoute,
} as any);
const AppMastersVendorsIdRoute = AppMastersVendorsIdRouteImport.update({
  id: "/masters/vendors/$id",
  path: "/masters/vendors/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppMastersVendorsNewRoute = AppMastersVendorsNewRouteImport.update({
  id: "/masters/vendors/new",
  path: "/masters/vendors/new",
  getParentRoute: () => AppRoute,
} as any);
const AppPackagingFcPackingSlipIndexRoute =
  AppPackagingFcPackingSlipIndexRouteImport.update({
    id: "/packaging/fc-packing-slip/",
    path: "/packaging/fc-packing-slip/",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingFcPackingSlipIdRoute =
  AppPackagingFcPackingSlipIdRouteImport.update({
    id: "/packaging/fc-packing-slip/$id",
    path: "/packaging/fc-packing-slip/$id",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingFcPackingSlipNewRoute =
  AppPackagingFcPackingSlipNewRouteImport.update({
    id: "/packaging/fc-packing-slip/new",
    path: "/packaging/fc-packing-slip/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingIvtIndexRoute = AppPackagingIvtIndexRouteImport.update({
  id: "/packaging/ivt/",
  path: "/packaging/ivt/",
  getParentRoute: () => AppRoute,
} as any);
const AppPackagingIvtIdRoute = AppPackagingIvtIdRouteImport.update({
  id: "/packaging/ivt/$id",
  path: "/packaging/ivt/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppPackagingIvtNewRoute = AppPackagingIvtNewRouteImport.update({
  id: "/packaging/ivt/new",
  path: "/packaging/ivt/new",
  getParentRoute: () => AppRoute,
} as any);
const AppPackagingOflIndexRoute = AppPackagingOflIndexRouteImport.update({
  id: "/packaging/ofl/",
  path: "/packaging/ofl/",
  getParentRoute: () => AppRoute,
} as any);
const AppPackagingOflIdRoute = AppPackagingOflIdRouteImport.update({
  id: "/packaging/ofl/$id",
  path: "/packaging/ofl/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppPackagingOflNewRoute = AppPackagingOflNewRouteImport.update({
  id: "/packaging/ofl/new",
  path: "/packaging/ofl/new",
  getParentRoute: () => AppRoute,
} as any);
const AppPackagingP2cIndexRoute = AppPackagingP2cIndexRouteImport.update({
  id: "/packaging/p2c/",
  path: "/packaging/p2c/",
  getParentRoute: () => AppRoute,
} as any);
const AppPackagingP2cIdRoute = AppPackagingP2cIdRouteImport.update({
  id: "/packaging/p2c/$id",
  path: "/packaging/p2c/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppPackagingP2cNewRoute = AppPackagingP2cNewRouteImport.update({
  id: "/packaging/p2c/new",
  path: "/packaging/p2c/new",
  getParentRoute: () => AppRoute,
} as any);
const AppPackagingPackReprintIndexRoute =
  AppPackagingPackReprintIndexRouteImport.update({
    id: "/packaging/pack-reprint/",
    path: "/packaging/pack-reprint/",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingPackReprintIdRoute =
  AppPackagingPackReprintIdRouteImport.update({
    id: "/packaging/pack-reprint/$id",
    path: "/packaging/pack-reprint/$id",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingPackReprintNewRoute =
  AppPackagingPackReprintNewRouteImport.update({
    id: "/packaging/pack-reprint/new",
    path: "/packaging/pack-reprint/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingPackingSlipIndexRoute =
  AppPackagingPackingSlipIndexRouteImport.update({
    id: "/packaging/packing-slip/",
    path: "/packaging/packing-slip/",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingPackingSlipIdRoute =
  AppPackagingPackingSlipIdRouteImport.update({
    id: "/packaging/packing-slip/$id",
    path: "/packaging/packing-slip/$id",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingPackingSlipNewRoute =
  AppPackagingPackingSlipNewRouteImport.update({
    id: "/packaging/packing-slip/new",
    path: "/packaging/packing-slip/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingPnpFcSlipIndexRoute =
  AppPackagingPnpFcSlipIndexRouteImport.update({
    id: "/packaging/pnp-fc-slip/",
    path: "/packaging/pnp-fc-slip/",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingPnpFcSlipIdRoute = AppPackagingPnpFcSlipIdRouteImport.update({
  id: "/packaging/pnp-fc-slip/$id",
  path: "/packaging/pnp-fc-slip/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppPackagingPnpSlipIndexRoute =
  AppPackagingPnpSlipIndexRouteImport.update({
    id: "/packaging/pnp-slip/",
    path: "/packaging/pnp-slip/",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingReprintSlipIndexRoute =
  AppPackagingReprintSlipIndexRouteImport.update({
    id: "/packaging/reprint-slip/",
    path: "/packaging/reprint-slip/",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingReprintSlipIdRoute =
  AppPackagingReprintSlipIdRouteImport.update({
    id: "/packaging/reprint-slip/$id",
    path: "/packaging/reprint-slip/$id",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingReprintSlipNewRoute =
  AppPackagingReprintSlipNewRouteImport.update({
    id: "/packaging/reprint-slip/new",
    path: "/packaging/reprint-slip/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingRootStockCountIndexRoute =
  AppPackagingRootStockCountIndexRouteImport.update({
    id: "/packaging/root-stock-count/",
    path: "/packaging/root-stock-count/",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingSathiIndexRoute = AppPackagingSathiIndexRouteImport.update({
  id: "/packaging/sathi/",
  path: "/packaging/sathi/",
  getParentRoute: () => AppRoute,
} as any);
const AppPackagingStoreIndentsIndexRoute =
  AppPackagingStoreIndentsIndexRouteImport.update({
    id: "/packaging/store-indents/",
    path: "/packaging/store-indents/",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingStoreIndentsIdRoute =
  AppPackagingStoreIndentsIdRouteImport.update({
    id: "/packaging/store-indents/$id",
    path: "/packaging/store-indents/$id",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingStoreIndentsNewRoute =
  AppPackagingStoreIndentsNewRouteImport.update({
    id: "/packaging/store-indents/new",
    path: "/packaging/store-indents/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingUnpackagingIndexRoute =
  AppPackagingUnpackagingIndexRouteImport.update({
    id: "/packaging/unpackaging/",
    path: "/packaging/unpackaging/",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingWbPackingSlipIndexRoute =
  AppPackagingWbPackingSlipIndexRouteImport.update({
    id: "/packaging/wb-packing-slip/",
    path: "/packaging/wb-packing-slip/",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingWbPackingSlipIdRoute =
  AppPackagingWbPackingSlipIdRouteImport.update({
    id: "/packaging/wb-packing-slip/$id",
    path: "/packaging/wb-packing-slip/$id",
    getParentRoute: () => AppRoute,
  } as any);
const AppPackagingWbPackingSlipNewRoute =
  AppPackagingWbPackingSlipNewRouteImport.update({
    id: "/packaging/wb-packing-slip/new",
    path: "/packaging/wb-packing-slip/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingBlendingIndexRoute =
  AppProcessingBlendingIndexRouteImport.update({
    id: "/processing/blending/",
    path: "/processing/blending/",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingBlendingIdRoute = AppProcessingBlendingIdRouteImport.update({
  id: "/processing/blending/$id",
  path: "/processing/blending/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppProcessingBlendingNewRoute =
  AppProcessingBlendingNewRouteImport.update({
    id: "/processing/blending/new",
    path: "/processing/blending/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingColorSortIndexRoute =
  AppProcessingColorSortIndexRouteImport.update({
    id: "/processing/color-sort/",
    path: "/processing/color-sort/",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingColorSortIdRoute =
  AppProcessingColorSortIdRouteImport.update({
    id: "/processing/color-sort/$id",
    path: "/processing/color-sort/$id",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingColorSortNewRoute =
  AppProcessingColorSortNewRouteImport.update({
    id: "/processing/color-sort/new",
    path: "/processing/color-sort/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingDryingIndexRoute =
  AppProcessingDryingIndexRouteImport.update({
    id: "/processing/drying/",
    path: "/processing/drying/",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingDryingIdRoute = AppProcessingDryingIdRouteImport.update({
  id: "/processing/drying/$id",
  path: "/processing/drying/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppProcessingDryingNewRoute = AppProcessingDryingNewRouteImport.update({
  id: "/processing/drying/new",
  path: "/processing/drying/new",
  getParentRoute: () => AppRoute,
} as any);
const AppProcessingPackingSlipIndexRoute =
  AppProcessingPackingSlipIndexRouteImport.update({
    id: "/processing/packing-slip/",
    path: "/processing/packing-slip/",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingPackingSlipIdRoute =
  AppProcessingPackingSlipIdRouteImport.update({
    id: "/processing/packing-slip/$id",
    path: "/processing/packing-slip/$id",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingPackingSlipNewRoute =
  AppProcessingPackingSlipNewRouteImport.update({
    id: "/processing/packing-slip/new",
    path: "/processing/packing-slip/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingPnpFcSlipIndexRoute =
  AppProcessingPnpFcSlipIndexRouteImport.update({
    id: "/processing/pnp-fc-slip/",
    path: "/processing/pnp-fc-slip/",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingPnpFcSlipIdRoute =
  AppProcessingPnpFcSlipIdRouteImport.update({
    id: "/processing/pnp-fc-slip/$id",
    path: "/processing/pnp-fc-slip/$id",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingPnpFcSlipNewRoute =
  AppProcessingPnpFcSlipNewRouteImport.update({
    id: "/processing/pnp-fc-slip/new",
    path: "/processing/pnp-fc-slip/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingPrimingIndexRoute =
  AppProcessingPrimingIndexRouteImport.update({
    id: "/processing/priming/",
    path: "/processing/priming/",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingPrimingIdRoute = AppProcessingPrimingIdRouteImport.update({
  id: "/processing/priming/$id",
  path: "/processing/priming/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppProcessingPrimingNewRoute = AppProcessingPrimingNewRouteImport.update({
  id: "/processing/priming/new",
  path: "/processing/priming/new",
  getParentRoute: () => AppRoute,
} as any);
const AppProcessingReportsIndexRoute =
  AppProcessingReportsIndexRouteImport.update({
    id: "/processing/reports/",
    path: "/processing/reports/",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingReportsKeyRoute = AppProcessingReportsKeyRouteImport.update({
  id: "/processing/reports/$key",
  path: "/processing/reports/$key",
  getParentRoute: () => AppRoute,
} as any);
const AppProcessingSlipIndexRoute = AppProcessingSlipIndexRouteImport.update({
  id: "/processing/slip/",
  path: "/processing/slip/",
  getParentRoute: () => AppRoute,
} as any);
const AppProcessingSlipIdRoute = AppProcessingSlipIdRouteImport.update({
  id: "/processing/slip/$id",
  path: "/processing/slip/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppProcessingSlipNewRoute = AppProcessingSlipNewRouteImport.update({
  id: "/processing/slip/new",
  path: "/processing/slip/new",
  getParentRoute: () => AppRoute,
} as any);
const AppProcessingThermalIndexRoute =
  AppProcessingThermalIndexRouteImport.update({
    id: "/processing/thermal/",
    path: "/processing/thermal/",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingThermalIdRoute = AppProcessingThermalIdRouteImport.update({
  id: "/processing/thermal/$id",
  path: "/processing/thermal/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppProcessingThermalNewRoute = AppProcessingThermalNewRouteImport.update({
  id: "/processing/thermal/new",
  path: "/processing/thermal/new",
  getParentRoute: () => AppRoute,
} as any);
const AppProcessingTreatmentIndexRoute =
  AppProcessingTreatmentIndexRouteImport.update({
    id: "/processing/treatment/",
    path: "/processing/treatment/",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingTreatmentIdRoute =
  AppProcessingTreatmentIdRouteImport.update({
    id: "/processing/treatment/$id",
    path: "/processing/treatment/$id",
    getParentRoute: () => AppRoute,
  } as any);
const AppProcessingTreatmentNewRoute =
  AppProcessingTreatmentNewRouteImport.update({
    id: "/processing/treatment/new",
    path: "/processing/treatment/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityAllocationIndexRoute =
  AppQualityAllocationIndexRouteImport.update({
    id: "/quality/allocation/",
    path: "/quality/allocation/",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityAllocationSrfIdRoute =
  AppQualityAllocationSrfIdRouteImport.update({
    id: "/quality/allocation/$srfId",
    path: "/quality/allocation/$srfId",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityAllocationMonitorRoute =
  AppQualityAllocationMonitorRouteImport.update({
    id: "/quality/allocation/monitor",
    path: "/quality/allocation/monitor",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityAllocationSamplesRoute =
  AppQualityAllocationSamplesRouteImport.update({
    id: "/quality/allocation/samples",
    path: "/quality/allocation/samples",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityBarcodeSearchIndexRoute =
  AppQualityBarcodeSearchIndexRouteImport.update({
    id: "/quality/barcode-search/",
    path: "/quality/barcode-search/",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityBatchFinderIndexRoute =
  AppQualityBatchFinderIndexRouteImport.update({
    id: "/quality/batch-finder/",
    path: "/quality/batch-finder/",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityBlendingIndexRoute = AppQualityBlendingIndexRouteImport.update({
  id: "/quality/blending/",
  path: "/quality/blending/",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityBlendingIdRoute = AppQualityBlendingIdRouteImport.update({
  id: "/quality/blending/$id",
  path: "/quality/blending/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityDamagedSamplesIndexRoute =
  AppQualityDamagedSamplesIndexRouteImport.update({
    id: "/quality/damaged-samples/",
    path: "/quality/damaged-samples/",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityDensityIndexRoute = AppQualityDensityIndexRouteImport.update({
  id: "/quality/density/",
  path: "/quality/density/",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityDovCalculatorIndexRoute =
  AppQualityDovCalculatorIndexRouteImport.update({
    id: "/quality/dov-calculator/",
    path: "/quality/dov-calculator/",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGerminationIndexRoute =
  AppQualityGerminationIndexRouteImport.update({
    id: "/quality/germination/",
    path: "/quality/germination/",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGerminationSampleIdRoute =
  AppQualityGerminationSampleIdRouteImport.update({
    id: "/quality/germination/$sampleId",
    path: "/quality/germination/$sampleId",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGotBiographyRoute = AppQualityGotBiographyRouteImport.update({
  id: "/quality/got/biography",
  path: "/quality/got/biography",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityGotDispatchRoute = AppQualityGotDispatchRouteImport.update({
  id: "/quality/got/dispatch",
  path: "/quality/got/dispatch",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityGotLowPpnRoute = AppQualityGotLowPpnRouteImport.update({
  id: "/quality/got/low-ppn",
  path: "/quality/got/low-ppn",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityGotPrintSampleRoute =
  AppQualityGotPrintSampleRouteImport.update({
    id: "/quality/got/print-sample",
    path: "/quality/got/print-sample",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGuardSamplesIndexRoute =
  AppQualityGuardSamplesIndexRouteImport.update({
    id: "/quality/guard-samples/",
    path: "/quality/guard-samples/",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGuardSamplesMoveRoute =
  AppQualityGuardSamplesMoveRouteImport.update({
    id: "/quality/guard-samples/move",
    path: "/quality/guard-samples/move",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityMoistureIndexRoute = AppQualityMoistureIndexRouteImport.update({
  id: "/quality/moisture/",
  path: "/quality/moisture/",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityMoistureSampleIdRoute =
  AppQualityMoistureSampleIdRouteImport.update({
    id: "/quality/moisture/$sampleId",
    path: "/quality/moisture/$sampleId",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityPendingIndexRoute = AppQualityPendingIndexRouteImport.update({
  id: "/quality/pending/",
  path: "/quality/pending/",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityPendingSampleIdRoute =
  AppQualityPendingSampleIdRouteImport.update({
    id: "/quality/pending/$sampleId",
    path: "/quality/pending/$sampleId",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityPpIndexRoute = AppQualityPpIndexRouteImport.update({
  id: "/quality/pp/",
  path: "/quality/pp/",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityPpSampleIdRoute = AppQualityPpSampleIdRouteImport.update({
  id: "/quality/pp/$sampleId",
  path: "/quality/pp/$sampleId",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityQcAgeingIndexRoute = AppQualityQcAgeingIndexRouteImport.update({
  id: "/quality/qc-ageing/",
  path: "/quality/qc-ageing/",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityRequestsIndexRoute = AppQualityRequestsIndexRouteImport.update({
  id: "/quality/requests/",
  path: "/quality/requests/",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityRequestsRequestIdRoute =
  AppQualityRequestsRequestIdRouteImport.update({
    id: "/quality/requests/$requestId",
    path: "/quality/requests/$requestId",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityRequestsNewRoute = AppQualityRequestsNewRouteImport.update({
  id: "/quality/requests/new",
  path: "/quality/requests/new",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityRtSrfIndexRoute = AppQualityRtSrfIndexRouteImport.update({
  id: "/quality/rt-srf/",
  path: "/quality/rt-srf/",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityStandardsIndexRoute =
  AppQualityStandardsIndexRouteImport.update({
    id: "/quality/standards/",
    path: "/quality/standards/",
    getParentRoute: () => AppRoute,
  } as any);
const AppReportsArrivalIndexRoute = AppReportsArrivalIndexRouteImport.update({
  id: "/reports/arrival/",
  path: "/reports/arrival/",
  getParentRoute: () => AppRoute,
} as any);
const AppReportsArrivalSlugRoute = AppReportsArrivalSlugRouteImport.update({
  id: "/reports/arrival/$slug",
  path: "/reports/arrival/$slug",
  getParentRoute: () => AppRoute,
} as any);
const AppReportsCswIndexRoute = AppReportsCswIndexRouteImport.update({
  id: "/reports/csw/",
  path: "/reports/csw/",
  getParentRoute: () => AppRoute,
} as any);
const AppReportsCswKeyRoute = AppReportsCswKeyRouteImport.update({
  id: "/reports/csw/$key",
  path: "/reports/csw/$key",
  getParentRoute: () => AppRoute,
} as any);
const AppReportsDispatchPeriodicalRoute =
  AppReportsDispatchPeriodicalRouteImport.update({
    id: "/reports/dispatch/periodical",
    path: "/reports/dispatch/periodical",
    getParentRoute: () => AppRoute,
  } as any);
const AppReportsOrdersDispatchKeyRoute =
  AppReportsOrdersDispatchKeyRouteImport.update({
    id: "/reports/orders-dispatch/$key",
    path: "/reports/orders-dispatch/$key",
    getParentRoute: () => AppRoute,
  } as any);
const AppReportsPackagingIndexRoute =
  AppReportsPackagingIndexRouteImport.update({
    id: "/reports/packaging/",
    path: "/reports/packaging/",
    getParentRoute: () => AppRoute,
  } as any);
const AppReportsPackagingSlugRoute = AppReportsPackagingSlugRouteImport.update({
  id: "/reports/packaging/$slug",
  path: "/reports/packaging/$slug",
  getParentRoute: () => AppRoute,
} as any);
const AppReportsQcSlugRoute = AppReportsQcSlugRouteImport.update({
  id: "/reports/qc/$slug",
  path: "/reports/qc/$slug",
  getParentRoute: () => AppRoute,
} as any);
const AppReportsRswIndexRoute = AppReportsRswIndexRouteImport.update({
  id: "/reports/rsw/",
  path: "/reports/rsw/",
  getParentRoute: () => AppRoute,
} as any);
const AppReportsRswKeyRoute = AppReportsRswKeyRouteImport.update({
  id: "/reports/rsw/$key",
  path: "/reports/rsw/$key",
  getParentRoute: () => AppRoute,
} as any);
const AppReportsStockIndexRoute = AppReportsStockIndexRouteImport.update({
  id: "/reports/stock/",
  path: "/reports/stock/",
  getParentRoute: () => AppRoute,
} as any);
const AppReportsStockSlugRoute = AppReportsStockSlugRouteImport.update({
  id: "/reports/stock/$slug",
  path: "/reports/stock/$slug",
  getParentRoute: () => AppRoute,
} as any);
const AppReportsWarehouseIndexRoute =
  AppReportsWarehouseIndexRouteImport.update({
    id: "/reports/warehouse/",
    path: "/reports/warehouse/",
    getParentRoute: () => AppRoute,
  } as any);
const AppReportsWarehouseSlugRoute = AppReportsWarehouseSlugRouteImport.update({
  id: "/reports/warehouse/$slug",
  path: "/reports/warehouse/$slug",
  getParentRoute: () => AppRoute,
} as any);
const AppRndPrimingIndexRoute = AppRndPrimingIndexRouteImport.update({
  id: "/rnd/priming/",
  path: "/rnd/priming/",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresArrivalsIndexRoute = AppStoresArrivalsIndexRouteImport.update({
  id: "/stores/arrivals/",
  path: "/stores/arrivals/",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresArrivalsIdRoute = AppStoresArrivalsIdRouteImport.update({
  id: "/stores/arrivals/$id",
  path: "/stores/arrivals/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresArrivalsNewRoute = AppStoresArrivalsNewRouteImport.update({
  id: "/stores/arrivals/new",
  path: "/stores/arrivals/new",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresCorrectionsIndexRoute =
  AppStoresCorrectionsIndexRouteImport.update({
    id: "/stores/corrections/",
    path: "/stores/corrections/",
    getParentRoute: () => AppRoute,
  } as any);
const AppStoresCorrectionsNewRoute = AppStoresCorrectionsNewRouteImport.update({
  id: "/stores/corrections/new",
  path: "/stores/corrections/new",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresCountsIndexRoute = AppStoresCountsIndexRouteImport.update({
  id: "/stores/counts/",
  path: "/stores/counts/",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresDocsIdRoute = AppStoresDocsIdRouteImport.update({
  id: "/stores/docs/$id",
  path: "/stores/docs/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresIndentsIndexRoute = AppStoresIndentsIndexRouteImport.update({
  id: "/stores/indents/",
  path: "/stores/indents/",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresIndentsIdRoute = AppStoresIndentsIdRouteImport.update({
  id: "/stores/indents/$id",
  path: "/stores/indents/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresIndentsNewRoute = AppStoresIndentsNewRouteImport.update({
  id: "/stores/indents/new",
  path: "/stores/indents/new",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresIssuesIndexRoute = AppStoresIssuesIndexRouteImport.update({
  id: "/stores/issues/",
  path: "/stores/issues/",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresIssuesNewRoute = AppStoresIssuesNewRouteImport.update({
  id: "/stores/issues/new",
  path: "/stores/issues/new",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresReportsIndexRoute = AppStoresReportsIndexRouteImport.update({
  id: "/stores/reports/",
  path: "/stores/reports/",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresReportsKeyRoute = AppStoresReportsKeyRouteImport.update({
  id: "/stores/reports/$key",
  path: "/stores/reports/$key",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresReportsBinCardRoute = AppStoresReportsBinCardRouteImport.update({
  id: "/stores/reports/bin-card",
  path: "/stores/reports/bin-card",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresSlocIndexRoute = AppStoresSlocIndexRouteImport.update({
  id: "/stores/sloc/",
  path: "/stores/sloc/",
  getParentRoute: () => AppRoute,
} as any);
const AppStoresSlocNewRoute = AppStoresSlocNewRouteImport.update({
  id: "/stores/sloc/new",
  path: "/stores/sloc/new",
  getParentRoute: () => AppRoute,
} as any);
const AppThermalPendingIndexRoute = AppThermalPendingIndexRouteImport.update({
  id: "/thermal/pending/",
  path: "/thermal/pending/",
  getParentRoute: () => AppRoute,
} as any);
const AppWarehouseStageLotBiographyRoute =
  AppWarehouseStageLotBiographyRouteImport.update({
    id: "/warehouse/$stage/lot-biography",
    path: "/warehouse/$stage/lot-biography",
    getParentRoute: () => AppRoute,
  } as any);
const AppWarehouseLotBiographyIndexRoute =
  AppWarehouseLotBiographyIndexRouteImport.update({
    id: "/warehouse/lot-biography/",
    path: "/warehouse/lot-biography/",
    getParentRoute: () => AppRoute,
  } as any);
const AppWarehouseLotBiographyLotIdRoute =
  AppWarehouseLotBiographyLotIdRouteImport.update({
    id: "/warehouse/lot-biography/$lotId",
    path: "/warehouse/lot-biography/$lotId",
    getParentRoute: () => AppRoute,
  } as any);
const AppArrivalsFormIdDetailsRoute =
  AppArrivalsFormIdDetailsRouteImport.update({
    id: "/arrivals/$form/$id_/details",
    path: "/arrivals/$form/$id/details",
    getParentRoute: () => AppRoute,
  } as any);
const AppArrivalsTradingIdDetailsRoute =
  AppArrivalsTradingIdDetailsRouteImport.update({
    id: "/arrivals/trading/$id_/details",
    path: "/arrivals/trading/$id/details",
    getParentRoute: () => AppRoute,
  } as any);
const AppDispatchSalesKindIndexRoute =
  AppDispatchSalesKindIndexRouteImport.update({
    id: "/dispatch/sales/$kind/",
    path: "/dispatch/sales/$kind/",
    getParentRoute: () => AppRoute,
  } as any);
const AppDispatchSalesKindIdRoute = AppDispatchSalesKindIdRouteImport.update({
  id: "/dispatch/sales/$kind/$id",
  path: "/dispatch/sales/$kind/$id",
  getParentRoute: () => AppRoute,
} as any);
const AppDispatchSalesKindNewRoute = AppDispatchSalesKindNewRouteImport.update({
  id: "/dispatch/sales/$kind/new",
  path: "/dispatch/sales/$kind/new",
  getParentRoute: () => AppRoute,
} as any);
const AppProcessingBlendingIdDetailsRoute =
  AppProcessingBlendingIdDetailsRouteImport.update({
    id: "/processing/blending/$id_/details",
    path: "/processing/blending/$id/details",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGotFinalGradeIndexRoute =
  AppQualityGotFinalGradeIndexRouteImport.update({
    id: "/quality/got/final-grade/",
    path: "/quality/got/final-grade/",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGotFinalGradeIdRoute =
  AppQualityGotFinalGradeIdRouteImport.update({
    id: "/quality/got/final-grade/$id",
    path: "/quality/got/final-grade/$id",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGotHandoverIndexRoute =
  AppQualityGotHandoverIndexRouteImport.update({
    id: "/quality/got/handover/",
    path: "/quality/got/handover/",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGotHandoverReceiveRoute =
  AppQualityGotHandoverReceiveRouteImport.update({
    id: "/quality/got/handover/receive",
    path: "/quality/got/handover/receive",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGotHandoverReportRoute =
  AppQualityGotHandoverReportRouteImport.update({
    id: "/quality/got/handover/report",
    path: "/quality/got/handover/report",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGotReportsIndexRoute =
  AppQualityGotReportsIndexRouteImport.update({
    id: "/quality/got/reports/",
    path: "/quality/got/reports/",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGotReportsKeyRoute = AppQualityGotReportsKeyRouteImport.update({
  id: "/quality/got/reports/$key",
  path: "/quality/got/reports/$key",
  getParentRoute: () => AppRoute,
} as any);
const AppQualityGotResultUpdateIndexRoute =
  AppQualityGotResultUpdateIndexRouteImport.update({
    id: "/quality/got/result-update/",
    path: "/quality/got/result-update/",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGotReviewIndexRoute =
  AppQualityGotReviewIndexRouteImport.update({
    id: "/quality/got/review/",
    path: "/quality/got/review/",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGotReviewSampleIdRoute =
  AppQualityGotReviewSampleIdRouteImport.update({
    id: "/quality/got/review/$sampleId",
    path: "/quality/got/review/$sampleId",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityReleasesKindIndexRoute =
  AppQualityReleasesKindIndexRouteImport.update({
    id: "/quality/releases/$kind/",
    path: "/quality/releases/$kind/",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityReleasesKindReleaseIdRoute =
  AppQualityReleasesKindReleaseIdRouteImport.update({
    id: "/quality/releases/$kind/$releaseId",
    path: "/quality/releases/$kind/$releaseId",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityReleasesKindNewRoute =
  AppQualityReleasesKindNewRouteImport.update({
    id: "/quality/releases/$kind/new",
    path: "/quality/releases/$kind/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppWarehouseStageBatchIndexRoute =
  AppWarehouseStageBatchIndexRouteImport.update({
    id: "/warehouse/$stage/batch/",
    path: "/warehouse/$stage/batch/",
    getParentRoute: () => AppRoute,
  } as any);
const AppWarehouseStageBatchNewRoute =
  AppWarehouseStageBatchNewRouteImport.update({
    id: "/warehouse/$stage/batch/new",
    path: "/warehouse/$stage/batch/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppWarehouseStageReleaseIndexRoute =
  AppWarehouseStageReleaseIndexRouteImport.update({
    id: "/warehouse/$stage/release/",
    path: "/warehouse/$stage/release/",
    getParentRoute: () => AppRoute,
  } as any);
const AppWarehouseStageReleaseNewRoute =
  AppWarehouseStageReleaseNewRouteImport.update({
    id: "/warehouse/$stage/release/new",
    path: "/warehouse/$stage/release/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppWarehouseStageReportsIndexRoute =
  AppWarehouseStageReportsIndexRouteImport.update({
    id: "/warehouse/$stage/reports/",
    path: "/warehouse/$stage/reports/",
    getParentRoute: () => AppRoute,
  } as any);
const AppWarehouseStageReportsKeyRoute =
  AppWarehouseStageReportsKeyRouteImport.update({
    id: "/warehouse/$stage/reports/$key",
    path: "/warehouse/$stage/reports/$key",
    getParentRoute: () => AppRoute,
  } as any);
const AppWarehouseStageSeedStatusIndexRoute =
  AppWarehouseStageSeedStatusIndexRouteImport.update({
    id: "/warehouse/$stage/seed-status/",
    path: "/warehouse/$stage/seed-status/",
    getParentRoute: () => AppRoute,
  } as any);
const AppWarehouseStageSeedStatusUpdateRoute =
  AppWarehouseStageSeedStatusUpdateRouteImport.update({
    id: "/warehouse/$stage/seed-status/update",
    path: "/warehouse/$stage/seed-status/update",
    getParentRoute: () => AppRoute,
  } as any);
const AppWarehouseStageSlocIndexRoute =
  AppWarehouseStageSlocIndexRouteImport.update({
    id: "/warehouse/$stage/sloc/",
    path: "/warehouse/$stage/sloc/",
    getParentRoute: () => AppRoute,
  } as any);
const AppWarehouseStageSlocNewRoute =
  AppWarehouseStageSlocNewRouteImport.update({
    id: "/warehouse/$stage/sloc/new",
    path: "/warehouse/$stage/sloc/new",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGotPrintKindDispatchIdRoute =
  AppQualityGotPrintKindDispatchIdRouteImport.update({
    id: "/quality/got/print/$kind/$dispatchId",
    path: "/quality/got/print/$kind/$dispatchId",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGotResultUpdateSampleIdIndexRoute =
  AppQualityGotResultUpdateSampleIdIndexRouteImport.update({
    id: "/quality/got/result-update/$sampleId/",
    path: "/quality/got/result-update/$sampleId/",
    getParentRoute: () => AppRoute,
  } as any);
const AppQualityGotResultUpdateSampleIdViewRoute =
  AppQualityGotResultUpdateSampleIdViewRouteImport.update({
    id: "/quality/got/result-update/$sampleId/view",
    path: "/quality/got/result-update/$sampleId/view",
    getParentRoute: () => AppRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/handheld": typeof HandheldRoute;
  "/login": typeof LoginRoute;
  "/abbreviations": typeof AppAbbreviationsRoute;
  "/dashboard": typeof AppDashboardRoute;
  "/home": typeof AppHomeRoute;
  "/qc-dashboard": typeof AppQcDashboardRoute;
  "/invite/$token": typeof InviteTokenRoute;
  "/kiosk/packing": typeof KioskPackingRoute;
  "/app/": typeof AppIndexRoute;
  "/account/password": typeof AppAccountPasswordRoute;
  "/account/profile": typeof AppAccountProfileRoute;
  "/admin/audit-log": typeof AppAdminAuditLogRoute;
  "/admin/integrations": typeof AppAdminIntegrationsRoute;
  "/admin/roles": typeof AppAdminRolesRoute;
  "/admin/users": typeof AppAdminUsersRoute;
  "/dev/tokens": typeof AppDevTokensRoute;
  "/dispatch/barcode-lookup": typeof AppDispatchBarcodeLookupRoute;
  "/feedback/$id": typeof AppFeedbackIdRoute;
  "/feedback/new": typeof AppFeedbackNewRoute;
  "/inventory/opening": typeof AppInventoryOpeningRoute;
  "/inventory/reconciliation": typeof AppInventoryReconciliationRoute;
  "/inventory/reports": typeof AppInventoryReportsRoute;
  "/inventory/reservations": typeof AppInventoryReservationsRoute;
  "/masters/$key": typeof AppMastersKeyRoute;
  "/masters/api-feed": typeof AppMastersApiFeedRoute;
  "/masters/got-farmers": typeof AppMastersGotFarmersRoute;
  "/masters/got-locations": typeof AppMastersGotLocationsRoute;
  "/masters/got-ppn-standards": typeof AppMastersGotPpnStandardsRoute;
  "/masters/locations": typeof AppMastersLocationsRoute;
  "/masters/mail-settings": typeof AppMastersMailSettingsRoute;
  "/masters/production-personnel": typeof AppMastersProductionPersonnelRoute;
  "/masters/storage-restrictions": typeof AppMastersStorageRestrictionsRoute;
  "/orders/$id": typeof AppOrdersIdRoute;
  "/orders/holds": typeof AppOrdersHoldsRoute;
  "/orders/import": typeof AppOrdersImportRoute;
  "/orders/new": typeof AppOrdersNewRoute;
  "/orders/status": typeof AppOrdersStatusRoute;
  "/reports/high-moisture": typeof AppReportsHighMoistureRoute;
  "/reports/variety-decoding": typeof AppReportsVarietyDecodingRoute;
  "/stores/captive": typeof AppStoresCaptiveRoute;
  "/stores/discard": typeof AppStoresDiscardRoute;
  "/stores/opening": typeof AppStoresOpeningRoute;
  "/stores/reorder": typeof AppStoresReorderRoute;
  "/stores/utility": typeof AppStoresUtilityRoute;
  "/warehouse/sloc": typeof AppWarehouseSlocRoute;
  "/arrivals/": typeof AppArrivalsIndexRoute;
  "/dryer/": typeof AppDryerIndexRoute;
  "/feedback/": typeof AppFeedbackIndexRoute;
  "/gate/": typeof AppGateIndexRoute;
  "/inventory/": typeof AppInventoryIndexRoute;
  "/orders/": typeof AppOrdersIndexRoute;
  "/quality/": typeof AppQualityIndexRoute;
  "/reports/": typeof AppReportsIndexRoute;
  "/stores/": typeof AppStoresIndexRoute;
  "/warehouse/": typeof AppWarehouseIndexRoute;
  "/admin/users/$userId": typeof AppAdminUsersUserIdRoute;
  "/arrivals/$form/$id": typeof AppArrivalsFormIdRoute;
  "/arrivals/$form/new": typeof AppArrivalsFormNewRoute;
  "/arrivals/pp-appearance/$sampleId": typeof AppArrivalsPpAppearanceSampleIdRoute;
  "/arrivals/trading/$id": typeof AppArrivalsTradingIdRoute;
  "/arrivals/trading/new": typeof AppArrivalsTradingNewRoute;
  "/dispatch/stock-transfer/$id": typeof AppDispatchStockTransferIdRoute;
  "/dispatch/stock-transfer/new": typeof AppDispatchStockTransferNewRoute;
  "/dryer/$stage/$id": typeof AppDryerStageIdRoute;
  "/gate/pass-in/$id": typeof AppGatePassInIdRoute;
  "/gate/pass-in/new": typeof AppGatePassInNewRoute;
  "/inventory/lots/$lotId": typeof AppInventoryLotsLotIdRoute;
  "/masters/vendors/$id": typeof AppMastersVendorsIdRoute;
  "/masters/vendors/new": typeof AppMastersVendorsNewRoute;
  "/packaging/fc-packing-slip/$id": typeof AppPackagingFcPackingSlipIdRoute;
  "/packaging/fc-packing-slip/new": typeof AppPackagingFcPackingSlipNewRoute;
  "/packaging/ivt/$id": typeof AppPackagingIvtIdRoute;
  "/packaging/ivt/new": typeof AppPackagingIvtNewRoute;
  "/packaging/ofl/$id": typeof AppPackagingOflIdRoute;
  "/packaging/ofl/new": typeof AppPackagingOflNewRoute;
  "/packaging/p2c/$id": typeof AppPackagingP2cIdRoute;
  "/packaging/p2c/new": typeof AppPackagingP2cNewRoute;
  "/packaging/pack-reprint/$id": typeof AppPackagingPackReprintIdRoute;
  "/packaging/pack-reprint/new": typeof AppPackagingPackReprintNewRoute;
  "/packaging/packing-slip/$id": typeof AppPackagingPackingSlipIdRoute;
  "/packaging/packing-slip/new": typeof AppPackagingPackingSlipNewRoute;
  "/packaging/pnp-fc-slip/$id": typeof AppPackagingPnpFcSlipIdRoute;
  "/packaging/reprint-slip/$id": typeof AppPackagingReprintSlipIdRoute;
  "/packaging/reprint-slip/new": typeof AppPackagingReprintSlipNewRoute;
  "/packaging/store-indents/$id": typeof AppPackagingStoreIndentsIdRoute;
  "/packaging/store-indents/new": typeof AppPackagingStoreIndentsNewRoute;
  "/packaging/wb-packing-slip/$id": typeof AppPackagingWbPackingSlipIdRoute;
  "/packaging/wb-packing-slip/new": typeof AppPackagingWbPackingSlipNewRoute;
  "/processing/blending/$id": typeof AppProcessingBlendingIdRoute;
  "/processing/blending/new": typeof AppProcessingBlendingNewRoute;
  "/processing/color-sort/$id": typeof AppProcessingColorSortIdRoute;
  "/processing/color-sort/new": typeof AppProcessingColorSortNewRoute;
  "/processing/drying/$id": typeof AppProcessingDryingIdRoute;
  "/processing/drying/new": typeof AppProcessingDryingNewRoute;
  "/processing/packing-slip/$id": typeof AppProcessingPackingSlipIdRoute;
  "/processing/packing-slip/new": typeof AppProcessingPackingSlipNewRoute;
  "/processing/pnp-fc-slip/$id": typeof AppProcessingPnpFcSlipIdRoute;
  "/processing/pnp-fc-slip/new": typeof AppProcessingPnpFcSlipNewRoute;
  "/processing/priming/$id": typeof AppProcessingPrimingIdRoute;
  "/processing/priming/new": typeof AppProcessingPrimingNewRoute;
  "/processing/reports/$key": typeof AppProcessingReportsKeyRoute;
  "/processing/slip/$id": typeof AppProcessingSlipIdRoute;
  "/processing/slip/new": typeof AppProcessingSlipNewRoute;
  "/processing/thermal/$id": typeof AppProcessingThermalIdRoute;
  "/processing/thermal/new": typeof AppProcessingThermalNewRoute;
  "/processing/treatment/$id": typeof AppProcessingTreatmentIdRoute;
  "/processing/treatment/new": typeof AppProcessingTreatmentNewRoute;
  "/quality/allocation/$srfId": typeof AppQualityAllocationSrfIdRoute;
  "/quality/allocation/monitor": typeof AppQualityAllocationMonitorRoute;
  "/quality/allocation/samples": typeof AppQualityAllocationSamplesRoute;
  "/quality/blending/$id": typeof AppQualityBlendingIdRoute;
  "/quality/germination/$sampleId": typeof AppQualityGerminationSampleIdRoute;
  "/quality/got/biography": typeof AppQualityGotBiographyRoute;
  "/quality/got/dispatch": typeof AppQualityGotDispatchRoute;
  "/quality/got/low-ppn": typeof AppQualityGotLowPpnRoute;
  "/quality/got/print-sample": typeof AppQualityGotPrintSampleRoute;
  "/quality/guard-samples/move": typeof AppQualityGuardSamplesMoveRoute;
  "/quality/moisture/$sampleId": typeof AppQualityMoistureSampleIdRoute;
  "/quality/pending/$sampleId": typeof AppQualityPendingSampleIdRoute;
  "/quality/pp/$sampleId": typeof AppQualityPpSampleIdRoute;
  "/quality/requests/$requestId": typeof AppQualityRequestsRequestIdRoute;
  "/quality/requests/new": typeof AppQualityRequestsNewRoute;
  "/reports/arrival/$slug": typeof AppReportsArrivalSlugRoute;
  "/reports/csw/$key": typeof AppReportsCswKeyRoute;
  "/reports/dispatch/periodical": typeof AppReportsDispatchPeriodicalRoute;
  "/reports/orders-dispatch/$key": typeof AppReportsOrdersDispatchKeyRoute;
  "/reports/packaging/$slug": typeof AppReportsPackagingSlugRoute;
  "/reports/qc/$slug": typeof AppReportsQcSlugRoute;
  "/reports/rsw/$key": typeof AppReportsRswKeyRoute;
  "/reports/stock/$slug": typeof AppReportsStockSlugRoute;
  "/reports/warehouse/$slug": typeof AppReportsWarehouseSlugRoute;
  "/stores/arrivals/$id": typeof AppStoresArrivalsIdRoute;
  "/stores/arrivals/new": typeof AppStoresArrivalsNewRoute;
  "/stores/corrections/new": typeof AppStoresCorrectionsNewRoute;
  "/stores/docs/$id": typeof AppStoresDocsIdRoute;
  "/stores/indents/$id": typeof AppStoresIndentsIdRoute;
  "/stores/indents/new": typeof AppStoresIndentsNewRoute;
  "/stores/issues/new": typeof AppStoresIssuesNewRoute;
  "/stores/reports/$key": typeof AppStoresReportsKeyRoute;
  "/stores/reports/bin-card": typeof AppStoresReportsBinCardRoute;
  "/stores/sloc/new": typeof AppStoresSlocNewRoute;
  "/warehouse/$stage/lot-biography": typeof AppWarehouseStageLotBiographyRoute;
  "/warehouse/lot-biography/$lotId": typeof AppWarehouseLotBiographyLotIdRoute;
  "/arrivals/$form/": typeof AppArrivalsFormIndexRoute;
  "/arrivals/pp-appearance/": typeof AppArrivalsPpAppearanceIndexRoute;
  "/arrivals/trading/": typeof AppArrivalsTradingIndexRoute;
  "/dispatch/stock-transfer/": typeof AppDispatchStockTransferIndexRoute;
  "/inventory/lots/": typeof AppInventoryLotsIndexRoute;
  "/packaging/fc-packing-slip/": typeof AppPackagingFcPackingSlipIndexRoute;
  "/packaging/ivt/": typeof AppPackagingIvtIndexRoute;
  "/packaging/ofl/": typeof AppPackagingOflIndexRoute;
  "/packaging/p2c/": typeof AppPackagingP2cIndexRoute;
  "/packaging/pack-reprint/": typeof AppPackagingPackReprintIndexRoute;
  "/packaging/packing-slip/": typeof AppPackagingPackingSlipIndexRoute;
  "/packaging/pnp-fc-slip/": typeof AppPackagingPnpFcSlipIndexRoute;
  "/packaging/pnp-slip/": typeof AppPackagingPnpSlipIndexRoute;
  "/packaging/reprint-slip/": typeof AppPackagingReprintSlipIndexRoute;
  "/packaging/root-stock-count/": typeof AppPackagingRootStockCountIndexRoute;
  "/packaging/sathi/": typeof AppPackagingSathiIndexRoute;
  "/packaging/store-indents/": typeof AppPackagingStoreIndentsIndexRoute;
  "/packaging/unpackaging/": typeof AppPackagingUnpackagingIndexRoute;
  "/packaging/wb-packing-slip/": typeof AppPackagingWbPackingSlipIndexRoute;
  "/processing/blending/": typeof AppProcessingBlendingIndexRoute;
  "/processing/color-sort/": typeof AppProcessingColorSortIndexRoute;
  "/processing/drying/": typeof AppProcessingDryingIndexRoute;
  "/processing/packing-slip/": typeof AppProcessingPackingSlipIndexRoute;
  "/processing/pnp-fc-slip/": typeof AppProcessingPnpFcSlipIndexRoute;
  "/processing/priming/": typeof AppProcessingPrimingIndexRoute;
  "/processing/reports/": typeof AppProcessingReportsIndexRoute;
  "/processing/slip/": typeof AppProcessingSlipIndexRoute;
  "/processing/thermal/": typeof AppProcessingThermalIndexRoute;
  "/processing/treatment/": typeof AppProcessingTreatmentIndexRoute;
  "/quality/allocation/": typeof AppQualityAllocationIndexRoute;
  "/quality/barcode-search/": typeof AppQualityBarcodeSearchIndexRoute;
  "/quality/batch-finder/": typeof AppQualityBatchFinderIndexRoute;
  "/quality/blending/": typeof AppQualityBlendingIndexRoute;
  "/quality/damaged-samples/": typeof AppQualityDamagedSamplesIndexRoute;
  "/quality/density/": typeof AppQualityDensityIndexRoute;
  "/quality/dov-calculator/": typeof AppQualityDovCalculatorIndexRoute;
  "/quality/germination/": typeof AppQualityGerminationIndexRoute;
  "/quality/guard-samples/": typeof AppQualityGuardSamplesIndexRoute;
  "/quality/moisture/": typeof AppQualityMoistureIndexRoute;
  "/quality/pending/": typeof AppQualityPendingIndexRoute;
  "/quality/pp/": typeof AppQualityPpIndexRoute;
  "/quality/qc-ageing/": typeof AppQualityQcAgeingIndexRoute;
  "/quality/requests/": typeof AppQualityRequestsIndexRoute;
  "/quality/rt-srf/": typeof AppQualityRtSrfIndexRoute;
  "/quality/standards/": typeof AppQualityStandardsIndexRoute;
  "/reports/arrival/": typeof AppReportsArrivalIndexRoute;
  "/reports/csw/": typeof AppReportsCswIndexRoute;
  "/reports/packaging/": typeof AppReportsPackagingIndexRoute;
  "/reports/rsw/": typeof AppReportsRswIndexRoute;
  "/reports/stock/": typeof AppReportsStockIndexRoute;
  "/reports/warehouse/": typeof AppReportsWarehouseIndexRoute;
  "/rnd/priming/": typeof AppRndPrimingIndexRoute;
  "/stores/arrivals/": typeof AppStoresArrivalsIndexRoute;
  "/stores/corrections/": typeof AppStoresCorrectionsIndexRoute;
  "/stores/counts/": typeof AppStoresCountsIndexRoute;
  "/stores/indents/": typeof AppStoresIndentsIndexRoute;
  "/stores/issues/": typeof AppStoresIssuesIndexRoute;
  "/stores/reports/": typeof AppStoresReportsIndexRoute;
  "/stores/sloc/": typeof AppStoresSlocIndexRoute;
  "/thermal/pending/": typeof AppThermalPendingIndexRoute;
  "/warehouse/lot-biography/": typeof AppWarehouseLotBiographyIndexRoute;
  "/arrivals/$form/$id/details": typeof AppArrivalsFormIdDetailsRoute;
  "/arrivals/trading/$id/details": typeof AppArrivalsTradingIdDetailsRoute;
  "/dispatch/sales/$kind/$id": typeof AppDispatchSalesKindIdRoute;
  "/dispatch/sales/$kind/new": typeof AppDispatchSalesKindNewRoute;
  "/processing/blending/$id/details": typeof AppProcessingBlendingIdDetailsRoute;
  "/quality/got/final-grade/$id": typeof AppQualityGotFinalGradeIdRoute;
  "/quality/got/handover/receive": typeof AppQualityGotHandoverReceiveRoute;
  "/quality/got/handover/report": typeof AppQualityGotHandoverReportRoute;
  "/quality/got/reports/$key": typeof AppQualityGotReportsKeyRoute;
  "/quality/got/review/$sampleId": typeof AppQualityGotReviewSampleIdRoute;
  "/quality/releases/$kind/$releaseId": typeof AppQualityReleasesKindReleaseIdRoute;
  "/quality/releases/$kind/new": typeof AppQualityReleasesKindNewRoute;
  "/warehouse/$stage/batch/new": typeof AppWarehouseStageBatchNewRoute;
  "/warehouse/$stage/release/new": typeof AppWarehouseStageReleaseNewRoute;
  "/warehouse/$stage/reports/$key": typeof AppWarehouseStageReportsKeyRoute;
  "/warehouse/$stage/seed-status/update": typeof AppWarehouseStageSeedStatusUpdateRoute;
  "/warehouse/$stage/sloc/new": typeof AppWarehouseStageSlocNewRoute;
  "/dispatch/sales/$kind/": typeof AppDispatchSalesKindIndexRoute;
  "/quality/got/final-grade/": typeof AppQualityGotFinalGradeIndexRoute;
  "/quality/got/handover/": typeof AppQualityGotHandoverIndexRoute;
  "/quality/got/reports/": typeof AppQualityGotReportsIndexRoute;
  "/quality/got/result-update/": typeof AppQualityGotResultUpdateIndexRoute;
  "/quality/got/review/": typeof AppQualityGotReviewIndexRoute;
  "/quality/releases/$kind/": typeof AppQualityReleasesKindIndexRoute;
  "/warehouse/$stage/batch/": typeof AppWarehouseStageBatchIndexRoute;
  "/warehouse/$stage/release/": typeof AppWarehouseStageReleaseIndexRoute;
  "/warehouse/$stage/reports/": typeof AppWarehouseStageReportsIndexRoute;
  "/warehouse/$stage/seed-status/": typeof AppWarehouseStageSeedStatusIndexRoute;
  "/warehouse/$stage/sloc/": typeof AppWarehouseStageSlocIndexRoute;
  "/quality/got/print/$kind/$dispatchId": typeof AppQualityGotPrintKindDispatchIdRoute;
  "/quality/got/result-update/$sampleId/view": typeof AppQualityGotResultUpdateSampleIdViewRoute;
  "/quality/got/result-update/$sampleId/": typeof AppQualityGotResultUpdateSampleIdIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/handheld": typeof HandheldRoute;
  "/login": typeof LoginRoute;
  "/abbreviations": typeof AppAbbreviationsRoute;
  "/dashboard": typeof AppDashboardRoute;
  "/home": typeof AppHomeRoute;
  "/qc-dashboard": typeof AppQcDashboardRoute;
  "/invite/$token": typeof InviteTokenRoute;
  "/kiosk/packing": typeof KioskPackingRoute;
  "/app": typeof AppIndexRoute;
  "/account/password": typeof AppAccountPasswordRoute;
  "/account/profile": typeof AppAccountProfileRoute;
  "/admin/audit-log": typeof AppAdminAuditLogRoute;
  "/admin/integrations": typeof AppAdminIntegrationsRoute;
  "/admin/roles": typeof AppAdminRolesRoute;
  "/admin/users": typeof AppAdminUsersRoute;
  "/dev/tokens": typeof AppDevTokensRoute;
  "/dispatch/barcode-lookup": typeof AppDispatchBarcodeLookupRoute;
  "/feedback/$id": typeof AppFeedbackIdRoute;
  "/feedback/new": typeof AppFeedbackNewRoute;
  "/inventory/opening": typeof AppInventoryOpeningRoute;
  "/inventory/reconciliation": typeof AppInventoryReconciliationRoute;
  "/inventory/reports": typeof AppInventoryReportsRoute;
  "/inventory/reservations": typeof AppInventoryReservationsRoute;
  "/masters/$key": typeof AppMastersKeyRoute;
  "/masters/api-feed": typeof AppMastersApiFeedRoute;
  "/masters/got-farmers": typeof AppMastersGotFarmersRoute;
  "/masters/got-locations": typeof AppMastersGotLocationsRoute;
  "/masters/got-ppn-standards": typeof AppMastersGotPpnStandardsRoute;
  "/masters/locations": typeof AppMastersLocationsRoute;
  "/masters/mail-settings": typeof AppMastersMailSettingsRoute;
  "/masters/production-personnel": typeof AppMastersProductionPersonnelRoute;
  "/masters/storage-restrictions": typeof AppMastersStorageRestrictionsRoute;
  "/orders/$id": typeof AppOrdersIdRoute;
  "/orders/holds": typeof AppOrdersHoldsRoute;
  "/orders/import": typeof AppOrdersImportRoute;
  "/orders/new": typeof AppOrdersNewRoute;
  "/orders/status": typeof AppOrdersStatusRoute;
  "/reports/high-moisture": typeof AppReportsHighMoistureRoute;
  "/reports/variety-decoding": typeof AppReportsVarietyDecodingRoute;
  "/stores/captive": typeof AppStoresCaptiveRoute;
  "/stores/discard": typeof AppStoresDiscardRoute;
  "/stores/opening": typeof AppStoresOpeningRoute;
  "/stores/reorder": typeof AppStoresReorderRoute;
  "/stores/utility": typeof AppStoresUtilityRoute;
  "/warehouse/sloc": typeof AppWarehouseSlocRoute;
  "/arrivals": typeof AppArrivalsIndexRoute;
  "/dryer": typeof AppDryerIndexRoute;
  "/feedback": typeof AppFeedbackIndexRoute;
  "/gate": typeof AppGateIndexRoute;
  "/inventory": typeof AppInventoryIndexRoute;
  "/orders": typeof AppOrdersIndexRoute;
  "/quality": typeof AppQualityIndexRoute;
  "/reports": typeof AppReportsIndexRoute;
  "/stores": typeof AppStoresIndexRoute;
  "/warehouse": typeof AppWarehouseIndexRoute;
  "/admin/users/$userId": typeof AppAdminUsersUserIdRoute;
  "/arrivals/$form/$id": typeof AppArrivalsFormIdRoute;
  "/arrivals/$form/new": typeof AppArrivalsFormNewRoute;
  "/arrivals/pp-appearance/$sampleId": typeof AppArrivalsPpAppearanceSampleIdRoute;
  "/arrivals/trading/$id": typeof AppArrivalsTradingIdRoute;
  "/arrivals/trading/new": typeof AppArrivalsTradingNewRoute;
  "/dispatch/stock-transfer/$id": typeof AppDispatchStockTransferIdRoute;
  "/dispatch/stock-transfer/new": typeof AppDispatchStockTransferNewRoute;
  "/dryer/$stage/$id": typeof AppDryerStageIdRoute;
  "/gate/pass-in/$id": typeof AppGatePassInIdRoute;
  "/gate/pass-in/new": typeof AppGatePassInNewRoute;
  "/inventory/lots/$lotId": typeof AppInventoryLotsLotIdRoute;
  "/masters/vendors/$id": typeof AppMastersVendorsIdRoute;
  "/masters/vendors/new": typeof AppMastersVendorsNewRoute;
  "/packaging/fc-packing-slip/$id": typeof AppPackagingFcPackingSlipIdRoute;
  "/packaging/fc-packing-slip/new": typeof AppPackagingFcPackingSlipNewRoute;
  "/packaging/ivt/$id": typeof AppPackagingIvtIdRoute;
  "/packaging/ivt/new": typeof AppPackagingIvtNewRoute;
  "/packaging/ofl/$id": typeof AppPackagingOflIdRoute;
  "/packaging/ofl/new": typeof AppPackagingOflNewRoute;
  "/packaging/p2c/$id": typeof AppPackagingP2cIdRoute;
  "/packaging/p2c/new": typeof AppPackagingP2cNewRoute;
  "/packaging/pack-reprint/$id": typeof AppPackagingPackReprintIdRoute;
  "/packaging/pack-reprint/new": typeof AppPackagingPackReprintNewRoute;
  "/packaging/packing-slip/$id": typeof AppPackagingPackingSlipIdRoute;
  "/packaging/packing-slip/new": typeof AppPackagingPackingSlipNewRoute;
  "/packaging/pnp-fc-slip/$id": typeof AppPackagingPnpFcSlipIdRoute;
  "/packaging/reprint-slip/$id": typeof AppPackagingReprintSlipIdRoute;
  "/packaging/reprint-slip/new": typeof AppPackagingReprintSlipNewRoute;
  "/packaging/store-indents/$id": typeof AppPackagingStoreIndentsIdRoute;
  "/packaging/store-indents/new": typeof AppPackagingStoreIndentsNewRoute;
  "/packaging/wb-packing-slip/$id": typeof AppPackagingWbPackingSlipIdRoute;
  "/packaging/wb-packing-slip/new": typeof AppPackagingWbPackingSlipNewRoute;
  "/processing/blending/$id": typeof AppProcessingBlendingIdRoute;
  "/processing/blending/new": typeof AppProcessingBlendingNewRoute;
  "/processing/color-sort/$id": typeof AppProcessingColorSortIdRoute;
  "/processing/color-sort/new": typeof AppProcessingColorSortNewRoute;
  "/processing/drying/$id": typeof AppProcessingDryingIdRoute;
  "/processing/drying/new": typeof AppProcessingDryingNewRoute;
  "/processing/packing-slip/$id": typeof AppProcessingPackingSlipIdRoute;
  "/processing/packing-slip/new": typeof AppProcessingPackingSlipNewRoute;
  "/processing/pnp-fc-slip/$id": typeof AppProcessingPnpFcSlipIdRoute;
  "/processing/pnp-fc-slip/new": typeof AppProcessingPnpFcSlipNewRoute;
  "/processing/priming/$id": typeof AppProcessingPrimingIdRoute;
  "/processing/priming/new": typeof AppProcessingPrimingNewRoute;
  "/processing/reports/$key": typeof AppProcessingReportsKeyRoute;
  "/processing/slip/$id": typeof AppProcessingSlipIdRoute;
  "/processing/slip/new": typeof AppProcessingSlipNewRoute;
  "/processing/thermal/$id": typeof AppProcessingThermalIdRoute;
  "/processing/thermal/new": typeof AppProcessingThermalNewRoute;
  "/processing/treatment/$id": typeof AppProcessingTreatmentIdRoute;
  "/processing/treatment/new": typeof AppProcessingTreatmentNewRoute;
  "/quality/allocation/$srfId": typeof AppQualityAllocationSrfIdRoute;
  "/quality/allocation/monitor": typeof AppQualityAllocationMonitorRoute;
  "/quality/allocation/samples": typeof AppQualityAllocationSamplesRoute;
  "/quality/blending/$id": typeof AppQualityBlendingIdRoute;
  "/quality/germination/$sampleId": typeof AppQualityGerminationSampleIdRoute;
  "/quality/got/biography": typeof AppQualityGotBiographyRoute;
  "/quality/got/dispatch": typeof AppQualityGotDispatchRoute;
  "/quality/got/low-ppn": typeof AppQualityGotLowPpnRoute;
  "/quality/got/print-sample": typeof AppQualityGotPrintSampleRoute;
  "/quality/guard-samples/move": typeof AppQualityGuardSamplesMoveRoute;
  "/quality/moisture/$sampleId": typeof AppQualityMoistureSampleIdRoute;
  "/quality/pending/$sampleId": typeof AppQualityPendingSampleIdRoute;
  "/quality/pp/$sampleId": typeof AppQualityPpSampleIdRoute;
  "/quality/requests/$requestId": typeof AppQualityRequestsRequestIdRoute;
  "/quality/requests/new": typeof AppQualityRequestsNewRoute;
  "/reports/arrival/$slug": typeof AppReportsArrivalSlugRoute;
  "/reports/csw/$key": typeof AppReportsCswKeyRoute;
  "/reports/dispatch/periodical": typeof AppReportsDispatchPeriodicalRoute;
  "/reports/orders-dispatch/$key": typeof AppReportsOrdersDispatchKeyRoute;
  "/reports/packaging/$slug": typeof AppReportsPackagingSlugRoute;
  "/reports/qc/$slug": typeof AppReportsQcSlugRoute;
  "/reports/rsw/$key": typeof AppReportsRswKeyRoute;
  "/reports/stock/$slug": typeof AppReportsStockSlugRoute;
  "/reports/warehouse/$slug": typeof AppReportsWarehouseSlugRoute;
  "/stores/arrivals/$id": typeof AppStoresArrivalsIdRoute;
  "/stores/arrivals/new": typeof AppStoresArrivalsNewRoute;
  "/stores/corrections/new": typeof AppStoresCorrectionsNewRoute;
  "/stores/docs/$id": typeof AppStoresDocsIdRoute;
  "/stores/indents/$id": typeof AppStoresIndentsIdRoute;
  "/stores/indents/new": typeof AppStoresIndentsNewRoute;
  "/stores/issues/new": typeof AppStoresIssuesNewRoute;
  "/stores/reports/$key": typeof AppStoresReportsKeyRoute;
  "/stores/reports/bin-card": typeof AppStoresReportsBinCardRoute;
  "/stores/sloc/new": typeof AppStoresSlocNewRoute;
  "/warehouse/$stage/lot-biography": typeof AppWarehouseStageLotBiographyRoute;
  "/warehouse/lot-biography/$lotId": typeof AppWarehouseLotBiographyLotIdRoute;
  "/arrivals/$form": typeof AppArrivalsFormIndexRoute;
  "/arrivals/pp-appearance": typeof AppArrivalsPpAppearanceIndexRoute;
  "/arrivals/trading": typeof AppArrivalsTradingIndexRoute;
  "/dispatch/stock-transfer": typeof AppDispatchStockTransferIndexRoute;
  "/inventory/lots": typeof AppInventoryLotsIndexRoute;
  "/packaging/fc-packing-slip": typeof AppPackagingFcPackingSlipIndexRoute;
  "/packaging/ivt": typeof AppPackagingIvtIndexRoute;
  "/packaging/ofl": typeof AppPackagingOflIndexRoute;
  "/packaging/p2c": typeof AppPackagingP2cIndexRoute;
  "/packaging/pack-reprint": typeof AppPackagingPackReprintIndexRoute;
  "/packaging/packing-slip": typeof AppPackagingPackingSlipIndexRoute;
  "/packaging/pnp-fc-slip": typeof AppPackagingPnpFcSlipIndexRoute;
  "/packaging/pnp-slip": typeof AppPackagingPnpSlipIndexRoute;
  "/packaging/reprint-slip": typeof AppPackagingReprintSlipIndexRoute;
  "/packaging/root-stock-count": typeof AppPackagingRootStockCountIndexRoute;
  "/packaging/sathi": typeof AppPackagingSathiIndexRoute;
  "/packaging/store-indents": typeof AppPackagingStoreIndentsIndexRoute;
  "/packaging/unpackaging": typeof AppPackagingUnpackagingIndexRoute;
  "/packaging/wb-packing-slip": typeof AppPackagingWbPackingSlipIndexRoute;
  "/processing/blending": typeof AppProcessingBlendingIndexRoute;
  "/processing/color-sort": typeof AppProcessingColorSortIndexRoute;
  "/processing/drying": typeof AppProcessingDryingIndexRoute;
  "/processing/packing-slip": typeof AppProcessingPackingSlipIndexRoute;
  "/processing/pnp-fc-slip": typeof AppProcessingPnpFcSlipIndexRoute;
  "/processing/priming": typeof AppProcessingPrimingIndexRoute;
  "/processing/reports": typeof AppProcessingReportsIndexRoute;
  "/processing/slip": typeof AppProcessingSlipIndexRoute;
  "/processing/thermal": typeof AppProcessingThermalIndexRoute;
  "/processing/treatment": typeof AppProcessingTreatmentIndexRoute;
  "/quality/allocation": typeof AppQualityAllocationIndexRoute;
  "/quality/barcode-search": typeof AppQualityBarcodeSearchIndexRoute;
  "/quality/batch-finder": typeof AppQualityBatchFinderIndexRoute;
  "/quality/blending": typeof AppQualityBlendingIndexRoute;
  "/quality/damaged-samples": typeof AppQualityDamagedSamplesIndexRoute;
  "/quality/density": typeof AppQualityDensityIndexRoute;
  "/quality/dov-calculator": typeof AppQualityDovCalculatorIndexRoute;
  "/quality/germination": typeof AppQualityGerminationIndexRoute;
  "/quality/guard-samples": typeof AppQualityGuardSamplesIndexRoute;
  "/quality/moisture": typeof AppQualityMoistureIndexRoute;
  "/quality/pending": typeof AppQualityPendingIndexRoute;
  "/quality/pp": typeof AppQualityPpIndexRoute;
  "/quality/qc-ageing": typeof AppQualityQcAgeingIndexRoute;
  "/quality/requests": typeof AppQualityRequestsIndexRoute;
  "/quality/rt-srf": typeof AppQualityRtSrfIndexRoute;
  "/quality/standards": typeof AppQualityStandardsIndexRoute;
  "/reports/arrival": typeof AppReportsArrivalIndexRoute;
  "/reports/csw": typeof AppReportsCswIndexRoute;
  "/reports/packaging": typeof AppReportsPackagingIndexRoute;
  "/reports/rsw": typeof AppReportsRswIndexRoute;
  "/reports/stock": typeof AppReportsStockIndexRoute;
  "/reports/warehouse": typeof AppReportsWarehouseIndexRoute;
  "/rnd/priming": typeof AppRndPrimingIndexRoute;
  "/stores/arrivals": typeof AppStoresArrivalsIndexRoute;
  "/stores/corrections": typeof AppStoresCorrectionsIndexRoute;
  "/stores/counts": typeof AppStoresCountsIndexRoute;
  "/stores/indents": typeof AppStoresIndentsIndexRoute;
  "/stores/issues": typeof AppStoresIssuesIndexRoute;
  "/stores/reports": typeof AppStoresReportsIndexRoute;
  "/stores/sloc": typeof AppStoresSlocIndexRoute;
  "/thermal/pending": typeof AppThermalPendingIndexRoute;
  "/warehouse/lot-biography": typeof AppWarehouseLotBiographyIndexRoute;
  "/arrivals/$form/$id/details": typeof AppArrivalsFormIdDetailsRoute;
  "/arrivals/trading/$id/details": typeof AppArrivalsTradingIdDetailsRoute;
  "/dispatch/sales/$kind/$id": typeof AppDispatchSalesKindIdRoute;
  "/dispatch/sales/$kind/new": typeof AppDispatchSalesKindNewRoute;
  "/processing/blending/$id/details": typeof AppProcessingBlendingIdDetailsRoute;
  "/quality/got/final-grade/$id": typeof AppQualityGotFinalGradeIdRoute;
  "/quality/got/handover/receive": typeof AppQualityGotHandoverReceiveRoute;
  "/quality/got/handover/report": typeof AppQualityGotHandoverReportRoute;
  "/quality/got/reports/$key": typeof AppQualityGotReportsKeyRoute;
  "/quality/got/review/$sampleId": typeof AppQualityGotReviewSampleIdRoute;
  "/quality/releases/$kind/$releaseId": typeof AppQualityReleasesKindReleaseIdRoute;
  "/quality/releases/$kind/new": typeof AppQualityReleasesKindNewRoute;
  "/warehouse/$stage/batch/new": typeof AppWarehouseStageBatchNewRoute;
  "/warehouse/$stage/release/new": typeof AppWarehouseStageReleaseNewRoute;
  "/warehouse/$stage/reports/$key": typeof AppWarehouseStageReportsKeyRoute;
  "/warehouse/$stage/seed-status/update": typeof AppWarehouseStageSeedStatusUpdateRoute;
  "/warehouse/$stage/sloc/new": typeof AppWarehouseStageSlocNewRoute;
  "/dispatch/sales/$kind": typeof AppDispatchSalesKindIndexRoute;
  "/quality/got/final-grade": typeof AppQualityGotFinalGradeIndexRoute;
  "/quality/got/handover": typeof AppQualityGotHandoverIndexRoute;
  "/quality/got/reports": typeof AppQualityGotReportsIndexRoute;
  "/quality/got/result-update": typeof AppQualityGotResultUpdateIndexRoute;
  "/quality/got/review": typeof AppQualityGotReviewIndexRoute;
  "/quality/releases/$kind": typeof AppQualityReleasesKindIndexRoute;
  "/warehouse/$stage/batch": typeof AppWarehouseStageBatchIndexRoute;
  "/warehouse/$stage/release": typeof AppWarehouseStageReleaseIndexRoute;
  "/warehouse/$stage/reports": typeof AppWarehouseStageReportsIndexRoute;
  "/warehouse/$stage/seed-status": typeof AppWarehouseStageSeedStatusIndexRoute;
  "/warehouse/$stage/sloc": typeof AppWarehouseStageSlocIndexRoute;
  "/quality/got/print/$kind/$dispatchId": typeof AppQualityGotPrintKindDispatchIdRoute;
  "/quality/got/result-update/$sampleId/view": typeof AppQualityGotResultUpdateSampleIdViewRoute;
  "/quality/got/result-update/$sampleId": typeof AppQualityGotResultUpdateSampleIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_app": typeof AppRouteWithChildren;
  "/forgot-password": typeof ForgotPasswordRoute;
  "/handheld": typeof HandheldRoute;
  "/login": typeof LoginRoute;
  "/_app/abbreviations": typeof AppAbbreviationsRoute;
  "/_app/dashboard": typeof AppDashboardRoute;
  "/_app/home": typeof AppHomeRoute;
  "/_app/qc-dashboard": typeof AppQcDashboardRoute;
  "/invite/$token": typeof InviteTokenRoute;
  "/kiosk/packing": typeof KioskPackingRoute;
  "/app/": typeof AppIndexRoute;
  "/_app/account/password": typeof AppAccountPasswordRoute;
  "/_app/account/profile": typeof AppAccountProfileRoute;
  "/_app/admin/audit-log": typeof AppAdminAuditLogRoute;
  "/_app/admin/integrations": typeof AppAdminIntegrationsRoute;
  "/_app/admin/roles": typeof AppAdminRolesRoute;
  "/_app/admin/users": typeof AppAdminUsersRoute;
  "/_app/dev/tokens": typeof AppDevTokensRoute;
  "/_app/dispatch/barcode-lookup": typeof AppDispatchBarcodeLookupRoute;
  "/_app/feedback/$id": typeof AppFeedbackIdRoute;
  "/_app/feedback/new": typeof AppFeedbackNewRoute;
  "/_app/inventory/opening": typeof AppInventoryOpeningRoute;
  "/_app/inventory/reconciliation": typeof AppInventoryReconciliationRoute;
  "/_app/inventory/reports": typeof AppInventoryReportsRoute;
  "/_app/inventory/reservations": typeof AppInventoryReservationsRoute;
  "/_app/masters/$key": typeof AppMastersKeyRoute;
  "/_app/masters/api-feed": typeof AppMastersApiFeedRoute;
  "/_app/masters/got-farmers": typeof AppMastersGotFarmersRoute;
  "/_app/masters/got-locations": typeof AppMastersGotLocationsRoute;
  "/_app/masters/got-ppn-standards": typeof AppMastersGotPpnStandardsRoute;
  "/_app/masters/locations": typeof AppMastersLocationsRoute;
  "/_app/masters/mail-settings": typeof AppMastersMailSettingsRoute;
  "/_app/masters/production-personnel": typeof AppMastersProductionPersonnelRoute;
  "/_app/masters/storage-restrictions": typeof AppMastersStorageRestrictionsRoute;
  "/_app/orders/$id": typeof AppOrdersIdRoute;
  "/_app/orders/holds": typeof AppOrdersHoldsRoute;
  "/_app/orders/import": typeof AppOrdersImportRoute;
  "/_app/orders/new": typeof AppOrdersNewRoute;
  "/_app/orders/status": typeof AppOrdersStatusRoute;
  "/_app/reports/high-moisture": typeof AppReportsHighMoistureRoute;
  "/_app/reports/variety-decoding": typeof AppReportsVarietyDecodingRoute;
  "/_app/stores/captive": typeof AppStoresCaptiveRoute;
  "/_app/stores/discard": typeof AppStoresDiscardRoute;
  "/_app/stores/opening": typeof AppStoresOpeningRoute;
  "/_app/stores/reorder": typeof AppStoresReorderRoute;
  "/_app/stores/utility": typeof AppStoresUtilityRoute;
  "/_app/warehouse/sloc": typeof AppWarehouseSlocRoute;
  "/_app/arrivals/": typeof AppArrivalsIndexRoute;
  "/_app/dryer/": typeof AppDryerIndexRoute;
  "/_app/feedback/": typeof AppFeedbackIndexRoute;
  "/_app/gate/": typeof AppGateIndexRoute;
  "/_app/inventory/": typeof AppInventoryIndexRoute;
  "/_app/orders/": typeof AppOrdersIndexRoute;
  "/_app/quality/": typeof AppQualityIndexRoute;
  "/_app/reports/": typeof AppReportsIndexRoute;
  "/_app/stores/": typeof AppStoresIndexRoute;
  "/_app/warehouse/": typeof AppWarehouseIndexRoute;
  "/_app/admin/users_/$userId": typeof AppAdminUsersUserIdRoute;
  "/_app/arrivals/$form/$id": typeof AppArrivalsFormIdRoute;
  "/_app/arrivals/$form/new": typeof AppArrivalsFormNewRoute;
  "/_app/arrivals/pp-appearance/$sampleId": typeof AppArrivalsPpAppearanceSampleIdRoute;
  "/_app/arrivals/trading/$id": typeof AppArrivalsTradingIdRoute;
  "/_app/arrivals/trading/new": typeof AppArrivalsTradingNewRoute;
  "/_app/dispatch/stock-transfer/$id": typeof AppDispatchStockTransferIdRoute;
  "/_app/dispatch/stock-transfer/new": typeof AppDispatchStockTransferNewRoute;
  "/_app/dryer/$stage/$id": typeof AppDryerStageIdRoute;
  "/_app/gate/pass-in/$id": typeof AppGatePassInIdRoute;
  "/_app/gate/pass-in/new": typeof AppGatePassInNewRoute;
  "/_app/inventory/lots/$lotId": typeof AppInventoryLotsLotIdRoute;
  "/_app/masters/vendors/$id": typeof AppMastersVendorsIdRoute;
  "/_app/masters/vendors/new": typeof AppMastersVendorsNewRoute;
  "/_app/packaging/fc-packing-slip/$id": typeof AppPackagingFcPackingSlipIdRoute;
  "/_app/packaging/fc-packing-slip/new": typeof AppPackagingFcPackingSlipNewRoute;
  "/_app/packaging/ivt/$id": typeof AppPackagingIvtIdRoute;
  "/_app/packaging/ivt/new": typeof AppPackagingIvtNewRoute;
  "/_app/packaging/ofl/$id": typeof AppPackagingOflIdRoute;
  "/_app/packaging/ofl/new": typeof AppPackagingOflNewRoute;
  "/_app/packaging/p2c/$id": typeof AppPackagingP2cIdRoute;
  "/_app/packaging/p2c/new": typeof AppPackagingP2cNewRoute;
  "/_app/packaging/pack-reprint/$id": typeof AppPackagingPackReprintIdRoute;
  "/_app/packaging/pack-reprint/new": typeof AppPackagingPackReprintNewRoute;
  "/_app/packaging/packing-slip/$id": typeof AppPackagingPackingSlipIdRoute;
  "/_app/packaging/packing-slip/new": typeof AppPackagingPackingSlipNewRoute;
  "/_app/packaging/pnp-fc-slip/$id": typeof AppPackagingPnpFcSlipIdRoute;
  "/_app/packaging/reprint-slip/$id": typeof AppPackagingReprintSlipIdRoute;
  "/_app/packaging/reprint-slip/new": typeof AppPackagingReprintSlipNewRoute;
  "/_app/packaging/store-indents/$id": typeof AppPackagingStoreIndentsIdRoute;
  "/_app/packaging/store-indents/new": typeof AppPackagingStoreIndentsNewRoute;
  "/_app/packaging/wb-packing-slip/$id": typeof AppPackagingWbPackingSlipIdRoute;
  "/_app/packaging/wb-packing-slip/new": typeof AppPackagingWbPackingSlipNewRoute;
  "/_app/processing/blending/$id": typeof AppProcessingBlendingIdRoute;
  "/_app/processing/blending/new": typeof AppProcessingBlendingNewRoute;
  "/_app/processing/color-sort/$id": typeof AppProcessingColorSortIdRoute;
  "/_app/processing/color-sort/new": typeof AppProcessingColorSortNewRoute;
  "/_app/processing/drying/$id": typeof AppProcessingDryingIdRoute;
  "/_app/processing/drying/new": typeof AppProcessingDryingNewRoute;
  "/_app/processing/packing-slip/$id": typeof AppProcessingPackingSlipIdRoute;
  "/_app/processing/packing-slip/new": typeof AppProcessingPackingSlipNewRoute;
  "/_app/processing/pnp-fc-slip/$id": typeof AppProcessingPnpFcSlipIdRoute;
  "/_app/processing/pnp-fc-slip/new": typeof AppProcessingPnpFcSlipNewRoute;
  "/_app/processing/priming/$id": typeof AppProcessingPrimingIdRoute;
  "/_app/processing/priming/new": typeof AppProcessingPrimingNewRoute;
  "/_app/processing/reports/$key": typeof AppProcessingReportsKeyRoute;
  "/_app/processing/slip/$id": typeof AppProcessingSlipIdRoute;
  "/_app/processing/slip/new": typeof AppProcessingSlipNewRoute;
  "/_app/processing/thermal/$id": typeof AppProcessingThermalIdRoute;
  "/_app/processing/thermal/new": typeof AppProcessingThermalNewRoute;
  "/_app/processing/treatment/$id": typeof AppProcessingTreatmentIdRoute;
  "/_app/processing/treatment/new": typeof AppProcessingTreatmentNewRoute;
  "/_app/quality/allocation/$srfId": typeof AppQualityAllocationSrfIdRoute;
  "/_app/quality/allocation/monitor": typeof AppQualityAllocationMonitorRoute;
  "/_app/quality/allocation/samples": typeof AppQualityAllocationSamplesRoute;
  "/_app/quality/blending/$id": typeof AppQualityBlendingIdRoute;
  "/_app/quality/germination/$sampleId": typeof AppQualityGerminationSampleIdRoute;
  "/_app/quality/got/biography": typeof AppQualityGotBiographyRoute;
  "/_app/quality/got/dispatch": typeof AppQualityGotDispatchRoute;
  "/_app/quality/got/low-ppn": typeof AppQualityGotLowPpnRoute;
  "/_app/quality/got/print-sample": typeof AppQualityGotPrintSampleRoute;
  "/_app/quality/guard-samples/move": typeof AppQualityGuardSamplesMoveRoute;
  "/_app/quality/moisture/$sampleId": typeof AppQualityMoistureSampleIdRoute;
  "/_app/quality/pending/$sampleId": typeof AppQualityPendingSampleIdRoute;
  "/_app/quality/pp/$sampleId": typeof AppQualityPpSampleIdRoute;
  "/_app/quality/requests/$requestId": typeof AppQualityRequestsRequestIdRoute;
  "/_app/quality/requests/new": typeof AppQualityRequestsNewRoute;
  "/_app/reports/arrival/$slug": typeof AppReportsArrivalSlugRoute;
  "/_app/reports/csw/$key": typeof AppReportsCswKeyRoute;
  "/_app/reports/dispatch/periodical": typeof AppReportsDispatchPeriodicalRoute;
  "/_app/reports/orders-dispatch/$key": typeof AppReportsOrdersDispatchKeyRoute;
  "/_app/reports/packaging/$slug": typeof AppReportsPackagingSlugRoute;
  "/_app/reports/qc/$slug": typeof AppReportsQcSlugRoute;
  "/_app/reports/rsw/$key": typeof AppReportsRswKeyRoute;
  "/_app/reports/stock/$slug": typeof AppReportsStockSlugRoute;
  "/_app/reports/warehouse/$slug": typeof AppReportsWarehouseSlugRoute;
  "/_app/stores/arrivals/$id": typeof AppStoresArrivalsIdRoute;
  "/_app/stores/arrivals/new": typeof AppStoresArrivalsNewRoute;
  "/_app/stores/corrections/new": typeof AppStoresCorrectionsNewRoute;
  "/_app/stores/docs/$id": typeof AppStoresDocsIdRoute;
  "/_app/stores/indents/$id": typeof AppStoresIndentsIdRoute;
  "/_app/stores/indents/new": typeof AppStoresIndentsNewRoute;
  "/_app/stores/issues/new": typeof AppStoresIssuesNewRoute;
  "/_app/stores/reports/$key": typeof AppStoresReportsKeyRoute;
  "/_app/stores/reports/bin-card": typeof AppStoresReportsBinCardRoute;
  "/_app/stores/sloc/new": typeof AppStoresSlocNewRoute;
  "/_app/warehouse/$stage/lot-biography": typeof AppWarehouseStageLotBiographyRoute;
  "/_app/warehouse/lot-biography/$lotId": typeof AppWarehouseLotBiographyLotIdRoute;
  "/_app/arrivals/$form/": typeof AppArrivalsFormIndexRoute;
  "/_app/arrivals/pp-appearance/": typeof AppArrivalsPpAppearanceIndexRoute;
  "/_app/arrivals/trading/": typeof AppArrivalsTradingIndexRoute;
  "/_app/dispatch/stock-transfer/": typeof AppDispatchStockTransferIndexRoute;
  "/_app/inventory/lots/": typeof AppInventoryLotsIndexRoute;
  "/_app/packaging/fc-packing-slip/": typeof AppPackagingFcPackingSlipIndexRoute;
  "/_app/packaging/ivt/": typeof AppPackagingIvtIndexRoute;
  "/_app/packaging/ofl/": typeof AppPackagingOflIndexRoute;
  "/_app/packaging/p2c/": typeof AppPackagingP2cIndexRoute;
  "/_app/packaging/pack-reprint/": typeof AppPackagingPackReprintIndexRoute;
  "/_app/packaging/packing-slip/": typeof AppPackagingPackingSlipIndexRoute;
  "/_app/packaging/pnp-fc-slip/": typeof AppPackagingPnpFcSlipIndexRoute;
  "/_app/packaging/pnp-slip/": typeof AppPackagingPnpSlipIndexRoute;
  "/_app/packaging/reprint-slip/": typeof AppPackagingReprintSlipIndexRoute;
  "/_app/packaging/root-stock-count/": typeof AppPackagingRootStockCountIndexRoute;
  "/_app/packaging/sathi/": typeof AppPackagingSathiIndexRoute;
  "/_app/packaging/store-indents/": typeof AppPackagingStoreIndentsIndexRoute;
  "/_app/packaging/unpackaging/": typeof AppPackagingUnpackagingIndexRoute;
  "/_app/packaging/wb-packing-slip/": typeof AppPackagingWbPackingSlipIndexRoute;
  "/_app/processing/blending/": typeof AppProcessingBlendingIndexRoute;
  "/_app/processing/color-sort/": typeof AppProcessingColorSortIndexRoute;
  "/_app/processing/drying/": typeof AppProcessingDryingIndexRoute;
  "/_app/processing/packing-slip/": typeof AppProcessingPackingSlipIndexRoute;
  "/_app/processing/pnp-fc-slip/": typeof AppProcessingPnpFcSlipIndexRoute;
  "/_app/processing/priming/": typeof AppProcessingPrimingIndexRoute;
  "/_app/processing/reports/": typeof AppProcessingReportsIndexRoute;
  "/_app/processing/slip/": typeof AppProcessingSlipIndexRoute;
  "/_app/processing/thermal/": typeof AppProcessingThermalIndexRoute;
  "/_app/processing/treatment/": typeof AppProcessingTreatmentIndexRoute;
  "/_app/quality/allocation/": typeof AppQualityAllocationIndexRoute;
  "/_app/quality/barcode-search/": typeof AppQualityBarcodeSearchIndexRoute;
  "/_app/quality/batch-finder/": typeof AppQualityBatchFinderIndexRoute;
  "/_app/quality/blending/": typeof AppQualityBlendingIndexRoute;
  "/_app/quality/damaged-samples/": typeof AppQualityDamagedSamplesIndexRoute;
  "/_app/quality/density/": typeof AppQualityDensityIndexRoute;
  "/_app/quality/dov-calculator/": typeof AppQualityDovCalculatorIndexRoute;
  "/_app/quality/germination/": typeof AppQualityGerminationIndexRoute;
  "/_app/quality/guard-samples/": typeof AppQualityGuardSamplesIndexRoute;
  "/_app/quality/moisture/": typeof AppQualityMoistureIndexRoute;
  "/_app/quality/pending/": typeof AppQualityPendingIndexRoute;
  "/_app/quality/pp/": typeof AppQualityPpIndexRoute;
  "/_app/quality/qc-ageing/": typeof AppQualityQcAgeingIndexRoute;
  "/_app/quality/requests/": typeof AppQualityRequestsIndexRoute;
  "/_app/quality/rt-srf/": typeof AppQualityRtSrfIndexRoute;
  "/_app/quality/standards/": typeof AppQualityStandardsIndexRoute;
  "/_app/reports/arrival/": typeof AppReportsArrivalIndexRoute;
  "/_app/reports/csw/": typeof AppReportsCswIndexRoute;
  "/_app/reports/packaging/": typeof AppReportsPackagingIndexRoute;
  "/_app/reports/rsw/": typeof AppReportsRswIndexRoute;
  "/_app/reports/stock/": typeof AppReportsStockIndexRoute;
  "/_app/reports/warehouse/": typeof AppReportsWarehouseIndexRoute;
  "/_app/rnd/priming/": typeof AppRndPrimingIndexRoute;
  "/_app/stores/arrivals/": typeof AppStoresArrivalsIndexRoute;
  "/_app/stores/corrections/": typeof AppStoresCorrectionsIndexRoute;
  "/_app/stores/counts/": typeof AppStoresCountsIndexRoute;
  "/_app/stores/indents/": typeof AppStoresIndentsIndexRoute;
  "/_app/stores/issues/": typeof AppStoresIssuesIndexRoute;
  "/_app/stores/reports/": typeof AppStoresReportsIndexRoute;
  "/_app/stores/sloc/": typeof AppStoresSlocIndexRoute;
  "/_app/thermal/pending/": typeof AppThermalPendingIndexRoute;
  "/_app/warehouse/lot-biography/": typeof AppWarehouseLotBiographyIndexRoute;
  "/_app/arrivals/$form/$id_/details": typeof AppArrivalsFormIdDetailsRoute;
  "/_app/arrivals/trading/$id_/details": typeof AppArrivalsTradingIdDetailsRoute;
  "/_app/dispatch/sales/$kind/$id": typeof AppDispatchSalesKindIdRoute;
  "/_app/dispatch/sales/$kind/new": typeof AppDispatchSalesKindNewRoute;
  "/_app/processing/blending/$id_/details": typeof AppProcessingBlendingIdDetailsRoute;
  "/_app/quality/got/final-grade/$id": typeof AppQualityGotFinalGradeIdRoute;
  "/_app/quality/got/handover/receive": typeof AppQualityGotHandoverReceiveRoute;
  "/_app/quality/got/handover/report": typeof AppQualityGotHandoverReportRoute;
  "/_app/quality/got/reports/$key": typeof AppQualityGotReportsKeyRoute;
  "/_app/quality/got/review/$sampleId": typeof AppQualityGotReviewSampleIdRoute;
  "/_app/quality/releases/$kind/$releaseId": typeof AppQualityReleasesKindReleaseIdRoute;
  "/_app/quality/releases/$kind/new": typeof AppQualityReleasesKindNewRoute;
  "/_app/warehouse/$stage/batch/new": typeof AppWarehouseStageBatchNewRoute;
  "/_app/warehouse/$stage/release/new": typeof AppWarehouseStageReleaseNewRoute;
  "/_app/warehouse/$stage/reports/$key": typeof AppWarehouseStageReportsKeyRoute;
  "/_app/warehouse/$stage/seed-status/update": typeof AppWarehouseStageSeedStatusUpdateRoute;
  "/_app/warehouse/$stage/sloc/new": typeof AppWarehouseStageSlocNewRoute;
  "/_app/dispatch/sales/$kind/": typeof AppDispatchSalesKindIndexRoute;
  "/_app/quality/got/final-grade/": typeof AppQualityGotFinalGradeIndexRoute;
  "/_app/quality/got/handover/": typeof AppQualityGotHandoverIndexRoute;
  "/_app/quality/got/reports/": typeof AppQualityGotReportsIndexRoute;
  "/_app/quality/got/result-update/": typeof AppQualityGotResultUpdateIndexRoute;
  "/_app/quality/got/review/": typeof AppQualityGotReviewIndexRoute;
  "/_app/quality/releases/$kind/": typeof AppQualityReleasesKindIndexRoute;
  "/_app/warehouse/$stage/batch/": typeof AppWarehouseStageBatchIndexRoute;
  "/_app/warehouse/$stage/release/": typeof AppWarehouseStageReleaseIndexRoute;
  "/_app/warehouse/$stage/reports/": typeof AppWarehouseStageReportsIndexRoute;
  "/_app/warehouse/$stage/seed-status/": typeof AppWarehouseStageSeedStatusIndexRoute;
  "/_app/warehouse/$stage/sloc/": typeof AppWarehouseStageSlocIndexRoute;
  "/_app/quality/got/print/$kind/$dispatchId": typeof AppQualityGotPrintKindDispatchIdRoute;
  "/_app/quality/got/result-update/$sampleId/view": typeof AppQualityGotResultUpdateSampleIdViewRoute;
  "/_app/quality/got/result-update/$sampleId/": typeof AppQualityGotResultUpdateSampleIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/forgot-password"
    | "/handheld"
    | "/login"
    | "/abbreviations"
    | "/dashboard"
    | "/home"
    | "/qc-dashboard"
    | "/invite/$token"
    | "/kiosk/packing"
    | "/app/"
    | "/account/password"
    | "/account/profile"
    | "/admin/audit-log"
    | "/admin/integrations"
    | "/admin/roles"
    | "/admin/users"
    | "/dev/tokens"
    | "/dispatch/barcode-lookup"
    | "/feedback/$id"
    | "/feedback/new"
    | "/inventory/opening"
    | "/inventory/reconciliation"
    | "/inventory/reports"
    | "/inventory/reservations"
    | "/masters/$key"
    | "/masters/api-feed"
    | "/masters/got-farmers"
    | "/masters/got-locations"
    | "/masters/got-ppn-standards"
    | "/masters/locations"
    | "/masters/mail-settings"
    | "/masters/production-personnel"
    | "/masters/storage-restrictions"
    | "/orders/$id"
    | "/orders/holds"
    | "/orders/import"
    | "/orders/new"
    | "/orders/status"
    | "/reports/high-moisture"
    | "/reports/variety-decoding"
    | "/stores/captive"
    | "/stores/discard"
    | "/stores/opening"
    | "/stores/reorder"
    | "/stores/utility"
    | "/warehouse/sloc"
    | "/arrivals/"
    | "/dryer/"
    | "/feedback/"
    | "/gate/"
    | "/inventory/"
    | "/orders/"
    | "/quality/"
    | "/reports/"
    | "/stores/"
    | "/warehouse/"
    | "/admin/users/$userId"
    | "/arrivals/$form/$id"
    | "/arrivals/$form/new"
    | "/arrivals/pp-appearance/$sampleId"
    | "/arrivals/trading/$id"
    | "/arrivals/trading/new"
    | "/dispatch/stock-transfer/$id"
    | "/dispatch/stock-transfer/new"
    | "/dryer/$stage/$id"
    | "/gate/pass-in/$id"
    | "/gate/pass-in/new"
    | "/inventory/lots/$lotId"
    | "/masters/vendors/$id"
    | "/masters/vendors/new"
    | "/packaging/fc-packing-slip/$id"
    | "/packaging/fc-packing-slip/new"
    | "/packaging/ivt/$id"
    | "/packaging/ivt/new"
    | "/packaging/ofl/$id"
    | "/packaging/ofl/new"
    | "/packaging/p2c/$id"
    | "/packaging/p2c/new"
    | "/packaging/pack-reprint/$id"
    | "/packaging/pack-reprint/new"
    | "/packaging/packing-slip/$id"
    | "/packaging/packing-slip/new"
    | "/packaging/pnp-fc-slip/$id"
    | "/packaging/reprint-slip/$id"
    | "/packaging/reprint-slip/new"
    | "/packaging/store-indents/$id"
    | "/packaging/store-indents/new"
    | "/packaging/wb-packing-slip/$id"
    | "/packaging/wb-packing-slip/new"
    | "/processing/blending/$id"
    | "/processing/blending/new"
    | "/processing/color-sort/$id"
    | "/processing/color-sort/new"
    | "/processing/drying/$id"
    | "/processing/drying/new"
    | "/processing/packing-slip/$id"
    | "/processing/packing-slip/new"
    | "/processing/pnp-fc-slip/$id"
    | "/processing/pnp-fc-slip/new"
    | "/processing/priming/$id"
    | "/processing/priming/new"
    | "/processing/reports/$key"
    | "/processing/slip/$id"
    | "/processing/slip/new"
    | "/processing/thermal/$id"
    | "/processing/thermal/new"
    | "/processing/treatment/$id"
    | "/processing/treatment/new"
    | "/quality/allocation/$srfId"
    | "/quality/allocation/monitor"
    | "/quality/allocation/samples"
    | "/quality/blending/$id"
    | "/quality/germination/$sampleId"
    | "/quality/got/biography"
    | "/quality/got/dispatch"
    | "/quality/got/low-ppn"
    | "/quality/got/print-sample"
    | "/quality/guard-samples/move"
    | "/quality/moisture/$sampleId"
    | "/quality/pending/$sampleId"
    | "/quality/pp/$sampleId"
    | "/quality/requests/$requestId"
    | "/quality/requests/new"
    | "/reports/arrival/$slug"
    | "/reports/csw/$key"
    | "/reports/dispatch/periodical"
    | "/reports/orders-dispatch/$key"
    | "/reports/packaging/$slug"
    | "/reports/qc/$slug"
    | "/reports/rsw/$key"
    | "/reports/stock/$slug"
    | "/reports/warehouse/$slug"
    | "/stores/arrivals/$id"
    | "/stores/arrivals/new"
    | "/stores/corrections/new"
    | "/stores/docs/$id"
    | "/stores/indents/$id"
    | "/stores/indents/new"
    | "/stores/issues/new"
    | "/stores/reports/$key"
    | "/stores/reports/bin-card"
    | "/stores/sloc/new"
    | "/warehouse/$stage/lot-biography"
    | "/warehouse/lot-biography/$lotId"
    | "/arrivals/$form/"
    | "/arrivals/pp-appearance/"
    | "/arrivals/trading/"
    | "/dispatch/stock-transfer/"
    | "/inventory/lots/"
    | "/packaging/fc-packing-slip/"
    | "/packaging/ivt/"
    | "/packaging/ofl/"
    | "/packaging/p2c/"
    | "/packaging/pack-reprint/"
    | "/packaging/packing-slip/"
    | "/packaging/pnp-fc-slip/"
    | "/packaging/pnp-slip/"
    | "/packaging/reprint-slip/"
    | "/packaging/root-stock-count/"
    | "/packaging/sathi/"
    | "/packaging/store-indents/"
    | "/packaging/unpackaging/"
    | "/packaging/wb-packing-slip/"
    | "/processing/blending/"
    | "/processing/color-sort/"
    | "/processing/drying/"
    | "/processing/packing-slip/"
    | "/processing/pnp-fc-slip/"
    | "/processing/priming/"
    | "/processing/reports/"
    | "/processing/slip/"
    | "/processing/thermal/"
    | "/processing/treatment/"
    | "/quality/allocation/"
    | "/quality/barcode-search/"
    | "/quality/batch-finder/"
    | "/quality/blending/"
    | "/quality/damaged-samples/"
    | "/quality/density/"
    | "/quality/dov-calculator/"
    | "/quality/germination/"
    | "/quality/guard-samples/"
    | "/quality/moisture/"
    | "/quality/pending/"
    | "/quality/pp/"
    | "/quality/qc-ageing/"
    | "/quality/requests/"
    | "/quality/rt-srf/"
    | "/quality/standards/"
    | "/reports/arrival/"
    | "/reports/csw/"
    | "/reports/packaging/"
    | "/reports/rsw/"
    | "/reports/stock/"
    | "/reports/warehouse/"
    | "/rnd/priming/"
    | "/stores/arrivals/"
    | "/stores/corrections/"
    | "/stores/counts/"
    | "/stores/indents/"
    | "/stores/issues/"
    | "/stores/reports/"
    | "/stores/sloc/"
    | "/thermal/pending/"
    | "/warehouse/lot-biography/"
    | "/arrivals/$form/$id/details"
    | "/arrivals/trading/$id/details"
    | "/dispatch/sales/$kind/$id"
    | "/dispatch/sales/$kind/new"
    | "/processing/blending/$id/details"
    | "/quality/got/final-grade/$id"
    | "/quality/got/handover/receive"
    | "/quality/got/handover/report"
    | "/quality/got/reports/$key"
    | "/quality/got/review/$sampleId"
    | "/quality/releases/$kind/$releaseId"
    | "/quality/releases/$kind/new"
    | "/warehouse/$stage/batch/new"
    | "/warehouse/$stage/release/new"
    | "/warehouse/$stage/reports/$key"
    | "/warehouse/$stage/seed-status/update"
    | "/warehouse/$stage/sloc/new"
    | "/dispatch/sales/$kind/"
    | "/quality/got/final-grade/"
    | "/quality/got/handover/"
    | "/quality/got/reports/"
    | "/quality/got/result-update/"
    | "/quality/got/review/"
    | "/quality/releases/$kind/"
    | "/warehouse/$stage/batch/"
    | "/warehouse/$stage/release/"
    | "/warehouse/$stage/reports/"
    | "/warehouse/$stage/seed-status/"
    | "/warehouse/$stage/sloc/"
    | "/quality/got/print/$kind/$dispatchId"
    | "/quality/got/result-update/$sampleId/view"
    | "/quality/got/result-update/$sampleId/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/forgot-password"
    | "/handheld"
    | "/login"
    | "/abbreviations"
    | "/dashboard"
    | "/home"
    | "/qc-dashboard"
    | "/invite/$token"
    | "/kiosk/packing"
    | "/app"
    | "/account/password"
    | "/account/profile"
    | "/admin/audit-log"
    | "/admin/integrations"
    | "/admin/roles"
    | "/admin/users"
    | "/dev/tokens"
    | "/dispatch/barcode-lookup"
    | "/feedback/$id"
    | "/feedback/new"
    | "/inventory/opening"
    | "/inventory/reconciliation"
    | "/inventory/reports"
    | "/inventory/reservations"
    | "/masters/$key"
    | "/masters/api-feed"
    | "/masters/got-farmers"
    | "/masters/got-locations"
    | "/masters/got-ppn-standards"
    | "/masters/locations"
    | "/masters/mail-settings"
    | "/masters/production-personnel"
    | "/masters/storage-restrictions"
    | "/orders/$id"
    | "/orders/holds"
    | "/orders/import"
    | "/orders/new"
    | "/orders/status"
    | "/reports/high-moisture"
    | "/reports/variety-decoding"
    | "/stores/captive"
    | "/stores/discard"
    | "/stores/opening"
    | "/stores/reorder"
    | "/stores/utility"
    | "/warehouse/sloc"
    | "/arrivals"
    | "/dryer"
    | "/feedback"
    | "/gate"
    | "/inventory"
    | "/orders"
    | "/quality"
    | "/reports"
    | "/stores"
    | "/warehouse"
    | "/admin/users/$userId"
    | "/arrivals/$form/$id"
    | "/arrivals/$form/new"
    | "/arrivals/pp-appearance/$sampleId"
    | "/arrivals/trading/$id"
    | "/arrivals/trading/new"
    | "/dispatch/stock-transfer/$id"
    | "/dispatch/stock-transfer/new"
    | "/dryer/$stage/$id"
    | "/gate/pass-in/$id"
    | "/gate/pass-in/new"
    | "/inventory/lots/$lotId"
    | "/masters/vendors/$id"
    | "/masters/vendors/new"
    | "/packaging/fc-packing-slip/$id"
    | "/packaging/fc-packing-slip/new"
    | "/packaging/ivt/$id"
    | "/packaging/ivt/new"
    | "/packaging/ofl/$id"
    | "/packaging/ofl/new"
    | "/packaging/p2c/$id"
    | "/packaging/p2c/new"
    | "/packaging/pack-reprint/$id"
    | "/packaging/pack-reprint/new"
    | "/packaging/packing-slip/$id"
    | "/packaging/packing-slip/new"
    | "/packaging/pnp-fc-slip/$id"
    | "/packaging/reprint-slip/$id"
    | "/packaging/reprint-slip/new"
    | "/packaging/store-indents/$id"
    | "/packaging/store-indents/new"
    | "/packaging/wb-packing-slip/$id"
    | "/packaging/wb-packing-slip/new"
    | "/processing/blending/$id"
    | "/processing/blending/new"
    | "/processing/color-sort/$id"
    | "/processing/color-sort/new"
    | "/processing/drying/$id"
    | "/processing/drying/new"
    | "/processing/packing-slip/$id"
    | "/processing/packing-slip/new"
    | "/processing/pnp-fc-slip/$id"
    | "/processing/pnp-fc-slip/new"
    | "/processing/priming/$id"
    | "/processing/priming/new"
    | "/processing/reports/$key"
    | "/processing/slip/$id"
    | "/processing/slip/new"
    | "/processing/thermal/$id"
    | "/processing/thermal/new"
    | "/processing/treatment/$id"
    | "/processing/treatment/new"
    | "/quality/allocation/$srfId"
    | "/quality/allocation/monitor"
    | "/quality/allocation/samples"
    | "/quality/blending/$id"
    | "/quality/germination/$sampleId"
    | "/quality/got/biography"
    | "/quality/got/dispatch"
    | "/quality/got/low-ppn"
    | "/quality/got/print-sample"
    | "/quality/guard-samples/move"
    | "/quality/moisture/$sampleId"
    | "/quality/pending/$sampleId"
    | "/quality/pp/$sampleId"
    | "/quality/requests/$requestId"
    | "/quality/requests/new"
    | "/reports/arrival/$slug"
    | "/reports/csw/$key"
    | "/reports/dispatch/periodical"
    | "/reports/orders-dispatch/$key"
    | "/reports/packaging/$slug"
    | "/reports/qc/$slug"
    | "/reports/rsw/$key"
    | "/reports/stock/$slug"
    | "/reports/warehouse/$slug"
    | "/stores/arrivals/$id"
    | "/stores/arrivals/new"
    | "/stores/corrections/new"
    | "/stores/docs/$id"
    | "/stores/indents/$id"
    | "/stores/indents/new"
    | "/stores/issues/new"
    | "/stores/reports/$key"
    | "/stores/reports/bin-card"
    | "/stores/sloc/new"
    | "/warehouse/$stage/lot-biography"
    | "/warehouse/lot-biography/$lotId"
    | "/arrivals/$form"
    | "/arrivals/pp-appearance"
    | "/arrivals/trading"
    | "/dispatch/stock-transfer"
    | "/inventory/lots"
    | "/packaging/fc-packing-slip"
    | "/packaging/ivt"
    | "/packaging/ofl"
    | "/packaging/p2c"
    | "/packaging/pack-reprint"
    | "/packaging/packing-slip"
    | "/packaging/pnp-fc-slip"
    | "/packaging/pnp-slip"
    | "/packaging/reprint-slip"
    | "/packaging/root-stock-count"
    | "/packaging/sathi"
    | "/packaging/store-indents"
    | "/packaging/unpackaging"
    | "/packaging/wb-packing-slip"
    | "/processing/blending"
    | "/processing/color-sort"
    | "/processing/drying"
    | "/processing/packing-slip"
    | "/processing/pnp-fc-slip"
    | "/processing/priming"
    | "/processing/reports"
    | "/processing/slip"
    | "/processing/thermal"
    | "/processing/treatment"
    | "/quality/allocation"
    | "/quality/barcode-search"
    | "/quality/batch-finder"
    | "/quality/blending"
    | "/quality/damaged-samples"
    | "/quality/density"
    | "/quality/dov-calculator"
    | "/quality/germination"
    | "/quality/guard-samples"
    | "/quality/moisture"
    | "/quality/pending"
    | "/quality/pp"
    | "/quality/qc-ageing"
    | "/quality/requests"
    | "/quality/rt-srf"
    | "/quality/standards"
    | "/reports/arrival"
    | "/reports/csw"
    | "/reports/packaging"
    | "/reports/rsw"
    | "/reports/stock"
    | "/reports/warehouse"
    | "/rnd/priming"
    | "/stores/arrivals"
    | "/stores/corrections"
    | "/stores/counts"
    | "/stores/indents"
    | "/stores/issues"
    | "/stores/reports"
    | "/stores/sloc"
    | "/thermal/pending"
    | "/warehouse/lot-biography"
    | "/arrivals/$form/$id/details"
    | "/arrivals/trading/$id/details"
    | "/dispatch/sales/$kind/$id"
    | "/dispatch/sales/$kind/new"
    | "/processing/blending/$id/details"
    | "/quality/got/final-grade/$id"
    | "/quality/got/handover/receive"
    | "/quality/got/handover/report"
    | "/quality/got/reports/$key"
    | "/quality/got/review/$sampleId"
    | "/quality/releases/$kind/$releaseId"
    | "/quality/releases/$kind/new"
    | "/warehouse/$stage/batch/new"
    | "/warehouse/$stage/release/new"
    | "/warehouse/$stage/reports/$key"
    | "/warehouse/$stage/seed-status/update"
    | "/warehouse/$stage/sloc/new"
    | "/dispatch/sales/$kind"
    | "/quality/got/final-grade"
    | "/quality/got/handover"
    | "/quality/got/reports"
    | "/quality/got/result-update"
    | "/quality/got/review"
    | "/quality/releases/$kind"
    | "/warehouse/$stage/batch"
    | "/warehouse/$stage/release"
    | "/warehouse/$stage/reports"
    | "/warehouse/$stage/seed-status"
    | "/warehouse/$stage/sloc"
    | "/quality/got/print/$kind/$dispatchId"
    | "/quality/got/result-update/$sampleId/view"
    | "/quality/got/result-update/$sampleId";
  id:
    | "__root__"
    | "/"
    | "/_app"
    | "/forgot-password"
    | "/handheld"
    | "/login"
    | "/_app/abbreviations"
    | "/_app/dashboard"
    | "/_app/home"
    | "/_app/qc-dashboard"
    | "/invite/$token"
    | "/kiosk/packing"
    | "/app/"
    | "/_app/account/password"
    | "/_app/account/profile"
    | "/_app/admin/audit-log"
    | "/_app/admin/integrations"
    | "/_app/admin/roles"
    | "/_app/admin/users"
    | "/_app/dev/tokens"
    | "/_app/dispatch/barcode-lookup"
    | "/_app/feedback/$id"
    | "/_app/feedback/new"
    | "/_app/inventory/opening"
    | "/_app/inventory/reconciliation"
    | "/_app/inventory/reports"
    | "/_app/inventory/reservations"
    | "/_app/masters/$key"
    | "/_app/masters/api-feed"
    | "/_app/masters/got-farmers"
    | "/_app/masters/got-locations"
    | "/_app/masters/got-ppn-standards"
    | "/_app/masters/locations"
    | "/_app/masters/mail-settings"
    | "/_app/masters/production-personnel"
    | "/_app/masters/storage-restrictions"
    | "/_app/orders/$id"
    | "/_app/orders/holds"
    | "/_app/orders/import"
    | "/_app/orders/new"
    | "/_app/orders/status"
    | "/_app/reports/high-moisture"
    | "/_app/reports/variety-decoding"
    | "/_app/stores/captive"
    | "/_app/stores/discard"
    | "/_app/stores/opening"
    | "/_app/stores/reorder"
    | "/_app/stores/utility"
    | "/_app/warehouse/sloc"
    | "/_app/arrivals/"
    | "/_app/dryer/"
    | "/_app/feedback/"
    | "/_app/gate/"
    | "/_app/inventory/"
    | "/_app/orders/"
    | "/_app/quality/"
    | "/_app/reports/"
    | "/_app/stores/"
    | "/_app/warehouse/"
    | "/_app/admin/users_/$userId"
    | "/_app/arrivals/$form/$id"
    | "/_app/arrivals/$form/new"
    | "/_app/arrivals/pp-appearance/$sampleId"
    | "/_app/arrivals/trading/$id"
    | "/_app/arrivals/trading/new"
    | "/_app/dispatch/stock-transfer/$id"
    | "/_app/dispatch/stock-transfer/new"
    | "/_app/dryer/$stage/$id"
    | "/_app/gate/pass-in/$id"
    | "/_app/gate/pass-in/new"
    | "/_app/inventory/lots/$lotId"
    | "/_app/masters/vendors/$id"
    | "/_app/masters/vendors/new"
    | "/_app/packaging/fc-packing-slip/$id"
    | "/_app/packaging/fc-packing-slip/new"
    | "/_app/packaging/ivt/$id"
    | "/_app/packaging/ivt/new"
    | "/_app/packaging/ofl/$id"
    | "/_app/packaging/ofl/new"
    | "/_app/packaging/p2c/$id"
    | "/_app/packaging/p2c/new"
    | "/_app/packaging/pack-reprint/$id"
    | "/_app/packaging/pack-reprint/new"
    | "/_app/packaging/packing-slip/$id"
    | "/_app/packaging/packing-slip/new"
    | "/_app/packaging/pnp-fc-slip/$id"
    | "/_app/packaging/reprint-slip/$id"
    | "/_app/packaging/reprint-slip/new"
    | "/_app/packaging/store-indents/$id"
    | "/_app/packaging/store-indents/new"
    | "/_app/packaging/wb-packing-slip/$id"
    | "/_app/packaging/wb-packing-slip/new"
    | "/_app/processing/blending/$id"
    | "/_app/processing/blending/new"
    | "/_app/processing/color-sort/$id"
    | "/_app/processing/color-sort/new"
    | "/_app/processing/drying/$id"
    | "/_app/processing/drying/new"
    | "/_app/processing/packing-slip/$id"
    | "/_app/processing/packing-slip/new"
    | "/_app/processing/pnp-fc-slip/$id"
    | "/_app/processing/pnp-fc-slip/new"
    | "/_app/processing/priming/$id"
    | "/_app/processing/priming/new"
    | "/_app/processing/reports/$key"
    | "/_app/processing/slip/$id"
    | "/_app/processing/slip/new"
    | "/_app/processing/thermal/$id"
    | "/_app/processing/thermal/new"
    | "/_app/processing/treatment/$id"
    | "/_app/processing/treatment/new"
    | "/_app/quality/allocation/$srfId"
    | "/_app/quality/allocation/monitor"
    | "/_app/quality/allocation/samples"
    | "/_app/quality/blending/$id"
    | "/_app/quality/germination/$sampleId"
    | "/_app/quality/got/biography"
    | "/_app/quality/got/dispatch"
    | "/_app/quality/got/low-ppn"
    | "/_app/quality/got/print-sample"
    | "/_app/quality/guard-samples/move"
    | "/_app/quality/moisture/$sampleId"
    | "/_app/quality/pending/$sampleId"
    | "/_app/quality/pp/$sampleId"
    | "/_app/quality/requests/$requestId"
    | "/_app/quality/requests/new"
    | "/_app/reports/arrival/$slug"
    | "/_app/reports/csw/$key"
    | "/_app/reports/dispatch/periodical"
    | "/_app/reports/orders-dispatch/$key"
    | "/_app/reports/packaging/$slug"
    | "/_app/reports/qc/$slug"
    | "/_app/reports/rsw/$key"
    | "/_app/reports/stock/$slug"
    | "/_app/reports/warehouse/$slug"
    | "/_app/stores/arrivals/$id"
    | "/_app/stores/arrivals/new"
    | "/_app/stores/corrections/new"
    | "/_app/stores/docs/$id"
    | "/_app/stores/indents/$id"
    | "/_app/stores/indents/new"
    | "/_app/stores/issues/new"
    | "/_app/stores/reports/$key"
    | "/_app/stores/reports/bin-card"
    | "/_app/stores/sloc/new"
    | "/_app/warehouse/$stage/lot-biography"
    | "/_app/warehouse/lot-biography/$lotId"
    | "/_app/arrivals/$form/"
    | "/_app/arrivals/pp-appearance/"
    | "/_app/arrivals/trading/"
    | "/_app/dispatch/stock-transfer/"
    | "/_app/inventory/lots/"
    | "/_app/packaging/fc-packing-slip/"
    | "/_app/packaging/ivt/"
    | "/_app/packaging/ofl/"
    | "/_app/packaging/p2c/"
    | "/_app/packaging/pack-reprint/"
    | "/_app/packaging/packing-slip/"
    | "/_app/packaging/pnp-fc-slip/"
    | "/_app/packaging/pnp-slip/"
    | "/_app/packaging/reprint-slip/"
    | "/_app/packaging/root-stock-count/"
    | "/_app/packaging/sathi/"
    | "/_app/packaging/store-indents/"
    | "/_app/packaging/unpackaging/"
    | "/_app/packaging/wb-packing-slip/"
    | "/_app/processing/blending/"
    | "/_app/processing/color-sort/"
    | "/_app/processing/drying/"
    | "/_app/processing/packing-slip/"
    | "/_app/processing/pnp-fc-slip/"
    | "/_app/processing/priming/"
    | "/_app/processing/reports/"
    | "/_app/processing/slip/"
    | "/_app/processing/thermal/"
    | "/_app/processing/treatment/"
    | "/_app/quality/allocation/"
    | "/_app/quality/barcode-search/"
    | "/_app/quality/batch-finder/"
    | "/_app/quality/blending/"
    | "/_app/quality/damaged-samples/"
    | "/_app/quality/density/"
    | "/_app/quality/dov-calculator/"
    | "/_app/quality/germination/"
    | "/_app/quality/guard-samples/"
    | "/_app/quality/moisture/"
    | "/_app/quality/pending/"
    | "/_app/quality/pp/"
    | "/_app/quality/qc-ageing/"
    | "/_app/quality/requests/"
    | "/_app/quality/rt-srf/"
    | "/_app/quality/standards/"
    | "/_app/reports/arrival/"
    | "/_app/reports/csw/"
    | "/_app/reports/packaging/"
    | "/_app/reports/rsw/"
    | "/_app/reports/stock/"
    | "/_app/reports/warehouse/"
    | "/_app/rnd/priming/"
    | "/_app/stores/arrivals/"
    | "/_app/stores/corrections/"
    | "/_app/stores/counts/"
    | "/_app/stores/indents/"
    | "/_app/stores/issues/"
    | "/_app/stores/reports/"
    | "/_app/stores/sloc/"
    | "/_app/thermal/pending/"
    | "/_app/warehouse/lot-biography/"
    | "/_app/arrivals/$form/$id_/details"
    | "/_app/arrivals/trading/$id_/details"
    | "/_app/dispatch/sales/$kind/$id"
    | "/_app/dispatch/sales/$kind/new"
    | "/_app/processing/blending/$id_/details"
    | "/_app/quality/got/final-grade/$id"
    | "/_app/quality/got/handover/receive"
    | "/_app/quality/got/handover/report"
    | "/_app/quality/got/reports/$key"
    | "/_app/quality/got/review/$sampleId"
    | "/_app/quality/releases/$kind/$releaseId"
    | "/_app/quality/releases/$kind/new"
    | "/_app/warehouse/$stage/batch/new"
    | "/_app/warehouse/$stage/release/new"
    | "/_app/warehouse/$stage/reports/$key"
    | "/_app/warehouse/$stage/seed-status/update"
    | "/_app/warehouse/$stage/sloc/new"
    | "/_app/dispatch/sales/$kind/"
    | "/_app/quality/got/final-grade/"
    | "/_app/quality/got/handover/"
    | "/_app/quality/got/reports/"
    | "/_app/quality/got/result-update/"
    | "/_app/quality/got/review/"
    | "/_app/quality/releases/$kind/"
    | "/_app/warehouse/$stage/batch/"
    | "/_app/warehouse/$stage/release/"
    | "/_app/warehouse/$stage/reports/"
    | "/_app/warehouse/$stage/seed-status/"
    | "/_app/warehouse/$stage/sloc/"
    | "/_app/quality/got/print/$kind/$dispatchId"
    | "/_app/quality/got/result-update/$sampleId/view"
    | "/_app/quality/got/result-update/$sampleId/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AppRoute: typeof AppRouteWithChildren;
  ForgotPasswordRoute: typeof ForgotPasswordRoute;
  HandheldRoute: typeof HandheldRoute;
  LoginRoute: typeof LoginRoute;
  InviteTokenRoute: typeof InviteTokenRoute;
  KioskPackingRoute: typeof KioskPackingRoute;
  AppIndexRoute: typeof AppIndexRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app": {
      id: "/_app";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/forgot-password": {
      id: "/forgot-password";
      path: "/forgot-password";
      fullPath: "/forgot-password";
      preLoaderRoute: typeof ForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/handheld": {
      id: "/handheld";
      path: "/handheld";
      fullPath: "/handheld";
      preLoaderRoute: typeof HandheldRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app/abbreviations": {
      id: "/_app/abbreviations";
      path: "/abbreviations";
      fullPath: "/abbreviations";
      preLoaderRoute: typeof AppAbbreviationsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/dashboard": {
      id: "/_app/dashboard";
      path: "/dashboard";
      fullPath: "/dashboard";
      preLoaderRoute: typeof AppDashboardRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/home": {
      id: "/_app/home";
      path: "/home";
      fullPath: "/home";
      preLoaderRoute: typeof AppHomeRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/qc-dashboard": {
      id: "/_app/qc-dashboard";
      path: "/qc-dashboard";
      fullPath: "/qc-dashboard";
      preLoaderRoute: typeof AppQcDashboardRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/app/": {
      id: "/app/";
      path: "/app";
      fullPath: "/app/";
      preLoaderRoute: typeof AppIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/invite/$token": {
      id: "/invite/$token";
      path: "/invite/$token";
      fullPath: "/invite/$token";
      preLoaderRoute: typeof InviteTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/kiosk/packing": {
      id: "/kiosk/packing";
      path: "/kiosk/packing";
      fullPath: "/kiosk/packing";
      preLoaderRoute: typeof KioskPackingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_app/account/password": {
      id: "/_app/account/password";
      path: "/account/password";
      fullPath: "/account/password";
      preLoaderRoute: typeof AppAccountPasswordRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/account/profile": {
      id: "/_app/account/profile";
      path: "/account/profile";
      fullPath: "/account/profile";
      preLoaderRoute: typeof AppAccountProfileRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/admin/audit-log": {
      id: "/_app/admin/audit-log";
      path: "/admin/audit-log";
      fullPath: "/admin/audit-log";
      preLoaderRoute: typeof AppAdminAuditLogRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/admin/integrations": {
      id: "/_app/admin/integrations";
      path: "/admin/integrations";
      fullPath: "/admin/integrations";
      preLoaderRoute: typeof AppAdminIntegrationsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/admin/roles": {
      id: "/_app/admin/roles";
      path: "/admin/roles";
      fullPath: "/admin/roles";
      preLoaderRoute: typeof AppAdminRolesRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/admin/users": {
      id: "/_app/admin/users";
      path: "/admin/users";
      fullPath: "/admin/users";
      preLoaderRoute: typeof AppAdminUsersRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/arrivals/": {
      id: "/_app/arrivals/";
      path: "/arrivals";
      fullPath: "/arrivals/";
      preLoaderRoute: typeof AppArrivalsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/dev/tokens": {
      id: "/_app/dev/tokens";
      path: "/dev/tokens";
      fullPath: "/dev/tokens";
      preLoaderRoute: typeof AppDevTokensRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/dispatch/barcode-lookup": {
      id: "/_app/dispatch/barcode-lookup";
      path: "/dispatch/barcode-lookup";
      fullPath: "/dispatch/barcode-lookup";
      preLoaderRoute: typeof AppDispatchBarcodeLookupRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/dryer/": {
      id: "/_app/dryer/";
      path: "/dryer";
      fullPath: "/dryer/";
      preLoaderRoute: typeof AppDryerIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/feedback/": {
      id: "/_app/feedback/";
      path: "/feedback";
      fullPath: "/feedback/";
      preLoaderRoute: typeof AppFeedbackIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/feedback/$id": {
      id: "/_app/feedback/$id";
      path: "/feedback/$id";
      fullPath: "/feedback/$id";
      preLoaderRoute: typeof AppFeedbackIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/feedback/new": {
      id: "/_app/feedback/new";
      path: "/feedback/new";
      fullPath: "/feedback/new";
      preLoaderRoute: typeof AppFeedbackNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/gate/": {
      id: "/_app/gate/";
      path: "/gate";
      fullPath: "/gate/";
      preLoaderRoute: typeof AppGateIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/inventory/": {
      id: "/_app/inventory/";
      path: "/inventory";
      fullPath: "/inventory/";
      preLoaderRoute: typeof AppInventoryIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/inventory/opening": {
      id: "/_app/inventory/opening";
      path: "/inventory/opening";
      fullPath: "/inventory/opening";
      preLoaderRoute: typeof AppInventoryOpeningRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/inventory/reconciliation": {
      id: "/_app/inventory/reconciliation";
      path: "/inventory/reconciliation";
      fullPath: "/inventory/reconciliation";
      preLoaderRoute: typeof AppInventoryReconciliationRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/inventory/reports": {
      id: "/_app/inventory/reports";
      path: "/inventory/reports";
      fullPath: "/inventory/reports";
      preLoaderRoute: typeof AppInventoryReportsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/inventory/reservations": {
      id: "/_app/inventory/reservations";
      path: "/inventory/reservations";
      fullPath: "/inventory/reservations";
      preLoaderRoute: typeof AppInventoryReservationsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/masters/$key": {
      id: "/_app/masters/$key";
      path: "/masters/$key";
      fullPath: "/masters/$key";
      preLoaderRoute: typeof AppMastersKeyRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/masters/api-feed": {
      id: "/_app/masters/api-feed";
      path: "/masters/api-feed";
      fullPath: "/masters/api-feed";
      preLoaderRoute: typeof AppMastersApiFeedRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/masters/got-farmers": {
      id: "/_app/masters/got-farmers";
      path: "/masters/got-farmers";
      fullPath: "/masters/got-farmers";
      preLoaderRoute: typeof AppMastersGotFarmersRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/masters/got-locations": {
      id: "/_app/masters/got-locations";
      path: "/masters/got-locations";
      fullPath: "/masters/got-locations";
      preLoaderRoute: typeof AppMastersGotLocationsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/masters/got-ppn-standards": {
      id: "/_app/masters/got-ppn-standards";
      path: "/masters/got-ppn-standards";
      fullPath: "/masters/got-ppn-standards";
      preLoaderRoute: typeof AppMastersGotPpnStandardsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/masters/locations": {
      id: "/_app/masters/locations";
      path: "/masters/locations";
      fullPath: "/masters/locations";
      preLoaderRoute: typeof AppMastersLocationsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/masters/mail-settings": {
      id: "/_app/masters/mail-settings";
      path: "/masters/mail-settings";
      fullPath: "/masters/mail-settings";
      preLoaderRoute: typeof AppMastersMailSettingsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/masters/production-personnel": {
      id: "/_app/masters/production-personnel";
      path: "/masters/production-personnel";
      fullPath: "/masters/production-personnel";
      preLoaderRoute: typeof AppMastersProductionPersonnelRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/masters/storage-restrictions": {
      id: "/_app/masters/storage-restrictions";
      path: "/masters/storage-restrictions";
      fullPath: "/masters/storage-restrictions";
      preLoaderRoute: typeof AppMastersStorageRestrictionsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/orders/": {
      id: "/_app/orders/";
      path: "/orders";
      fullPath: "/orders/";
      preLoaderRoute: typeof AppOrdersIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/orders/$id": {
      id: "/_app/orders/$id";
      path: "/orders/$id";
      fullPath: "/orders/$id";
      preLoaderRoute: typeof AppOrdersIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/orders/holds": {
      id: "/_app/orders/holds";
      path: "/orders/holds";
      fullPath: "/orders/holds";
      preLoaderRoute: typeof AppOrdersHoldsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/orders/import": {
      id: "/_app/orders/import";
      path: "/orders/import";
      fullPath: "/orders/import";
      preLoaderRoute: typeof AppOrdersImportRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/orders/new": {
      id: "/_app/orders/new";
      path: "/orders/new";
      fullPath: "/orders/new";
      preLoaderRoute: typeof AppOrdersNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/orders/status": {
      id: "/_app/orders/status";
      path: "/orders/status";
      fullPath: "/orders/status";
      preLoaderRoute: typeof AppOrdersStatusRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/": {
      id: "/_app/quality/";
      path: "/quality";
      fullPath: "/quality/";
      preLoaderRoute: typeof AppQualityIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/": {
      id: "/_app/reports/";
      path: "/reports";
      fullPath: "/reports/";
      preLoaderRoute: typeof AppReportsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/high-moisture": {
      id: "/_app/reports/high-moisture";
      path: "/reports/high-moisture";
      fullPath: "/reports/high-moisture";
      preLoaderRoute: typeof AppReportsHighMoistureRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/variety-decoding": {
      id: "/_app/reports/variety-decoding";
      path: "/reports/variety-decoding";
      fullPath: "/reports/variety-decoding";
      preLoaderRoute: typeof AppReportsVarietyDecodingRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/": {
      id: "/_app/stores/";
      path: "/stores";
      fullPath: "/stores/";
      preLoaderRoute: typeof AppStoresIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/captive": {
      id: "/_app/stores/captive";
      path: "/stores/captive";
      fullPath: "/stores/captive";
      preLoaderRoute: typeof AppStoresCaptiveRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/discard": {
      id: "/_app/stores/discard";
      path: "/stores/discard";
      fullPath: "/stores/discard";
      preLoaderRoute: typeof AppStoresDiscardRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/opening": {
      id: "/_app/stores/opening";
      path: "/stores/opening";
      fullPath: "/stores/opening";
      preLoaderRoute: typeof AppStoresOpeningRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/reorder": {
      id: "/_app/stores/reorder";
      path: "/stores/reorder";
      fullPath: "/stores/reorder";
      preLoaderRoute: typeof AppStoresReorderRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/utility": {
      id: "/_app/stores/utility";
      path: "/stores/utility";
      fullPath: "/stores/utility";
      preLoaderRoute: typeof AppStoresUtilityRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/warehouse/": {
      id: "/_app/warehouse/";
      path: "/warehouse";
      fullPath: "/warehouse/";
      preLoaderRoute: typeof AppWarehouseIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/warehouse/sloc": {
      id: "/_app/warehouse/sloc";
      path: "/warehouse/sloc";
      fullPath: "/warehouse/sloc";
      preLoaderRoute: typeof AppWarehouseSlocRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/admin/users_/$userId": {
      id: "/_app/admin/users_/$userId";
      path: "/admin/users/$userId";
      fullPath: "/admin/users/$userId";
      preLoaderRoute: typeof AppAdminUsersUserIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/arrivals/$form/": {
      id: "/_app/arrivals/$form/";
      path: "/arrivals/$form";
      fullPath: "/arrivals/$form/";
      preLoaderRoute: typeof AppArrivalsFormIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/arrivals/$form/$id": {
      id: "/_app/arrivals/$form/$id";
      path: "/arrivals/$form/$id";
      fullPath: "/arrivals/$form/$id";
      preLoaderRoute: typeof AppArrivalsFormIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/arrivals/$form/new": {
      id: "/_app/arrivals/$form/new";
      path: "/arrivals/$form/new";
      fullPath: "/arrivals/$form/new";
      preLoaderRoute: typeof AppArrivalsFormNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/arrivals/pp-appearance/": {
      id: "/_app/arrivals/pp-appearance/";
      path: "/arrivals/pp-appearance";
      fullPath: "/arrivals/pp-appearance/";
      preLoaderRoute: typeof AppArrivalsPpAppearanceIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/arrivals/pp-appearance/$sampleId": {
      id: "/_app/arrivals/pp-appearance/$sampleId";
      path: "/arrivals/pp-appearance/$sampleId";
      fullPath: "/arrivals/pp-appearance/$sampleId";
      preLoaderRoute: typeof AppArrivalsPpAppearanceSampleIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/arrivals/trading/": {
      id: "/_app/arrivals/trading/";
      path: "/arrivals/trading";
      fullPath: "/arrivals/trading/";
      preLoaderRoute: typeof AppArrivalsTradingIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/arrivals/trading/$id": {
      id: "/_app/arrivals/trading/$id";
      path: "/arrivals/trading/$id";
      fullPath: "/arrivals/trading/$id";
      preLoaderRoute: typeof AppArrivalsTradingIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/arrivals/trading/new": {
      id: "/_app/arrivals/trading/new";
      path: "/arrivals/trading/new";
      fullPath: "/arrivals/trading/new";
      preLoaderRoute: typeof AppArrivalsTradingNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/dispatch/stock-transfer/": {
      id: "/_app/dispatch/stock-transfer/";
      path: "/dispatch/stock-transfer";
      fullPath: "/dispatch/stock-transfer/";
      preLoaderRoute: typeof AppDispatchStockTransferIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/dispatch/stock-transfer/$id": {
      id: "/_app/dispatch/stock-transfer/$id";
      path: "/dispatch/stock-transfer/$id";
      fullPath: "/dispatch/stock-transfer/$id";
      preLoaderRoute: typeof AppDispatchStockTransferIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/dispatch/stock-transfer/new": {
      id: "/_app/dispatch/stock-transfer/new";
      path: "/dispatch/stock-transfer/new";
      fullPath: "/dispatch/stock-transfer/new";
      preLoaderRoute: typeof AppDispatchStockTransferNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/dryer/$stage/$id": {
      id: "/_app/dryer/$stage/$id";
      path: "/dryer/$stage/$id";
      fullPath: "/dryer/$stage/$id";
      preLoaderRoute: typeof AppDryerStageIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/gate/pass-in/$id": {
      id: "/_app/gate/pass-in/$id";
      path: "/gate/pass-in/$id";
      fullPath: "/gate/pass-in/$id";
      preLoaderRoute: typeof AppGatePassInIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/gate/pass-in/new": {
      id: "/_app/gate/pass-in/new";
      path: "/gate/pass-in/new";
      fullPath: "/gate/pass-in/new";
      preLoaderRoute: typeof AppGatePassInNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/inventory/lots/": {
      id: "/_app/inventory/lots/";
      path: "/inventory/lots";
      fullPath: "/inventory/lots/";
      preLoaderRoute: typeof AppInventoryLotsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/inventory/lots/$lotId": {
      id: "/_app/inventory/lots/$lotId";
      path: "/inventory/lots/$lotId";
      fullPath: "/inventory/lots/$lotId";
      preLoaderRoute: typeof AppInventoryLotsLotIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/masters/vendors/$id": {
      id: "/_app/masters/vendors/$id";
      path: "/masters/vendors/$id";
      fullPath: "/masters/vendors/$id";
      preLoaderRoute: typeof AppMastersVendorsIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/masters/vendors/new": {
      id: "/_app/masters/vendors/new";
      path: "/masters/vendors/new";
      fullPath: "/masters/vendors/new";
      preLoaderRoute: typeof AppMastersVendorsNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/fc-packing-slip/": {
      id: "/_app/packaging/fc-packing-slip/";
      path: "/packaging/fc-packing-slip";
      fullPath: "/packaging/fc-packing-slip/";
      preLoaderRoute: typeof AppPackagingFcPackingSlipIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/fc-packing-slip/$id": {
      id: "/_app/packaging/fc-packing-slip/$id";
      path: "/packaging/fc-packing-slip/$id";
      fullPath: "/packaging/fc-packing-slip/$id";
      preLoaderRoute: typeof AppPackagingFcPackingSlipIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/fc-packing-slip/new": {
      id: "/_app/packaging/fc-packing-slip/new";
      path: "/packaging/fc-packing-slip/new";
      fullPath: "/packaging/fc-packing-slip/new";
      preLoaderRoute: typeof AppPackagingFcPackingSlipNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/ivt/": {
      id: "/_app/packaging/ivt/";
      path: "/packaging/ivt";
      fullPath: "/packaging/ivt/";
      preLoaderRoute: typeof AppPackagingIvtIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/ivt/$id": {
      id: "/_app/packaging/ivt/$id";
      path: "/packaging/ivt/$id";
      fullPath: "/packaging/ivt/$id";
      preLoaderRoute: typeof AppPackagingIvtIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/ivt/new": {
      id: "/_app/packaging/ivt/new";
      path: "/packaging/ivt/new";
      fullPath: "/packaging/ivt/new";
      preLoaderRoute: typeof AppPackagingIvtNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/ofl/": {
      id: "/_app/packaging/ofl/";
      path: "/packaging/ofl";
      fullPath: "/packaging/ofl/";
      preLoaderRoute: typeof AppPackagingOflIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/ofl/$id": {
      id: "/_app/packaging/ofl/$id";
      path: "/packaging/ofl/$id";
      fullPath: "/packaging/ofl/$id";
      preLoaderRoute: typeof AppPackagingOflIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/ofl/new": {
      id: "/_app/packaging/ofl/new";
      path: "/packaging/ofl/new";
      fullPath: "/packaging/ofl/new";
      preLoaderRoute: typeof AppPackagingOflNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/p2c/": {
      id: "/_app/packaging/p2c/";
      path: "/packaging/p2c";
      fullPath: "/packaging/p2c/";
      preLoaderRoute: typeof AppPackagingP2cIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/p2c/$id": {
      id: "/_app/packaging/p2c/$id";
      path: "/packaging/p2c/$id";
      fullPath: "/packaging/p2c/$id";
      preLoaderRoute: typeof AppPackagingP2cIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/p2c/new": {
      id: "/_app/packaging/p2c/new";
      path: "/packaging/p2c/new";
      fullPath: "/packaging/p2c/new";
      preLoaderRoute: typeof AppPackagingP2cNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/pack-reprint/": {
      id: "/_app/packaging/pack-reprint/";
      path: "/packaging/pack-reprint";
      fullPath: "/packaging/pack-reprint/";
      preLoaderRoute: typeof AppPackagingPackReprintIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/pack-reprint/$id": {
      id: "/_app/packaging/pack-reprint/$id";
      path: "/packaging/pack-reprint/$id";
      fullPath: "/packaging/pack-reprint/$id";
      preLoaderRoute: typeof AppPackagingPackReprintIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/pack-reprint/new": {
      id: "/_app/packaging/pack-reprint/new";
      path: "/packaging/pack-reprint/new";
      fullPath: "/packaging/pack-reprint/new";
      preLoaderRoute: typeof AppPackagingPackReprintNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/packing-slip/": {
      id: "/_app/packaging/packing-slip/";
      path: "/packaging/packing-slip";
      fullPath: "/packaging/packing-slip/";
      preLoaderRoute: typeof AppPackagingPackingSlipIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/packing-slip/$id": {
      id: "/_app/packaging/packing-slip/$id";
      path: "/packaging/packing-slip/$id";
      fullPath: "/packaging/packing-slip/$id";
      preLoaderRoute: typeof AppPackagingPackingSlipIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/packing-slip/new": {
      id: "/_app/packaging/packing-slip/new";
      path: "/packaging/packing-slip/new";
      fullPath: "/packaging/packing-slip/new";
      preLoaderRoute: typeof AppPackagingPackingSlipNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/pnp-fc-slip/": {
      id: "/_app/packaging/pnp-fc-slip/";
      path: "/packaging/pnp-fc-slip";
      fullPath: "/packaging/pnp-fc-slip/";
      preLoaderRoute: typeof AppPackagingPnpFcSlipIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/pnp-fc-slip/$id": {
      id: "/_app/packaging/pnp-fc-slip/$id";
      path: "/packaging/pnp-fc-slip/$id";
      fullPath: "/packaging/pnp-fc-slip/$id";
      preLoaderRoute: typeof AppPackagingPnpFcSlipIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/pnp-slip/": {
      id: "/_app/packaging/pnp-slip/";
      path: "/packaging/pnp-slip";
      fullPath: "/packaging/pnp-slip/";
      preLoaderRoute: typeof AppPackagingPnpSlipIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/reprint-slip/": {
      id: "/_app/packaging/reprint-slip/";
      path: "/packaging/reprint-slip";
      fullPath: "/packaging/reprint-slip/";
      preLoaderRoute: typeof AppPackagingReprintSlipIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/reprint-slip/$id": {
      id: "/_app/packaging/reprint-slip/$id";
      path: "/packaging/reprint-slip/$id";
      fullPath: "/packaging/reprint-slip/$id";
      preLoaderRoute: typeof AppPackagingReprintSlipIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/reprint-slip/new": {
      id: "/_app/packaging/reprint-slip/new";
      path: "/packaging/reprint-slip/new";
      fullPath: "/packaging/reprint-slip/new";
      preLoaderRoute: typeof AppPackagingReprintSlipNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/root-stock-count/": {
      id: "/_app/packaging/root-stock-count/";
      path: "/packaging/root-stock-count";
      fullPath: "/packaging/root-stock-count/";
      preLoaderRoute: typeof AppPackagingRootStockCountIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/sathi/": {
      id: "/_app/packaging/sathi/";
      path: "/packaging/sathi";
      fullPath: "/packaging/sathi/";
      preLoaderRoute: typeof AppPackagingSathiIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/store-indents/": {
      id: "/_app/packaging/store-indents/";
      path: "/packaging/store-indents";
      fullPath: "/packaging/store-indents/";
      preLoaderRoute: typeof AppPackagingStoreIndentsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/store-indents/$id": {
      id: "/_app/packaging/store-indents/$id";
      path: "/packaging/store-indents/$id";
      fullPath: "/packaging/store-indents/$id";
      preLoaderRoute: typeof AppPackagingStoreIndentsIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/store-indents/new": {
      id: "/_app/packaging/store-indents/new";
      path: "/packaging/store-indents/new";
      fullPath: "/packaging/store-indents/new";
      preLoaderRoute: typeof AppPackagingStoreIndentsNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/unpackaging/": {
      id: "/_app/packaging/unpackaging/";
      path: "/packaging/unpackaging";
      fullPath: "/packaging/unpackaging/";
      preLoaderRoute: typeof AppPackagingUnpackagingIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/wb-packing-slip/": {
      id: "/_app/packaging/wb-packing-slip/";
      path: "/packaging/wb-packing-slip";
      fullPath: "/packaging/wb-packing-slip/";
      preLoaderRoute: typeof AppPackagingWbPackingSlipIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/wb-packing-slip/$id": {
      id: "/_app/packaging/wb-packing-slip/$id";
      path: "/packaging/wb-packing-slip/$id";
      fullPath: "/packaging/wb-packing-slip/$id";
      preLoaderRoute: typeof AppPackagingWbPackingSlipIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/packaging/wb-packing-slip/new": {
      id: "/_app/packaging/wb-packing-slip/new";
      path: "/packaging/wb-packing-slip/new";
      fullPath: "/packaging/wb-packing-slip/new";
      preLoaderRoute: typeof AppPackagingWbPackingSlipNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/blending/": {
      id: "/_app/processing/blending/";
      path: "/processing/blending";
      fullPath: "/processing/blending/";
      preLoaderRoute: typeof AppProcessingBlendingIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/blending/$id": {
      id: "/_app/processing/blending/$id";
      path: "/processing/blending/$id";
      fullPath: "/processing/blending/$id";
      preLoaderRoute: typeof AppProcessingBlendingIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/blending/new": {
      id: "/_app/processing/blending/new";
      path: "/processing/blending/new";
      fullPath: "/processing/blending/new";
      preLoaderRoute: typeof AppProcessingBlendingNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/color-sort/": {
      id: "/_app/processing/color-sort/";
      path: "/processing/color-sort";
      fullPath: "/processing/color-sort/";
      preLoaderRoute: typeof AppProcessingColorSortIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/color-sort/$id": {
      id: "/_app/processing/color-sort/$id";
      path: "/processing/color-sort/$id";
      fullPath: "/processing/color-sort/$id";
      preLoaderRoute: typeof AppProcessingColorSortIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/color-sort/new": {
      id: "/_app/processing/color-sort/new";
      path: "/processing/color-sort/new";
      fullPath: "/processing/color-sort/new";
      preLoaderRoute: typeof AppProcessingColorSortNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/drying/": {
      id: "/_app/processing/drying/";
      path: "/processing/drying";
      fullPath: "/processing/drying/";
      preLoaderRoute: typeof AppProcessingDryingIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/drying/$id": {
      id: "/_app/processing/drying/$id";
      path: "/processing/drying/$id";
      fullPath: "/processing/drying/$id";
      preLoaderRoute: typeof AppProcessingDryingIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/drying/new": {
      id: "/_app/processing/drying/new";
      path: "/processing/drying/new";
      fullPath: "/processing/drying/new";
      preLoaderRoute: typeof AppProcessingDryingNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/packing-slip/": {
      id: "/_app/processing/packing-slip/";
      path: "/processing/packing-slip";
      fullPath: "/processing/packing-slip/";
      preLoaderRoute: typeof AppProcessingPackingSlipIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/packing-slip/$id": {
      id: "/_app/processing/packing-slip/$id";
      path: "/processing/packing-slip/$id";
      fullPath: "/processing/packing-slip/$id";
      preLoaderRoute: typeof AppProcessingPackingSlipIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/packing-slip/new": {
      id: "/_app/processing/packing-slip/new";
      path: "/processing/packing-slip/new";
      fullPath: "/processing/packing-slip/new";
      preLoaderRoute: typeof AppProcessingPackingSlipNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/pnp-fc-slip/": {
      id: "/_app/processing/pnp-fc-slip/";
      path: "/processing/pnp-fc-slip";
      fullPath: "/processing/pnp-fc-slip/";
      preLoaderRoute: typeof AppProcessingPnpFcSlipIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/pnp-fc-slip/$id": {
      id: "/_app/processing/pnp-fc-slip/$id";
      path: "/processing/pnp-fc-slip/$id";
      fullPath: "/processing/pnp-fc-slip/$id";
      preLoaderRoute: typeof AppProcessingPnpFcSlipIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/pnp-fc-slip/new": {
      id: "/_app/processing/pnp-fc-slip/new";
      path: "/processing/pnp-fc-slip/new";
      fullPath: "/processing/pnp-fc-slip/new";
      preLoaderRoute: typeof AppProcessingPnpFcSlipNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/priming/": {
      id: "/_app/processing/priming/";
      path: "/processing/priming";
      fullPath: "/processing/priming/";
      preLoaderRoute: typeof AppProcessingPrimingIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/priming/$id": {
      id: "/_app/processing/priming/$id";
      path: "/processing/priming/$id";
      fullPath: "/processing/priming/$id";
      preLoaderRoute: typeof AppProcessingPrimingIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/priming/new": {
      id: "/_app/processing/priming/new";
      path: "/processing/priming/new";
      fullPath: "/processing/priming/new";
      preLoaderRoute: typeof AppProcessingPrimingNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/reports/": {
      id: "/_app/processing/reports/";
      path: "/processing/reports";
      fullPath: "/processing/reports/";
      preLoaderRoute: typeof AppProcessingReportsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/reports/$key": {
      id: "/_app/processing/reports/$key";
      path: "/processing/reports/$key";
      fullPath: "/processing/reports/$key";
      preLoaderRoute: typeof AppProcessingReportsKeyRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/slip/": {
      id: "/_app/processing/slip/";
      path: "/processing/slip";
      fullPath: "/processing/slip/";
      preLoaderRoute: typeof AppProcessingSlipIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/slip/$id": {
      id: "/_app/processing/slip/$id";
      path: "/processing/slip/$id";
      fullPath: "/processing/slip/$id";
      preLoaderRoute: typeof AppProcessingSlipIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/slip/new": {
      id: "/_app/processing/slip/new";
      path: "/processing/slip/new";
      fullPath: "/processing/slip/new";
      preLoaderRoute: typeof AppProcessingSlipNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/thermal/": {
      id: "/_app/processing/thermal/";
      path: "/processing/thermal";
      fullPath: "/processing/thermal/";
      preLoaderRoute: typeof AppProcessingThermalIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/thermal/$id": {
      id: "/_app/processing/thermal/$id";
      path: "/processing/thermal/$id";
      fullPath: "/processing/thermal/$id";
      preLoaderRoute: typeof AppProcessingThermalIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/thermal/new": {
      id: "/_app/processing/thermal/new";
      path: "/processing/thermal/new";
      fullPath: "/processing/thermal/new";
      preLoaderRoute: typeof AppProcessingThermalNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/treatment/": {
      id: "/_app/processing/treatment/";
      path: "/processing/treatment";
      fullPath: "/processing/treatment/";
      preLoaderRoute: typeof AppProcessingTreatmentIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/treatment/$id": {
      id: "/_app/processing/treatment/$id";
      path: "/processing/treatment/$id";
      fullPath: "/processing/treatment/$id";
      preLoaderRoute: typeof AppProcessingTreatmentIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/treatment/new": {
      id: "/_app/processing/treatment/new";
      path: "/processing/treatment/new";
      fullPath: "/processing/treatment/new";
      preLoaderRoute: typeof AppProcessingTreatmentNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/allocation/": {
      id: "/_app/quality/allocation/";
      path: "/quality/allocation";
      fullPath: "/quality/allocation/";
      preLoaderRoute: typeof AppQualityAllocationIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/allocation/$srfId": {
      id: "/_app/quality/allocation/$srfId";
      path: "/quality/allocation/$srfId";
      fullPath: "/quality/allocation/$srfId";
      preLoaderRoute: typeof AppQualityAllocationSrfIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/allocation/monitor": {
      id: "/_app/quality/allocation/monitor";
      path: "/quality/allocation/monitor";
      fullPath: "/quality/allocation/monitor";
      preLoaderRoute: typeof AppQualityAllocationMonitorRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/allocation/samples": {
      id: "/_app/quality/allocation/samples";
      path: "/quality/allocation/samples";
      fullPath: "/quality/allocation/samples";
      preLoaderRoute: typeof AppQualityAllocationSamplesRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/barcode-search/": {
      id: "/_app/quality/barcode-search/";
      path: "/quality/barcode-search";
      fullPath: "/quality/barcode-search/";
      preLoaderRoute: typeof AppQualityBarcodeSearchIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/batch-finder/": {
      id: "/_app/quality/batch-finder/";
      path: "/quality/batch-finder";
      fullPath: "/quality/batch-finder/";
      preLoaderRoute: typeof AppQualityBatchFinderIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/blending/": {
      id: "/_app/quality/blending/";
      path: "/quality/blending";
      fullPath: "/quality/blending/";
      preLoaderRoute: typeof AppQualityBlendingIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/blending/$id": {
      id: "/_app/quality/blending/$id";
      path: "/quality/blending/$id";
      fullPath: "/quality/blending/$id";
      preLoaderRoute: typeof AppQualityBlendingIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/damaged-samples/": {
      id: "/_app/quality/damaged-samples/";
      path: "/quality/damaged-samples";
      fullPath: "/quality/damaged-samples/";
      preLoaderRoute: typeof AppQualityDamagedSamplesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/density/": {
      id: "/_app/quality/density/";
      path: "/quality/density";
      fullPath: "/quality/density/";
      preLoaderRoute: typeof AppQualityDensityIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/dov-calculator/": {
      id: "/_app/quality/dov-calculator/";
      path: "/quality/dov-calculator";
      fullPath: "/quality/dov-calculator/";
      preLoaderRoute: typeof AppQualityDovCalculatorIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/germination/": {
      id: "/_app/quality/germination/";
      path: "/quality/germination";
      fullPath: "/quality/germination/";
      preLoaderRoute: typeof AppQualityGerminationIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/germination/$sampleId": {
      id: "/_app/quality/germination/$sampleId";
      path: "/quality/germination/$sampleId";
      fullPath: "/quality/germination/$sampleId";
      preLoaderRoute: typeof AppQualityGerminationSampleIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/biography": {
      id: "/_app/quality/got/biography";
      path: "/quality/got/biography";
      fullPath: "/quality/got/biography";
      preLoaderRoute: typeof AppQualityGotBiographyRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/dispatch": {
      id: "/_app/quality/got/dispatch";
      path: "/quality/got/dispatch";
      fullPath: "/quality/got/dispatch";
      preLoaderRoute: typeof AppQualityGotDispatchRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/low-ppn": {
      id: "/_app/quality/got/low-ppn";
      path: "/quality/got/low-ppn";
      fullPath: "/quality/got/low-ppn";
      preLoaderRoute: typeof AppQualityGotLowPpnRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/print-sample": {
      id: "/_app/quality/got/print-sample";
      path: "/quality/got/print-sample";
      fullPath: "/quality/got/print-sample";
      preLoaderRoute: typeof AppQualityGotPrintSampleRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/guard-samples/": {
      id: "/_app/quality/guard-samples/";
      path: "/quality/guard-samples";
      fullPath: "/quality/guard-samples/";
      preLoaderRoute: typeof AppQualityGuardSamplesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/guard-samples/move": {
      id: "/_app/quality/guard-samples/move";
      path: "/quality/guard-samples/move";
      fullPath: "/quality/guard-samples/move";
      preLoaderRoute: typeof AppQualityGuardSamplesMoveRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/moisture/": {
      id: "/_app/quality/moisture/";
      path: "/quality/moisture";
      fullPath: "/quality/moisture/";
      preLoaderRoute: typeof AppQualityMoistureIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/moisture/$sampleId": {
      id: "/_app/quality/moisture/$sampleId";
      path: "/quality/moisture/$sampleId";
      fullPath: "/quality/moisture/$sampleId";
      preLoaderRoute: typeof AppQualityMoistureSampleIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/pending/": {
      id: "/_app/quality/pending/";
      path: "/quality/pending";
      fullPath: "/quality/pending/";
      preLoaderRoute: typeof AppQualityPendingIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/pending/$sampleId": {
      id: "/_app/quality/pending/$sampleId";
      path: "/quality/pending/$sampleId";
      fullPath: "/quality/pending/$sampleId";
      preLoaderRoute: typeof AppQualityPendingSampleIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/pp/": {
      id: "/_app/quality/pp/";
      path: "/quality/pp";
      fullPath: "/quality/pp/";
      preLoaderRoute: typeof AppQualityPpIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/pp/$sampleId": {
      id: "/_app/quality/pp/$sampleId";
      path: "/quality/pp/$sampleId";
      fullPath: "/quality/pp/$sampleId";
      preLoaderRoute: typeof AppQualityPpSampleIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/qc-ageing/": {
      id: "/_app/quality/qc-ageing/";
      path: "/quality/qc-ageing";
      fullPath: "/quality/qc-ageing/";
      preLoaderRoute: typeof AppQualityQcAgeingIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/requests/": {
      id: "/_app/quality/requests/";
      path: "/quality/requests";
      fullPath: "/quality/requests/";
      preLoaderRoute: typeof AppQualityRequestsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/requests/$requestId": {
      id: "/_app/quality/requests/$requestId";
      path: "/quality/requests/$requestId";
      fullPath: "/quality/requests/$requestId";
      preLoaderRoute: typeof AppQualityRequestsRequestIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/requests/new": {
      id: "/_app/quality/requests/new";
      path: "/quality/requests/new";
      fullPath: "/quality/requests/new";
      preLoaderRoute: typeof AppQualityRequestsNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/rt-srf/": {
      id: "/_app/quality/rt-srf/";
      path: "/quality/rt-srf";
      fullPath: "/quality/rt-srf/";
      preLoaderRoute: typeof AppQualityRtSrfIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/standards/": {
      id: "/_app/quality/standards/";
      path: "/quality/standards";
      fullPath: "/quality/standards/";
      preLoaderRoute: typeof AppQualityStandardsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/arrival/": {
      id: "/_app/reports/arrival/";
      path: "/reports/arrival";
      fullPath: "/reports/arrival/";
      preLoaderRoute: typeof AppReportsArrivalIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/arrival/$slug": {
      id: "/_app/reports/arrival/$slug";
      path: "/reports/arrival/$slug";
      fullPath: "/reports/arrival/$slug";
      preLoaderRoute: typeof AppReportsArrivalSlugRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/csw/": {
      id: "/_app/reports/csw/";
      path: "/reports/csw";
      fullPath: "/reports/csw/";
      preLoaderRoute: typeof AppReportsCswIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/csw/$key": {
      id: "/_app/reports/csw/$key";
      path: "/reports/csw/$key";
      fullPath: "/reports/csw/$key";
      preLoaderRoute: typeof AppReportsCswKeyRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/dispatch/periodical": {
      id: "/_app/reports/dispatch/periodical";
      path: "/reports/dispatch/periodical";
      fullPath: "/reports/dispatch/periodical";
      preLoaderRoute: typeof AppReportsDispatchPeriodicalRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/orders-dispatch/$key": {
      id: "/_app/reports/orders-dispatch/$key";
      path: "/reports/orders-dispatch/$key";
      fullPath: "/reports/orders-dispatch/$key";
      preLoaderRoute: typeof AppReportsOrdersDispatchKeyRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/packaging/": {
      id: "/_app/reports/packaging/";
      path: "/reports/packaging";
      fullPath: "/reports/packaging/";
      preLoaderRoute: typeof AppReportsPackagingIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/packaging/$slug": {
      id: "/_app/reports/packaging/$slug";
      path: "/reports/packaging/$slug";
      fullPath: "/reports/packaging/$slug";
      preLoaderRoute: typeof AppReportsPackagingSlugRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/qc/$slug": {
      id: "/_app/reports/qc/$slug";
      path: "/reports/qc/$slug";
      fullPath: "/reports/qc/$slug";
      preLoaderRoute: typeof AppReportsQcSlugRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/rsw/": {
      id: "/_app/reports/rsw/";
      path: "/reports/rsw";
      fullPath: "/reports/rsw/";
      preLoaderRoute: typeof AppReportsRswIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/rsw/$key": {
      id: "/_app/reports/rsw/$key";
      path: "/reports/rsw/$key";
      fullPath: "/reports/rsw/$key";
      preLoaderRoute: typeof AppReportsRswKeyRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/stock/": {
      id: "/_app/reports/stock/";
      path: "/reports/stock";
      fullPath: "/reports/stock/";
      preLoaderRoute: typeof AppReportsStockIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/stock/$slug": {
      id: "/_app/reports/stock/$slug";
      path: "/reports/stock/$slug";
      fullPath: "/reports/stock/$slug";
      preLoaderRoute: typeof AppReportsStockSlugRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/warehouse/": {
      id: "/_app/reports/warehouse/";
      path: "/reports/warehouse";
      fullPath: "/reports/warehouse/";
      preLoaderRoute: typeof AppReportsWarehouseIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/reports/warehouse/$slug": {
      id: "/_app/reports/warehouse/$slug";
      path: "/reports/warehouse/$slug";
      fullPath: "/reports/warehouse/$slug";
      preLoaderRoute: typeof AppReportsWarehouseSlugRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/rnd/priming/": {
      id: "/_app/rnd/priming/";
      path: "/rnd/priming";
      fullPath: "/rnd/priming/";
      preLoaderRoute: typeof AppRndPrimingIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/arrivals/": {
      id: "/_app/stores/arrivals/";
      path: "/stores/arrivals";
      fullPath: "/stores/arrivals/";
      preLoaderRoute: typeof AppStoresArrivalsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/arrivals/$id": {
      id: "/_app/stores/arrivals/$id";
      path: "/stores/arrivals/$id";
      fullPath: "/stores/arrivals/$id";
      preLoaderRoute: typeof AppStoresArrivalsIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/arrivals/new": {
      id: "/_app/stores/arrivals/new";
      path: "/stores/arrivals/new";
      fullPath: "/stores/arrivals/new";
      preLoaderRoute: typeof AppStoresArrivalsNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/corrections/": {
      id: "/_app/stores/corrections/";
      path: "/stores/corrections";
      fullPath: "/stores/corrections/";
      preLoaderRoute: typeof AppStoresCorrectionsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/corrections/new": {
      id: "/_app/stores/corrections/new";
      path: "/stores/corrections/new";
      fullPath: "/stores/corrections/new";
      preLoaderRoute: typeof AppStoresCorrectionsNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/counts/": {
      id: "/_app/stores/counts/";
      path: "/stores/counts";
      fullPath: "/stores/counts/";
      preLoaderRoute: typeof AppStoresCountsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/docs/$id": {
      id: "/_app/stores/docs/$id";
      path: "/stores/docs/$id";
      fullPath: "/stores/docs/$id";
      preLoaderRoute: typeof AppStoresDocsIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/indents/": {
      id: "/_app/stores/indents/";
      path: "/stores/indents";
      fullPath: "/stores/indents/";
      preLoaderRoute: typeof AppStoresIndentsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/indents/$id": {
      id: "/_app/stores/indents/$id";
      path: "/stores/indents/$id";
      fullPath: "/stores/indents/$id";
      preLoaderRoute: typeof AppStoresIndentsIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/indents/new": {
      id: "/_app/stores/indents/new";
      path: "/stores/indents/new";
      fullPath: "/stores/indents/new";
      preLoaderRoute: typeof AppStoresIndentsNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/issues/": {
      id: "/_app/stores/issues/";
      path: "/stores/issues";
      fullPath: "/stores/issues/";
      preLoaderRoute: typeof AppStoresIssuesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/issues/new": {
      id: "/_app/stores/issues/new";
      path: "/stores/issues/new";
      fullPath: "/stores/issues/new";
      preLoaderRoute: typeof AppStoresIssuesNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/reports/": {
      id: "/_app/stores/reports/";
      path: "/stores/reports";
      fullPath: "/stores/reports/";
      preLoaderRoute: typeof AppStoresReportsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/reports/$key": {
      id: "/_app/stores/reports/$key";
      path: "/stores/reports/$key";
      fullPath: "/stores/reports/$key";
      preLoaderRoute: typeof AppStoresReportsKeyRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/reports/bin-card": {
      id: "/_app/stores/reports/bin-card";
      path: "/stores/reports/bin-card";
      fullPath: "/stores/reports/bin-card";
      preLoaderRoute: typeof AppStoresReportsBinCardRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/sloc/": {
      id: "/_app/stores/sloc/";
      path: "/stores/sloc";
      fullPath: "/stores/sloc/";
      preLoaderRoute: typeof AppStoresSlocIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/stores/sloc/new": {
      id: "/_app/stores/sloc/new";
      path: "/stores/sloc/new";
      fullPath: "/stores/sloc/new";
      preLoaderRoute: typeof AppStoresSlocNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/thermal/pending/": {
      id: "/_app/thermal/pending/";
      path: "/thermal/pending";
      fullPath: "/thermal/pending/";
      preLoaderRoute: typeof AppThermalPendingIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/warehouse/$stage/lot-biography": {
      id: "/_app/warehouse/$stage/lot-biography";
      path: "/warehouse/$stage/lot-biography";
      fullPath: "/warehouse/$stage/lot-biography";
      preLoaderRoute: typeof AppWarehouseStageLotBiographyRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/warehouse/lot-biography/": {
      id: "/_app/warehouse/lot-biography/";
      path: "/warehouse/lot-biography";
      fullPath: "/warehouse/lot-biography/";
      preLoaderRoute: typeof AppWarehouseLotBiographyIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/warehouse/lot-biography/$lotId": {
      id: "/_app/warehouse/lot-biography/$lotId";
      path: "/warehouse/lot-biography/$lotId";
      fullPath: "/warehouse/lot-biography/$lotId";
      preLoaderRoute: typeof AppWarehouseLotBiographyLotIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/arrivals/$form/$id_/details": {
      id: "/_app/arrivals/$form/$id_/details";
      path: "/arrivals/$form/$id/details";
      fullPath: "/arrivals/$form/$id/details";
      preLoaderRoute: typeof AppArrivalsFormIdDetailsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/arrivals/trading/$id_/details": {
      id: "/_app/arrivals/trading/$id_/details";
      path: "/arrivals/trading/$id/details";
      fullPath: "/arrivals/trading/$id/details";
      preLoaderRoute: typeof AppArrivalsTradingIdDetailsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/dispatch/sales/$kind/": {
      id: "/_app/dispatch/sales/$kind/";
      path: "/dispatch/sales/$kind";
      fullPath: "/dispatch/sales/$kind/";
      preLoaderRoute: typeof AppDispatchSalesKindIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/dispatch/sales/$kind/$id": {
      id: "/_app/dispatch/sales/$kind/$id";
      path: "/dispatch/sales/$kind/$id";
      fullPath: "/dispatch/sales/$kind/$id";
      preLoaderRoute: typeof AppDispatchSalesKindIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/dispatch/sales/$kind/new": {
      id: "/_app/dispatch/sales/$kind/new";
      path: "/dispatch/sales/$kind/new";
      fullPath: "/dispatch/sales/$kind/new";
      preLoaderRoute: typeof AppDispatchSalesKindNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/processing/blending/$id_/details": {
      id: "/_app/processing/blending/$id_/details";
      path: "/processing/blending/$id/details";
      fullPath: "/processing/blending/$id/details";
      preLoaderRoute: typeof AppProcessingBlendingIdDetailsRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/final-grade/": {
      id: "/_app/quality/got/final-grade/";
      path: "/quality/got/final-grade";
      fullPath: "/quality/got/final-grade/";
      preLoaderRoute: typeof AppQualityGotFinalGradeIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/final-grade/$id": {
      id: "/_app/quality/got/final-grade/$id";
      path: "/quality/got/final-grade/$id";
      fullPath: "/quality/got/final-grade/$id";
      preLoaderRoute: typeof AppQualityGotFinalGradeIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/handover/": {
      id: "/_app/quality/got/handover/";
      path: "/quality/got/handover";
      fullPath: "/quality/got/handover/";
      preLoaderRoute: typeof AppQualityGotHandoverIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/handover/receive": {
      id: "/_app/quality/got/handover/receive";
      path: "/quality/got/handover/receive";
      fullPath: "/quality/got/handover/receive";
      preLoaderRoute: typeof AppQualityGotHandoverReceiveRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/handover/report": {
      id: "/_app/quality/got/handover/report";
      path: "/quality/got/handover/report";
      fullPath: "/quality/got/handover/report";
      preLoaderRoute: typeof AppQualityGotHandoverReportRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/reports/": {
      id: "/_app/quality/got/reports/";
      path: "/quality/got/reports";
      fullPath: "/quality/got/reports/";
      preLoaderRoute: typeof AppQualityGotReportsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/reports/$key": {
      id: "/_app/quality/got/reports/$key";
      path: "/quality/got/reports/$key";
      fullPath: "/quality/got/reports/$key";
      preLoaderRoute: typeof AppQualityGotReportsKeyRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/result-update/": {
      id: "/_app/quality/got/result-update/";
      path: "/quality/got/result-update";
      fullPath: "/quality/got/result-update/";
      preLoaderRoute: typeof AppQualityGotResultUpdateIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/review/": {
      id: "/_app/quality/got/review/";
      path: "/quality/got/review";
      fullPath: "/quality/got/review/";
      preLoaderRoute: typeof AppQualityGotReviewIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/review/$sampleId": {
      id: "/_app/quality/got/review/$sampleId";
      path: "/quality/got/review/$sampleId";
      fullPath: "/quality/got/review/$sampleId";
      preLoaderRoute: typeof AppQualityGotReviewSampleIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/releases/$kind/": {
      id: "/_app/quality/releases/$kind/";
      path: "/quality/releases/$kind";
      fullPath: "/quality/releases/$kind/";
      preLoaderRoute: typeof AppQualityReleasesKindIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/releases/$kind/$releaseId": {
      id: "/_app/quality/releases/$kind/$releaseId";
      path: "/quality/releases/$kind/$releaseId";
      fullPath: "/quality/releases/$kind/$releaseId";
      preLoaderRoute: typeof AppQualityReleasesKindReleaseIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/releases/$kind/new": {
      id: "/_app/quality/releases/$kind/new";
      path: "/quality/releases/$kind/new";
      fullPath: "/quality/releases/$kind/new";
      preLoaderRoute: typeof AppQualityReleasesKindNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/warehouse/$stage/batch/": {
      id: "/_app/warehouse/$stage/batch/";
      path: "/warehouse/$stage/batch";
      fullPath: "/warehouse/$stage/batch/";
      preLoaderRoute: typeof AppWarehouseStageBatchIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/warehouse/$stage/batch/new": {
      id: "/_app/warehouse/$stage/batch/new";
      path: "/warehouse/$stage/batch/new";
      fullPath: "/warehouse/$stage/batch/new";
      preLoaderRoute: typeof AppWarehouseStageBatchNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/warehouse/$stage/release/": {
      id: "/_app/warehouse/$stage/release/";
      path: "/warehouse/$stage/release";
      fullPath: "/warehouse/$stage/release/";
      preLoaderRoute: typeof AppWarehouseStageReleaseIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/warehouse/$stage/release/new": {
      id: "/_app/warehouse/$stage/release/new";
      path: "/warehouse/$stage/release/new";
      fullPath: "/warehouse/$stage/release/new";
      preLoaderRoute: typeof AppWarehouseStageReleaseNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/warehouse/$stage/reports/": {
      id: "/_app/warehouse/$stage/reports/";
      path: "/warehouse/$stage/reports";
      fullPath: "/warehouse/$stage/reports/";
      preLoaderRoute: typeof AppWarehouseStageReportsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/warehouse/$stage/reports/$key": {
      id: "/_app/warehouse/$stage/reports/$key";
      path: "/warehouse/$stage/reports/$key";
      fullPath: "/warehouse/$stage/reports/$key";
      preLoaderRoute: typeof AppWarehouseStageReportsKeyRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/warehouse/$stage/seed-status/": {
      id: "/_app/warehouse/$stage/seed-status/";
      path: "/warehouse/$stage/seed-status";
      fullPath: "/warehouse/$stage/seed-status/";
      preLoaderRoute: typeof AppWarehouseStageSeedStatusIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/warehouse/$stage/seed-status/update": {
      id: "/_app/warehouse/$stage/seed-status/update";
      path: "/warehouse/$stage/seed-status/update";
      fullPath: "/warehouse/$stage/seed-status/update";
      preLoaderRoute: typeof AppWarehouseStageSeedStatusUpdateRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/warehouse/$stage/sloc/": {
      id: "/_app/warehouse/$stage/sloc/";
      path: "/warehouse/$stage/sloc";
      fullPath: "/warehouse/$stage/sloc/";
      preLoaderRoute: typeof AppWarehouseStageSlocIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/warehouse/$stage/sloc/new": {
      id: "/_app/warehouse/$stage/sloc/new";
      path: "/warehouse/$stage/sloc/new";
      fullPath: "/warehouse/$stage/sloc/new";
      preLoaderRoute: typeof AppWarehouseStageSlocNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/print/$kind/$dispatchId": {
      id: "/_app/quality/got/print/$kind/$dispatchId";
      path: "/quality/got/print/$kind/$dispatchId";
      fullPath: "/quality/got/print/$kind/$dispatchId";
      preLoaderRoute: typeof AppQualityGotPrintKindDispatchIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/result-update/$sampleId/": {
      id: "/_app/quality/got/result-update/$sampleId/";
      path: "/quality/got/result-update/$sampleId";
      fullPath: "/quality/got/result-update/$sampleId/";
      preLoaderRoute: typeof AppQualityGotResultUpdateSampleIdIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    "/_app/quality/got/result-update/$sampleId/view": {
      id: "/_app/quality/got/result-update/$sampleId/view";
      path: "/quality/got/result-update/$sampleId/view";
      fullPath: "/quality/got/result-update/$sampleId/view";
      preLoaderRoute: typeof AppQualityGotResultUpdateSampleIdViewRouteImport;
      parentRoute: typeof AppRoute;
    };
  }
}

interface AppRouteChildren {
  AppAbbreviationsRoute: typeof AppAbbreviationsRoute;
  AppDashboardRoute: typeof AppDashboardRoute;
  AppHomeRoute: typeof AppHomeRoute;
  AppQcDashboardRoute: typeof AppQcDashboardRoute;
  AppAccountPasswordRoute: typeof AppAccountPasswordRoute;
  AppAccountProfileRoute: typeof AppAccountProfileRoute;
  AppAdminAuditLogRoute: typeof AppAdminAuditLogRoute;
  AppAdminIntegrationsRoute: typeof AppAdminIntegrationsRoute;
  AppAdminRolesRoute: typeof AppAdminRolesRoute;
  AppAdminUsersRoute: typeof AppAdminUsersRoute;
  AppDevTokensRoute: typeof AppDevTokensRoute;
  AppDispatchBarcodeLookupRoute: typeof AppDispatchBarcodeLookupRoute;
  AppFeedbackIdRoute: typeof AppFeedbackIdRoute;
  AppFeedbackNewRoute: typeof AppFeedbackNewRoute;
  AppInventoryOpeningRoute: typeof AppInventoryOpeningRoute;
  AppInventoryReconciliationRoute: typeof AppInventoryReconciliationRoute;
  AppInventoryReportsRoute: typeof AppInventoryReportsRoute;
  AppInventoryReservationsRoute: typeof AppInventoryReservationsRoute;
  AppMastersKeyRoute: typeof AppMastersKeyRoute;
  AppMastersApiFeedRoute: typeof AppMastersApiFeedRoute;
  AppMastersGotFarmersRoute: typeof AppMastersGotFarmersRoute;
  AppMastersGotLocationsRoute: typeof AppMastersGotLocationsRoute;
  AppMastersGotPpnStandardsRoute: typeof AppMastersGotPpnStandardsRoute;
  AppMastersLocationsRoute: typeof AppMastersLocationsRoute;
  AppMastersMailSettingsRoute: typeof AppMastersMailSettingsRoute;
  AppMastersProductionPersonnelRoute: typeof AppMastersProductionPersonnelRoute;
  AppMastersStorageRestrictionsRoute: typeof AppMastersStorageRestrictionsRoute;
  AppOrdersIdRoute: typeof AppOrdersIdRoute;
  AppOrdersHoldsRoute: typeof AppOrdersHoldsRoute;
  AppOrdersImportRoute: typeof AppOrdersImportRoute;
  AppOrdersNewRoute: typeof AppOrdersNewRoute;
  AppOrdersStatusRoute: typeof AppOrdersStatusRoute;
  AppReportsHighMoistureRoute: typeof AppReportsHighMoistureRoute;
  AppReportsVarietyDecodingRoute: typeof AppReportsVarietyDecodingRoute;
  AppStoresCaptiveRoute: typeof AppStoresCaptiveRoute;
  AppStoresDiscardRoute: typeof AppStoresDiscardRoute;
  AppStoresOpeningRoute: typeof AppStoresOpeningRoute;
  AppStoresReorderRoute: typeof AppStoresReorderRoute;
  AppStoresUtilityRoute: typeof AppStoresUtilityRoute;
  AppWarehouseSlocRoute: typeof AppWarehouseSlocRoute;
  AppArrivalsIndexRoute: typeof AppArrivalsIndexRoute;
  AppDryerIndexRoute: typeof AppDryerIndexRoute;
  AppFeedbackIndexRoute: typeof AppFeedbackIndexRoute;
  AppGateIndexRoute: typeof AppGateIndexRoute;
  AppInventoryIndexRoute: typeof AppInventoryIndexRoute;
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute;
  AppQualityIndexRoute: typeof AppQualityIndexRoute;
  AppReportsIndexRoute: typeof AppReportsIndexRoute;
  AppStoresIndexRoute: typeof AppStoresIndexRoute;
  AppWarehouseIndexRoute: typeof AppWarehouseIndexRoute;
  AppAdminUsersUserIdRoute: typeof AppAdminUsersUserIdRoute;
  AppArrivalsFormIdRoute: typeof AppArrivalsFormIdRoute;
  AppArrivalsFormNewRoute: typeof AppArrivalsFormNewRoute;
  AppArrivalsPpAppearanceSampleIdRoute: typeof AppArrivalsPpAppearanceSampleIdRoute;
  AppArrivalsTradingIdRoute: typeof AppArrivalsTradingIdRoute;
  AppArrivalsTradingNewRoute: typeof AppArrivalsTradingNewRoute;
  AppDispatchStockTransferIdRoute: typeof AppDispatchStockTransferIdRoute;
  AppDispatchStockTransferNewRoute: typeof AppDispatchStockTransferNewRoute;
  AppDryerStageIdRoute: typeof AppDryerStageIdRoute;
  AppGatePassInIdRoute: typeof AppGatePassInIdRoute;
  AppGatePassInNewRoute: typeof AppGatePassInNewRoute;
  AppInventoryLotsLotIdRoute: typeof AppInventoryLotsLotIdRoute;
  AppMastersVendorsIdRoute: typeof AppMastersVendorsIdRoute;
  AppMastersVendorsNewRoute: typeof AppMastersVendorsNewRoute;
  AppPackagingFcPackingSlipIdRoute: typeof AppPackagingFcPackingSlipIdRoute;
  AppPackagingFcPackingSlipNewRoute: typeof AppPackagingFcPackingSlipNewRoute;
  AppPackagingIvtIdRoute: typeof AppPackagingIvtIdRoute;
  AppPackagingIvtNewRoute: typeof AppPackagingIvtNewRoute;
  AppPackagingOflIdRoute: typeof AppPackagingOflIdRoute;
  AppPackagingOflNewRoute: typeof AppPackagingOflNewRoute;
  AppPackagingP2cIdRoute: typeof AppPackagingP2cIdRoute;
  AppPackagingP2cNewRoute: typeof AppPackagingP2cNewRoute;
  AppPackagingPackReprintIdRoute: typeof AppPackagingPackReprintIdRoute;
  AppPackagingPackReprintNewRoute: typeof AppPackagingPackReprintNewRoute;
  AppPackagingPackingSlipIdRoute: typeof AppPackagingPackingSlipIdRoute;
  AppPackagingPackingSlipNewRoute: typeof AppPackagingPackingSlipNewRoute;
  AppPackagingPnpFcSlipIdRoute: typeof AppPackagingPnpFcSlipIdRoute;
  AppPackagingReprintSlipIdRoute: typeof AppPackagingReprintSlipIdRoute;
  AppPackagingReprintSlipNewRoute: typeof AppPackagingReprintSlipNewRoute;
  AppPackagingStoreIndentsIdRoute: typeof AppPackagingStoreIndentsIdRoute;
  AppPackagingStoreIndentsNewRoute: typeof AppPackagingStoreIndentsNewRoute;
  AppPackagingWbPackingSlipIdRoute: typeof AppPackagingWbPackingSlipIdRoute;
  AppPackagingWbPackingSlipNewRoute: typeof AppPackagingWbPackingSlipNewRoute;
  AppProcessingBlendingIdRoute: typeof AppProcessingBlendingIdRoute;
  AppProcessingBlendingNewRoute: typeof AppProcessingBlendingNewRoute;
  AppProcessingColorSortIdRoute: typeof AppProcessingColorSortIdRoute;
  AppProcessingColorSortNewRoute: typeof AppProcessingColorSortNewRoute;
  AppProcessingDryingIdRoute: typeof AppProcessingDryingIdRoute;
  AppProcessingDryingNewRoute: typeof AppProcessingDryingNewRoute;
  AppProcessingPackingSlipIdRoute: typeof AppProcessingPackingSlipIdRoute;
  AppProcessingPackingSlipNewRoute: typeof AppProcessingPackingSlipNewRoute;
  AppProcessingPnpFcSlipIdRoute: typeof AppProcessingPnpFcSlipIdRoute;
  AppProcessingPnpFcSlipNewRoute: typeof AppProcessingPnpFcSlipNewRoute;
  AppProcessingPrimingIdRoute: typeof AppProcessingPrimingIdRoute;
  AppProcessingPrimingNewRoute: typeof AppProcessingPrimingNewRoute;
  AppProcessingReportsKeyRoute: typeof AppProcessingReportsKeyRoute;
  AppProcessingSlipIdRoute: typeof AppProcessingSlipIdRoute;
  AppProcessingSlipNewRoute: typeof AppProcessingSlipNewRoute;
  AppProcessingThermalIdRoute: typeof AppProcessingThermalIdRoute;
  AppProcessingThermalNewRoute: typeof AppProcessingThermalNewRoute;
  AppProcessingTreatmentIdRoute: typeof AppProcessingTreatmentIdRoute;
  AppProcessingTreatmentNewRoute: typeof AppProcessingTreatmentNewRoute;
  AppQualityAllocationSrfIdRoute: typeof AppQualityAllocationSrfIdRoute;
  AppQualityAllocationMonitorRoute: typeof AppQualityAllocationMonitorRoute;
  AppQualityAllocationSamplesRoute: typeof AppQualityAllocationSamplesRoute;
  AppQualityBlendingIdRoute: typeof AppQualityBlendingIdRoute;
  AppQualityGerminationSampleIdRoute: typeof AppQualityGerminationSampleIdRoute;
  AppQualityGotBiographyRoute: typeof AppQualityGotBiographyRoute;
  AppQualityGotDispatchRoute: typeof AppQualityGotDispatchRoute;
  AppQualityGotLowPpnRoute: typeof AppQualityGotLowPpnRoute;
  AppQualityGotPrintSampleRoute: typeof AppQualityGotPrintSampleRoute;
  AppQualityGuardSamplesMoveRoute: typeof AppQualityGuardSamplesMoveRoute;
  AppQualityMoistureSampleIdRoute: typeof AppQualityMoistureSampleIdRoute;
  AppQualityPendingSampleIdRoute: typeof AppQualityPendingSampleIdRoute;
  AppQualityPpSampleIdRoute: typeof AppQualityPpSampleIdRoute;
  AppQualityRequestsRequestIdRoute: typeof AppQualityRequestsRequestIdRoute;
  AppQualityRequestsNewRoute: typeof AppQualityRequestsNewRoute;
  AppReportsArrivalSlugRoute: typeof AppReportsArrivalSlugRoute;
  AppReportsCswKeyRoute: typeof AppReportsCswKeyRoute;
  AppReportsDispatchPeriodicalRoute: typeof AppReportsDispatchPeriodicalRoute;
  AppReportsOrdersDispatchKeyRoute: typeof AppReportsOrdersDispatchKeyRoute;
  AppReportsPackagingSlugRoute: typeof AppReportsPackagingSlugRoute;
  AppReportsQcSlugRoute: typeof AppReportsQcSlugRoute;
  AppReportsRswKeyRoute: typeof AppReportsRswKeyRoute;
  AppReportsStockSlugRoute: typeof AppReportsStockSlugRoute;
  AppReportsWarehouseSlugRoute: typeof AppReportsWarehouseSlugRoute;
  AppStoresArrivalsIdRoute: typeof AppStoresArrivalsIdRoute;
  AppStoresArrivalsNewRoute: typeof AppStoresArrivalsNewRoute;
  AppStoresCorrectionsNewRoute: typeof AppStoresCorrectionsNewRoute;
  AppStoresDocsIdRoute: typeof AppStoresDocsIdRoute;
  AppStoresIndentsIdRoute: typeof AppStoresIndentsIdRoute;
  AppStoresIndentsNewRoute: typeof AppStoresIndentsNewRoute;
  AppStoresIssuesNewRoute: typeof AppStoresIssuesNewRoute;
  AppStoresReportsKeyRoute: typeof AppStoresReportsKeyRoute;
  AppStoresReportsBinCardRoute: typeof AppStoresReportsBinCardRoute;
  AppStoresSlocNewRoute: typeof AppStoresSlocNewRoute;
  AppWarehouseStageLotBiographyRoute: typeof AppWarehouseStageLotBiographyRoute;
  AppWarehouseLotBiographyLotIdRoute: typeof AppWarehouseLotBiographyLotIdRoute;
  AppArrivalsFormIndexRoute: typeof AppArrivalsFormIndexRoute;
  AppArrivalsPpAppearanceIndexRoute: typeof AppArrivalsPpAppearanceIndexRoute;
  AppArrivalsTradingIndexRoute: typeof AppArrivalsTradingIndexRoute;
  AppDispatchStockTransferIndexRoute: typeof AppDispatchStockTransferIndexRoute;
  AppInventoryLotsIndexRoute: typeof AppInventoryLotsIndexRoute;
  AppPackagingFcPackingSlipIndexRoute: typeof AppPackagingFcPackingSlipIndexRoute;
  AppPackagingIvtIndexRoute: typeof AppPackagingIvtIndexRoute;
  AppPackagingOflIndexRoute: typeof AppPackagingOflIndexRoute;
  AppPackagingP2cIndexRoute: typeof AppPackagingP2cIndexRoute;
  AppPackagingPackReprintIndexRoute: typeof AppPackagingPackReprintIndexRoute;
  AppPackagingPackingSlipIndexRoute: typeof AppPackagingPackingSlipIndexRoute;
  AppPackagingPnpFcSlipIndexRoute: typeof AppPackagingPnpFcSlipIndexRoute;
  AppPackagingPnpSlipIndexRoute: typeof AppPackagingPnpSlipIndexRoute;
  AppPackagingReprintSlipIndexRoute: typeof AppPackagingReprintSlipIndexRoute;
  AppPackagingRootStockCountIndexRoute: typeof AppPackagingRootStockCountIndexRoute;
  AppPackagingSathiIndexRoute: typeof AppPackagingSathiIndexRoute;
  AppPackagingStoreIndentsIndexRoute: typeof AppPackagingStoreIndentsIndexRoute;
  AppPackagingUnpackagingIndexRoute: typeof AppPackagingUnpackagingIndexRoute;
  AppPackagingWbPackingSlipIndexRoute: typeof AppPackagingWbPackingSlipIndexRoute;
  AppProcessingBlendingIndexRoute: typeof AppProcessingBlendingIndexRoute;
  AppProcessingColorSortIndexRoute: typeof AppProcessingColorSortIndexRoute;
  AppProcessingDryingIndexRoute: typeof AppProcessingDryingIndexRoute;
  AppProcessingPackingSlipIndexRoute: typeof AppProcessingPackingSlipIndexRoute;
  AppProcessingPnpFcSlipIndexRoute: typeof AppProcessingPnpFcSlipIndexRoute;
  AppProcessingPrimingIndexRoute: typeof AppProcessingPrimingIndexRoute;
  AppProcessingReportsIndexRoute: typeof AppProcessingReportsIndexRoute;
  AppProcessingSlipIndexRoute: typeof AppProcessingSlipIndexRoute;
  AppProcessingThermalIndexRoute: typeof AppProcessingThermalIndexRoute;
  AppProcessingTreatmentIndexRoute: typeof AppProcessingTreatmentIndexRoute;
  AppQualityAllocationIndexRoute: typeof AppQualityAllocationIndexRoute;
  AppQualityBarcodeSearchIndexRoute: typeof AppQualityBarcodeSearchIndexRoute;
  AppQualityBatchFinderIndexRoute: typeof AppQualityBatchFinderIndexRoute;
  AppQualityBlendingIndexRoute: typeof AppQualityBlendingIndexRoute;
  AppQualityDamagedSamplesIndexRoute: typeof AppQualityDamagedSamplesIndexRoute;
  AppQualityDensityIndexRoute: typeof AppQualityDensityIndexRoute;
  AppQualityDovCalculatorIndexRoute: typeof AppQualityDovCalculatorIndexRoute;
  AppQualityGerminationIndexRoute: typeof AppQualityGerminationIndexRoute;
  AppQualityGuardSamplesIndexRoute: typeof AppQualityGuardSamplesIndexRoute;
  AppQualityMoistureIndexRoute: typeof AppQualityMoistureIndexRoute;
  AppQualityPendingIndexRoute: typeof AppQualityPendingIndexRoute;
  AppQualityPpIndexRoute: typeof AppQualityPpIndexRoute;
  AppQualityQcAgeingIndexRoute: typeof AppQualityQcAgeingIndexRoute;
  AppQualityRequestsIndexRoute: typeof AppQualityRequestsIndexRoute;
  AppQualityRtSrfIndexRoute: typeof AppQualityRtSrfIndexRoute;
  AppQualityStandardsIndexRoute: typeof AppQualityStandardsIndexRoute;
  AppReportsArrivalIndexRoute: typeof AppReportsArrivalIndexRoute;
  AppReportsCswIndexRoute: typeof AppReportsCswIndexRoute;
  AppReportsPackagingIndexRoute: typeof AppReportsPackagingIndexRoute;
  AppReportsRswIndexRoute: typeof AppReportsRswIndexRoute;
  AppReportsStockIndexRoute: typeof AppReportsStockIndexRoute;
  AppReportsWarehouseIndexRoute: typeof AppReportsWarehouseIndexRoute;
  AppRndPrimingIndexRoute: typeof AppRndPrimingIndexRoute;
  AppStoresArrivalsIndexRoute: typeof AppStoresArrivalsIndexRoute;
  AppStoresCorrectionsIndexRoute: typeof AppStoresCorrectionsIndexRoute;
  AppStoresCountsIndexRoute: typeof AppStoresCountsIndexRoute;
  AppStoresIndentsIndexRoute: typeof AppStoresIndentsIndexRoute;
  AppStoresIssuesIndexRoute: typeof AppStoresIssuesIndexRoute;
  AppStoresReportsIndexRoute: typeof AppStoresReportsIndexRoute;
  AppStoresSlocIndexRoute: typeof AppStoresSlocIndexRoute;
  AppThermalPendingIndexRoute: typeof AppThermalPendingIndexRoute;
  AppWarehouseLotBiographyIndexRoute: typeof AppWarehouseLotBiographyIndexRoute;
  AppArrivalsFormIdDetailsRoute: typeof AppArrivalsFormIdDetailsRoute;
  AppArrivalsTradingIdDetailsRoute: typeof AppArrivalsTradingIdDetailsRoute;
  AppDispatchSalesKindIdRoute: typeof AppDispatchSalesKindIdRoute;
  AppDispatchSalesKindNewRoute: typeof AppDispatchSalesKindNewRoute;
  AppProcessingBlendingIdDetailsRoute: typeof AppProcessingBlendingIdDetailsRoute;
  AppQualityGotFinalGradeIdRoute: typeof AppQualityGotFinalGradeIdRoute;
  AppQualityGotHandoverReceiveRoute: typeof AppQualityGotHandoverReceiveRoute;
  AppQualityGotHandoverReportRoute: typeof AppQualityGotHandoverReportRoute;
  AppQualityGotReportsKeyRoute: typeof AppQualityGotReportsKeyRoute;
  AppQualityGotReviewSampleIdRoute: typeof AppQualityGotReviewSampleIdRoute;
  AppQualityReleasesKindReleaseIdRoute: typeof AppQualityReleasesKindReleaseIdRoute;
  AppQualityReleasesKindNewRoute: typeof AppQualityReleasesKindNewRoute;
  AppWarehouseStageBatchNewRoute: typeof AppWarehouseStageBatchNewRoute;
  AppWarehouseStageReleaseNewRoute: typeof AppWarehouseStageReleaseNewRoute;
  AppWarehouseStageReportsKeyRoute: typeof AppWarehouseStageReportsKeyRoute;
  AppWarehouseStageSeedStatusUpdateRoute: typeof AppWarehouseStageSeedStatusUpdateRoute;
  AppWarehouseStageSlocNewRoute: typeof AppWarehouseStageSlocNewRoute;
  AppDispatchSalesKindIndexRoute: typeof AppDispatchSalesKindIndexRoute;
  AppQualityGotFinalGradeIndexRoute: typeof AppQualityGotFinalGradeIndexRoute;
  AppQualityGotHandoverIndexRoute: typeof AppQualityGotHandoverIndexRoute;
  AppQualityGotReportsIndexRoute: typeof AppQualityGotReportsIndexRoute;
  AppQualityGotResultUpdateIndexRoute: typeof AppQualityGotResultUpdateIndexRoute;
  AppQualityGotReviewIndexRoute: typeof AppQualityGotReviewIndexRoute;
  AppQualityReleasesKindIndexRoute: typeof AppQualityReleasesKindIndexRoute;
  AppWarehouseStageBatchIndexRoute: typeof AppWarehouseStageBatchIndexRoute;
  AppWarehouseStageReleaseIndexRoute: typeof AppWarehouseStageReleaseIndexRoute;
  AppWarehouseStageReportsIndexRoute: typeof AppWarehouseStageReportsIndexRoute;
  AppWarehouseStageSeedStatusIndexRoute: typeof AppWarehouseStageSeedStatusIndexRoute;
  AppWarehouseStageSlocIndexRoute: typeof AppWarehouseStageSlocIndexRoute;
  AppQualityGotPrintKindDispatchIdRoute: typeof AppQualityGotPrintKindDispatchIdRoute;
  AppQualityGotResultUpdateSampleIdViewRoute: typeof AppQualityGotResultUpdateSampleIdViewRoute;
  AppQualityGotResultUpdateSampleIdIndexRoute: typeof AppQualityGotResultUpdateSampleIdIndexRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppAbbreviationsRoute: AppAbbreviationsRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppHomeRoute: AppHomeRoute,
  AppQcDashboardRoute: AppQcDashboardRoute,
  AppAccountPasswordRoute: AppAccountPasswordRoute,
  AppAccountProfileRoute: AppAccountProfileRoute,
  AppAdminAuditLogRoute: AppAdminAuditLogRoute,
  AppAdminIntegrationsRoute: AppAdminIntegrationsRoute,
  AppAdminRolesRoute: AppAdminRolesRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppDevTokensRoute: AppDevTokensRoute,
  AppDispatchBarcodeLookupRoute: AppDispatchBarcodeLookupRoute,
  AppFeedbackIdRoute: AppFeedbackIdRoute,
  AppFeedbackNewRoute: AppFeedbackNewRoute,
  AppInventoryOpeningRoute: AppInventoryOpeningRoute,
  AppInventoryReconciliationRoute: AppInventoryReconciliationRoute,
  AppInventoryReportsRoute: AppInventoryReportsRoute,
  AppInventoryReservationsRoute: AppInventoryReservationsRoute,
  AppMastersKeyRoute: AppMastersKeyRoute,
  AppMastersApiFeedRoute: AppMastersApiFeedRoute,
  AppMastersGotFarmersRoute: AppMastersGotFarmersRoute,
  AppMastersGotLocationsRoute: AppMastersGotLocationsRoute,
  AppMastersGotPpnStandardsRoute: AppMastersGotPpnStandardsRoute,
  AppMastersLocationsRoute: AppMastersLocationsRoute,
  AppMastersMailSettingsRoute: AppMastersMailSettingsRoute,
  AppMastersProductionPersonnelRoute: AppMastersProductionPersonnelRoute,
  AppMastersStorageRestrictionsRoute: AppMastersStorageRestrictionsRoute,
  AppOrdersIdRoute: AppOrdersIdRoute,
  AppOrdersHoldsRoute: AppOrdersHoldsRoute,
  AppOrdersImportRoute: AppOrdersImportRoute,
  AppOrdersNewRoute: AppOrdersNewRoute,
  AppOrdersStatusRoute: AppOrdersStatusRoute,
  AppReportsHighMoistureRoute: AppReportsHighMoistureRoute,
  AppReportsVarietyDecodingRoute: AppReportsVarietyDecodingRoute,
  AppStoresCaptiveRoute: AppStoresCaptiveRoute,
  AppStoresDiscardRoute: AppStoresDiscardRoute,
  AppStoresOpeningRoute: AppStoresOpeningRoute,
  AppStoresReorderRoute: AppStoresReorderRoute,
  AppStoresUtilityRoute: AppStoresUtilityRoute,
  AppWarehouseSlocRoute: AppWarehouseSlocRoute,
  AppArrivalsIndexRoute: AppArrivalsIndexRoute,
  AppDryerIndexRoute: AppDryerIndexRoute,
  AppFeedbackIndexRoute: AppFeedbackIndexRoute,
  AppGateIndexRoute: AppGateIndexRoute,
  AppInventoryIndexRoute: AppInventoryIndexRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
  AppQualityIndexRoute: AppQualityIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppStoresIndexRoute: AppStoresIndexRoute,
  AppWarehouseIndexRoute: AppWarehouseIndexRoute,
  AppAdminUsersUserIdRoute: AppAdminUsersUserIdRoute,
  AppArrivalsFormIdRoute: AppArrivalsFormIdRoute,
  AppArrivalsFormNewRoute: AppArrivalsFormNewRoute,
  AppArrivalsPpAppearanceSampleIdRoute: AppArrivalsPpAppearanceSampleIdRoute,
  AppArrivalsTradingIdRoute: AppArrivalsTradingIdRoute,
  AppArrivalsTradingNewRoute: AppArrivalsTradingNewRoute,
  AppDispatchStockTransferIdRoute: AppDispatchStockTransferIdRoute,
  AppDispatchStockTransferNewRoute: AppDispatchStockTransferNewRoute,
  AppDryerStageIdRoute: AppDryerStageIdRoute,
  AppGatePassInIdRoute: AppGatePassInIdRoute,
  AppGatePassInNewRoute: AppGatePassInNewRoute,
  AppInventoryLotsLotIdRoute: AppInventoryLotsLotIdRoute,
  AppMastersVendorsIdRoute: AppMastersVendorsIdRoute,
  AppMastersVendorsNewRoute: AppMastersVendorsNewRoute,
  AppPackagingFcPackingSlipIdRoute: AppPackagingFcPackingSlipIdRoute,
  AppPackagingFcPackingSlipNewRoute: AppPackagingFcPackingSlipNewRoute,
  AppPackagingIvtIdRoute: AppPackagingIvtIdRoute,
  AppPackagingIvtNewRoute: AppPackagingIvtNewRoute,
  AppPackagingOflIdRoute: AppPackagingOflIdRoute,
  AppPackagingOflNewRoute: AppPackagingOflNewRoute,
  AppPackagingP2cIdRoute: AppPackagingP2cIdRoute,
  AppPackagingP2cNewRoute: AppPackagingP2cNewRoute,
  AppPackagingPackReprintIdRoute: AppPackagingPackReprintIdRoute,
  AppPackagingPackReprintNewRoute: AppPackagingPackReprintNewRoute,
  AppPackagingPackingSlipIdRoute: AppPackagingPackingSlipIdRoute,
  AppPackagingPackingSlipNewRoute: AppPackagingPackingSlipNewRoute,
  AppPackagingPnpFcSlipIdRoute: AppPackagingPnpFcSlipIdRoute,
  AppPackagingReprintSlipIdRoute: AppPackagingReprintSlipIdRoute,
  AppPackagingReprintSlipNewRoute: AppPackagingReprintSlipNewRoute,
  AppPackagingStoreIndentsIdRoute: AppPackagingStoreIndentsIdRoute,
  AppPackagingStoreIndentsNewRoute: AppPackagingStoreIndentsNewRoute,
  AppPackagingWbPackingSlipIdRoute: AppPackagingWbPackingSlipIdRoute,
  AppPackagingWbPackingSlipNewRoute: AppPackagingWbPackingSlipNewRoute,
  AppProcessingBlendingIdRoute: AppProcessingBlendingIdRoute,
  AppProcessingBlendingNewRoute: AppProcessingBlendingNewRoute,
  AppProcessingColorSortIdRoute: AppProcessingColorSortIdRoute,
  AppProcessingColorSortNewRoute: AppProcessingColorSortNewRoute,
  AppProcessingDryingIdRoute: AppProcessingDryingIdRoute,
  AppProcessingDryingNewRoute: AppProcessingDryingNewRoute,
  AppProcessingPackingSlipIdRoute: AppProcessingPackingSlipIdRoute,
  AppProcessingPackingSlipNewRoute: AppProcessingPackingSlipNewRoute,
  AppProcessingPnpFcSlipIdRoute: AppProcessingPnpFcSlipIdRoute,
  AppProcessingPnpFcSlipNewRoute: AppProcessingPnpFcSlipNewRoute,
  AppProcessingPrimingIdRoute: AppProcessingPrimingIdRoute,
  AppProcessingPrimingNewRoute: AppProcessingPrimingNewRoute,
  AppProcessingReportsKeyRoute: AppProcessingReportsKeyRoute,
  AppProcessingSlipIdRoute: AppProcessingSlipIdRoute,
  AppProcessingSlipNewRoute: AppProcessingSlipNewRoute,
  AppProcessingThermalIdRoute: AppProcessingThermalIdRoute,
  AppProcessingThermalNewRoute: AppProcessingThermalNewRoute,
  AppProcessingTreatmentIdRoute: AppProcessingTreatmentIdRoute,
  AppProcessingTreatmentNewRoute: AppProcessingTreatmentNewRoute,
  AppQualityAllocationSrfIdRoute: AppQualityAllocationSrfIdRoute,
  AppQualityAllocationMonitorRoute: AppQualityAllocationMonitorRoute,
  AppQualityAllocationSamplesRoute: AppQualityAllocationSamplesRoute,
  AppQualityBlendingIdRoute: AppQualityBlendingIdRoute,
  AppQualityGerminationSampleIdRoute: AppQualityGerminationSampleIdRoute,
  AppQualityGotBiographyRoute: AppQualityGotBiographyRoute,
  AppQualityGotDispatchRoute: AppQualityGotDispatchRoute,
  AppQualityGotLowPpnRoute: AppQualityGotLowPpnRoute,
  AppQualityGotPrintSampleRoute: AppQualityGotPrintSampleRoute,
  AppQualityGuardSamplesMoveRoute: AppQualityGuardSamplesMoveRoute,
  AppQualityMoistureSampleIdRoute: AppQualityMoistureSampleIdRoute,
  AppQualityPendingSampleIdRoute: AppQualityPendingSampleIdRoute,
  AppQualityPpSampleIdRoute: AppQualityPpSampleIdRoute,
  AppQualityRequestsRequestIdRoute: AppQualityRequestsRequestIdRoute,
  AppQualityRequestsNewRoute: AppQualityRequestsNewRoute,
  AppReportsArrivalSlugRoute: AppReportsArrivalSlugRoute,
  AppReportsCswKeyRoute: AppReportsCswKeyRoute,
  AppReportsDispatchPeriodicalRoute: AppReportsDispatchPeriodicalRoute,
  AppReportsOrdersDispatchKeyRoute: AppReportsOrdersDispatchKeyRoute,
  AppReportsPackagingSlugRoute: AppReportsPackagingSlugRoute,
  AppReportsQcSlugRoute: AppReportsQcSlugRoute,
  AppReportsRswKeyRoute: AppReportsRswKeyRoute,
  AppReportsStockSlugRoute: AppReportsStockSlugRoute,
  AppReportsWarehouseSlugRoute: AppReportsWarehouseSlugRoute,
  AppStoresArrivalsIdRoute: AppStoresArrivalsIdRoute,
  AppStoresArrivalsNewRoute: AppStoresArrivalsNewRoute,
  AppStoresCorrectionsNewRoute: AppStoresCorrectionsNewRoute,
  AppStoresDocsIdRoute: AppStoresDocsIdRoute,
  AppStoresIndentsIdRoute: AppStoresIndentsIdRoute,
  AppStoresIndentsNewRoute: AppStoresIndentsNewRoute,
  AppStoresIssuesNewRoute: AppStoresIssuesNewRoute,
  AppStoresReportsKeyRoute: AppStoresReportsKeyRoute,
  AppStoresReportsBinCardRoute: AppStoresReportsBinCardRoute,
  AppStoresSlocNewRoute: AppStoresSlocNewRoute,
  AppWarehouseStageLotBiographyRoute: AppWarehouseStageLotBiographyRoute,
  AppWarehouseLotBiographyLotIdRoute: AppWarehouseLotBiographyLotIdRoute,
  AppArrivalsFormIndexRoute: AppArrivalsFormIndexRoute,
  AppArrivalsPpAppearanceIndexRoute: AppArrivalsPpAppearanceIndexRoute,
  AppArrivalsTradingIndexRoute: AppArrivalsTradingIndexRoute,
  AppDispatchStockTransferIndexRoute: AppDispatchStockTransferIndexRoute,
  AppInventoryLotsIndexRoute: AppInventoryLotsIndexRoute,
  AppPackagingFcPackingSlipIndexRoute: AppPackagingFcPackingSlipIndexRoute,
  AppPackagingIvtIndexRoute: AppPackagingIvtIndexRoute,
  AppPackagingOflIndexRoute: AppPackagingOflIndexRoute,
  AppPackagingP2cIndexRoute: AppPackagingP2cIndexRoute,
  AppPackagingPackReprintIndexRoute: AppPackagingPackReprintIndexRoute,
  AppPackagingPackingSlipIndexRoute: AppPackagingPackingSlipIndexRoute,
  AppPackagingPnpFcSlipIndexRoute: AppPackagingPnpFcSlipIndexRoute,
  AppPackagingPnpSlipIndexRoute: AppPackagingPnpSlipIndexRoute,
  AppPackagingReprintSlipIndexRoute: AppPackagingReprintSlipIndexRoute,
  AppPackagingRootStockCountIndexRoute: AppPackagingRootStockCountIndexRoute,
  AppPackagingSathiIndexRoute: AppPackagingSathiIndexRoute,
  AppPackagingStoreIndentsIndexRoute: AppPackagingStoreIndentsIndexRoute,
  AppPackagingUnpackagingIndexRoute: AppPackagingUnpackagingIndexRoute,
  AppPackagingWbPackingSlipIndexRoute: AppPackagingWbPackingSlipIndexRoute,
  AppProcessingBlendingIndexRoute: AppProcessingBlendingIndexRoute,
  AppProcessingColorSortIndexRoute: AppProcessingColorSortIndexRoute,
  AppProcessingDryingIndexRoute: AppProcessingDryingIndexRoute,
  AppProcessingPackingSlipIndexRoute: AppProcessingPackingSlipIndexRoute,
  AppProcessingPnpFcSlipIndexRoute: AppProcessingPnpFcSlipIndexRoute,
  AppProcessingPrimingIndexRoute: AppProcessingPrimingIndexRoute,
  AppProcessingReportsIndexRoute: AppProcessingReportsIndexRoute,
  AppProcessingSlipIndexRoute: AppProcessingSlipIndexRoute,
  AppProcessingThermalIndexRoute: AppProcessingThermalIndexRoute,
  AppProcessingTreatmentIndexRoute: AppProcessingTreatmentIndexRoute,
  AppQualityAllocationIndexRoute: AppQualityAllocationIndexRoute,
  AppQualityBarcodeSearchIndexRoute: AppQualityBarcodeSearchIndexRoute,
  AppQualityBatchFinderIndexRoute: AppQualityBatchFinderIndexRoute,
  AppQualityBlendingIndexRoute: AppQualityBlendingIndexRoute,
  AppQualityDamagedSamplesIndexRoute: AppQualityDamagedSamplesIndexRoute,
  AppQualityDensityIndexRoute: AppQualityDensityIndexRoute,
  AppQualityDovCalculatorIndexRoute: AppQualityDovCalculatorIndexRoute,
  AppQualityGerminationIndexRoute: AppQualityGerminationIndexRoute,
  AppQualityGuardSamplesIndexRoute: AppQualityGuardSamplesIndexRoute,
  AppQualityMoistureIndexRoute: AppQualityMoistureIndexRoute,
  AppQualityPendingIndexRoute: AppQualityPendingIndexRoute,
  AppQualityPpIndexRoute: AppQualityPpIndexRoute,
  AppQualityQcAgeingIndexRoute: AppQualityQcAgeingIndexRoute,
  AppQualityRequestsIndexRoute: AppQualityRequestsIndexRoute,
  AppQualityRtSrfIndexRoute: AppQualityRtSrfIndexRoute,
  AppQualityStandardsIndexRoute: AppQualityStandardsIndexRoute,
  AppReportsArrivalIndexRoute: AppReportsArrivalIndexRoute,
  AppReportsCswIndexRoute: AppReportsCswIndexRoute,
  AppReportsPackagingIndexRoute: AppReportsPackagingIndexRoute,
  AppReportsRswIndexRoute: AppReportsRswIndexRoute,
  AppReportsStockIndexRoute: AppReportsStockIndexRoute,
  AppReportsWarehouseIndexRoute: AppReportsWarehouseIndexRoute,
  AppRndPrimingIndexRoute: AppRndPrimingIndexRoute,
  AppStoresArrivalsIndexRoute: AppStoresArrivalsIndexRoute,
  AppStoresCorrectionsIndexRoute: AppStoresCorrectionsIndexRoute,
  AppStoresCountsIndexRoute: AppStoresCountsIndexRoute,
  AppStoresIndentsIndexRoute: AppStoresIndentsIndexRoute,
  AppStoresIssuesIndexRoute: AppStoresIssuesIndexRoute,
  AppStoresReportsIndexRoute: AppStoresReportsIndexRoute,
  AppStoresSlocIndexRoute: AppStoresSlocIndexRoute,
  AppThermalPendingIndexRoute: AppThermalPendingIndexRoute,
  AppWarehouseLotBiographyIndexRoute: AppWarehouseLotBiographyIndexRoute,
  AppArrivalsFormIdDetailsRoute: AppArrivalsFormIdDetailsRoute,
  AppArrivalsTradingIdDetailsRoute: AppArrivalsTradingIdDetailsRoute,
  AppDispatchSalesKindIdRoute: AppDispatchSalesKindIdRoute,
  AppDispatchSalesKindNewRoute: AppDispatchSalesKindNewRoute,
  AppProcessingBlendingIdDetailsRoute: AppProcessingBlendingIdDetailsRoute,
  AppQualityGotFinalGradeIdRoute: AppQualityGotFinalGradeIdRoute,
  AppQualityGotHandoverReceiveRoute: AppQualityGotHandoverReceiveRoute,
  AppQualityGotHandoverReportRoute: AppQualityGotHandoverReportRoute,
  AppQualityGotReportsKeyRoute: AppQualityGotReportsKeyRoute,
  AppQualityGotReviewSampleIdRoute: AppQualityGotReviewSampleIdRoute,
  AppQualityReleasesKindReleaseIdRoute: AppQualityReleasesKindReleaseIdRoute,
  AppQualityReleasesKindNewRoute: AppQualityReleasesKindNewRoute,
  AppWarehouseStageBatchNewRoute: AppWarehouseStageBatchNewRoute,
  AppWarehouseStageReleaseNewRoute: AppWarehouseStageReleaseNewRoute,
  AppWarehouseStageReportsKeyRoute: AppWarehouseStageReportsKeyRoute,
  AppWarehouseStageSeedStatusUpdateRoute:
    AppWarehouseStageSeedStatusUpdateRoute,
  AppWarehouseStageSlocNewRoute: AppWarehouseStageSlocNewRoute,
  AppDispatchSalesKindIndexRoute: AppDispatchSalesKindIndexRoute,
  AppQualityGotFinalGradeIndexRoute: AppQualityGotFinalGradeIndexRoute,
  AppQualityGotHandoverIndexRoute: AppQualityGotHandoverIndexRoute,
  AppQualityGotReportsIndexRoute: AppQualityGotReportsIndexRoute,
  AppQualityGotResultUpdateIndexRoute: AppQualityGotResultUpdateIndexRoute,
  AppQualityGotReviewIndexRoute: AppQualityGotReviewIndexRoute,
  AppQualityReleasesKindIndexRoute: AppQualityReleasesKindIndexRoute,
  AppWarehouseStageBatchIndexRoute: AppWarehouseStageBatchIndexRoute,
  AppWarehouseStageReleaseIndexRoute: AppWarehouseStageReleaseIndexRoute,
  AppWarehouseStageReportsIndexRoute: AppWarehouseStageReportsIndexRoute,
  AppWarehouseStageSeedStatusIndexRoute: AppWarehouseStageSeedStatusIndexRoute,
  AppWarehouseStageSlocIndexRoute: AppWarehouseStageSlocIndexRoute,
  AppQualityGotPrintKindDispatchIdRoute: AppQualityGotPrintKindDispatchIdRoute,
  AppQualityGotResultUpdateSampleIdViewRoute:
    AppQualityGotResultUpdateSampleIdViewRoute,
  AppQualityGotResultUpdateSampleIdIndexRoute:
    AppQualityGotResultUpdateSampleIdIndexRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  HandheldRoute: HandheldRoute,
  LoginRoute: LoginRoute,
  InviteTokenRoute: InviteTokenRoute,
  KioskPackingRoute: KioskPackingRoute,
  AppIndexRoute: AppIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
